import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { useMyQuery } from './src/data-access/graphql-client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Access = {
  accessReasons: Maybe<Array<Scalars['String']['output']>>;
  emailDomain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Maybe<Array<Scalars['String']['output']>>;
};

export type AccessCompact = {
  accessReasons: Maybe<Array<AccessReason>>;
  emailDomain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AccessReason = {
  accessBy: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
};

export type AccessThrough = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type AccessThroughName = {
  name: Scalars['String']['output'];
};

export enum AccessType {
  All = 'all',
  AppsWithAccess = 'appsWithAccess',
  ExternalUsers = 'externalUsers',
  InternalUsers = 'internalUsers',
  SharedWithAnyone = 'sharedWithAnyone',
  SharedWithOrganization = 'sharedWithOrganization'
}

export type Account = {
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isAdminMode: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  roles: Array<Maybe<Scalars['String']['output']>>;
  viewingAs: Maybe<TenantUser>;
};

export type AccountOrInvite = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isInvite: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AccountPagination = {
  accounts: Scalars['Int']['output'];
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<AccountOrInvite>;
};

export type AccountUser = {
  email: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tenantEmailDomain: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

export type Action = {
  args: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ActionInput = {
  args: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ActiveSensitiveData = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ActivityTimelineEntry = {
  action: Maybe<Scalars['String']['output']>;
  activityType: Scalars['String']['output'];
  automationType: Maybe<Scalars['String']['output']>;
  completedAt: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  newState: Maybe<Scalars['String']['output']>;
  parameters: Maybe<Scalars['String']['output']>;
  previousState: Maybe<Scalars['String']['output']>;
  result: Maybe<Scalars['String']['output']>;
  sourcePolicyName: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  userEmail: Maybe<Scalars['String']['output']>;
  userName: Maybe<Scalars['String']['output']>;
};

export type ActivityTimelineResponse = {
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<ActivityTimelineEntry>;
};

export type AdminConsentData = {
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type AiAppsFilesCounts = {
  aiFiles: Maybe<Scalars['Int']['output']>;
  aiFolders: Maybe<Scalars['Int']['output']>;
  all: Maybe<Scalars['Int']['output']>;
  filesCritical: Maybe<Scalars['Int']['output']>;
  filesElevated: Maybe<Scalars['Int']['output']>;
  filesHigh: Maybe<Scalars['Int']['output']>;
  filesLow: Maybe<Scalars['Int']['output']>;
  filesModerate: Maybe<Scalars['Int']['output']>;
  filesNone: Maybe<Scalars['Int']['output']>;
  foldersCritical: Maybe<Scalars['Int']['output']>;
  foldersElevated: Maybe<Scalars['Int']['output']>;
  foldersHigh: Maybe<Scalars['Int']['output']>;
  foldersLow: Maybe<Scalars['Int']['output']>;
  foldersModerate: Maybe<Scalars['Int']['output']>;
  foldersNone: Maybe<Scalars['Int']['output']>;
};

export type Alert = {
  accessFrom: Maybe<Scalars['String']['output']>;
  accessThrough: Maybe<Array<Scalars['String']['output']>>;
  accessibleFiles: Maybe<Scalars['Int']['output']>;
  accessibleSites: Maybe<Scalars['Int']['output']>;
  activity: Maybe<Scalars['String']['output']>;
  addInApplication: Maybe<Scalars['Boolean']['output']>;
  approvalStatus: Maybe<Scalars['String']['output']>;
  assignedUser: Maybe<Scalars['String']['output']>;
  avatar: Maybe<Scalars['String']['output']>;
  azureId: Maybe<Scalars['ID']['output']>;
  azureRegisteredAt: Maybe<Scalars['String']['output']>;
  canAdminConsent: Maybe<Scalars['Boolean']['output']>;
  channelType: Maybe<Scalars['String']['output']>;
  connected: Maybe<Scalars['String']['output']>;
  connectedApps: Maybe<Scalars['Int']['output']>;
  containedGroups: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  createdFrom: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  detectedAt: Maybe<Scalars['String']['output']>;
  directUsersWithAccess: Maybe<Scalars['Int']['output']>;
  drives: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['String']['output']>;
  emailDomain: Maybe<Scalars['String']['output']>;
  emailsAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseApplication: Maybe<Scalars['Boolean']['output']>;
  externalUsers: Maybe<Scalars['Int']['output']>;
  externalUsersWithAccess: Maybe<Scalars['Int']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  filesAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filesSize: Maybe<Scalars['String']['output']>;
  filesWithSensitiveData: Maybe<Scalars['Int']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  firstAdminUser: Maybe<Scalars['String']['output']>;
  groups: Maybe<Array<Maybe<Group>>>;
  groupsWithAccess: Maybe<Scalars['Int']['output']>;
  hasMfa: Maybe<Scalars['Boolean']['output']>;
  hasSignedIn: Maybe<Scalars['Boolean']['output']>;
  help: Maybe<Scalars['String']['output']>;
  homepage: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactiveUsers: Maybe<Scalars['Int']['output']>;
  indirectUsersWithAccess: Maybe<Scalars['Int']['output']>;
  isAdmin: Maybe<Scalars['Boolean']['output']>;
  isBlocked: Maybe<Scalars['Boolean']['output']>;
  isChannelSite: Maybe<Scalars['Boolean']['output']>;
  isExternal: Maybe<Scalars['Boolean']['output']>;
  isFullyScanned: Maybe<Scalars['Boolean']['output']>;
  isHubSite: Maybe<Scalars['Boolean']['output']>;
  isMemberOfGroups: Maybe<Scalars['Int']['output']>;
  isResolved: Maybe<Scalars['Boolean']['output']>;
  isTeams: Maybe<Scalars['Boolean']['output']>;
  isTeamsSite: Maybe<Scalars['Boolean']['output']>;
  lastActivity: Maybe<Scalars['String']['output']>;
  lastSignIn: Maybe<Scalars['String']['output']>;
  lastUsed: Maybe<Scalars['String']['output']>;
  licenses: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  link: Maybe<Scalars['String']['output']>;
  lists: Maybe<Scalars['Int']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  members: Maybe<Scalars['Int']['output']>;
  modifiedAt: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nestedExternalUsers: Maybe<Scalars['Int']['output']>;
  nestedMembers: Maybe<Scalars['Int']['output']>;
  notebooks: Maybe<Scalars['Int']['output']>;
  organizationName: Maybe<Scalars['String']['output']>;
  owners: Maybe<Scalars['Int']['output']>;
  pages: Maybe<Scalars['Int']['output']>;
  path: Maybe<Scalars['String']['output']>;
  permissions: Maybe<Array<Scalars['String']['output']>>;
  privacy: Maybe<Scalars['String']['output']>;
  publisherName: Maybe<Scalars['String']['output']>;
  registeredApplication: Maybe<Scalars['Boolean']['output']>;
  resolvedAt: Maybe<Scalars['String']['output']>;
  resourceCount: Maybe<Scalars['Int']['output']>;
  resourceName: Maybe<Scalars['String']['output']>;
  resourceType: Maybe<Scalars['String']['output']>;
  roles: Maybe<Array<Scalars['String']['output']>>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivity: Maybe<Scalars['String']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  severity: Maybe<Scalars['String']['output']>;
  signInDisabledAt: Maybe<Scalars['String']['output']>;
  sites: Maybe<Scalars['Int']['output']>;
  snoozedAt: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  subsites: Maybe<Scalars['Int']['output']>;
  teamsChannels: Maybe<Scalars['Int']['output']>;
  teamsChannelsPrivate: Maybe<Scalars['Int']['output']>;
  teamsChannelsShared: Maybe<Scalars['Int']['output']>;
  teamsChannelsStandard: Maybe<Scalars['Int']['output']>;
  totalExternalUsers: Maybe<Scalars['Int']['output']>;
  totalGroupMemberships: Maybe<Scalars['Int']['output']>;
  totalSensitivityScore: Maybe<Scalars['Float']['output']>;
  totalUsers: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  userName: Maybe<Scalars['String']['output']>;
  users: Maybe<Scalars['Int']['output']>;
  usersAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  usersWithAccess: Maybe<Scalars['Int']['output']>;
  webUrl: Maybe<Scalars['String']['output']>;
};

export type AlertFiltersInput = {
  accountEnabled: InputMaybe<Scalars['Boolean']['input']>;
  createdBy: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailDomain: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  exposureLevel: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileType: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupType: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasMfa: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin: InputMaybe<Scalars['Boolean']['input']>;
  isExternal: InputMaybe<Scalars['Boolean']['input']>;
  isHubSite: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalSite: InputMaybe<Scalars['Boolean']['input']>;
  isTeams: InputMaybe<Scalars['Boolean']['input']>;
  isVerified: InputMaybe<Scalars['Boolean']['input']>;
  privacy: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publisher: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sensitivityLevel: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sharedExternally: InputMaybe<Scalars['Boolean']['input']>;
  sharedWithAnyone: InputMaybe<Scalars['Boolean']['input']>;
  siteType: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  size: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AlertPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<Alert>;
};

export type AlertResourceNode = {
  createdAt: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isResolved: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  resolvedAt: Maybe<Scalars['String']['output']>;
  snoozedAt: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type AlertResourcesPagination = {
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<AlertResourceNode>;
};

export type AlertResult = {
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  detectedAt: Maybe<Scalars['String']['output']>;
  exposureLevel: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modifiedAt: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  resolvedAt: Maybe<Scalars['String']['output']>;
  resourceName: Maybe<Scalars['String']['output']>;
  resourceType: Maybe<Scalars['String']['output']>;
  riskLevel: Maybe<Scalars['String']['output']>;
  sensitivityLevel: Maybe<Scalars['String']['output']>;
  severity: Maybe<Scalars['String']['output']>;
  siteName: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
};

export type AlertResultsResponse = {
  hasNextPage: Scalars['Boolean']['output'];
  itemsFound: Scalars['Int']['output'];
  nodes: Array<AlertResult>;
};

export type App = {
  accessFrom: Maybe<Scalars['String']['output']>;
  addInApplication: Maybe<Scalars['Boolean']['output']>;
  approvalStatus: Maybe<Scalars['String']['output']>;
  connected: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  emailsAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseApplication: Maybe<Scalars['Boolean']['output']>;
  externalUsers: Maybe<Scalars['Int']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  filesAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filesWithSensitiveData: Maybe<Scalars['Int']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  firstAdminUser: Maybe<Scalars['String']['output']>;
  groups: Maybe<Scalars['Int']['output']>;
  homepage: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  inactiveUsers: Maybe<Scalars['Int']['output']>;
  lastUsed: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  permissions: Maybe<Scalars['Int']['output']>;
  publisherName: Maybe<Scalars['String']['output']>;
  registeredApplication: Maybe<Scalars['Boolean']['output']>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivity: Maybe<Scalars['String']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  users: Maybe<Scalars['Int']['output']>;
  usersAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  usersWithAccess: Maybe<Scalars['Int']['output']>;
};

export type AppFileData = {
  createdBy: Maybe<Scalars['String']['output']>;
  createdDate: Maybe<Scalars['String']['output']>;
  fileSensitivityLabels: Maybe<Scalars['String']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModified: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sensitivity: Maybe<Scalars['Float']['output']>;
  size: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  webUrl: Maybe<Scalars['String']['output']>;
};

export type AppFilesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<AppFileData>;
};

export type AppFilterCounts = {
  activeUsers: Maybe<Scalars['Int']['output']>;
  addIn: Maybe<Scalars['Int']['output']>;
  all: Maybe<Scalars['Int']['output']>;
  appRegistration: Maybe<Scalars['Int']['output']>;
  applications: Maybe<Scalars['Int']['output']>;
  approved: Maybe<Scalars['Int']['output']>;
  auditLogs: Maybe<Scalars['Int']['output']>;
  chat: Maybe<Scalars['Int']['output']>;
  connected1Day: Maybe<Scalars['Int']['output']>;
  connected1Year: Maybe<Scalars['Int']['output']>;
  connected7Days: Maybe<Scalars['Int']['output']>;
  connected30Days: Maybe<Scalars['Int']['output']>;
  connected90Days: Maybe<Scalars['Int']['output']>;
  directory: Maybe<Scalars['Int']['output']>;
  email: Maybe<Scalars['Int']['output']>;
  enterprise: Maybe<Scalars['Int']['output']>;
  externalUsers: Maybe<Scalars['Int']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  groups: Maybe<Scalars['Int']['output']>;
  inactiveUsers: Maybe<Scalars['Int']['output']>;
  internalUsers: Maybe<Scalars['Int']['output']>;
  lastUsed1Day: Maybe<Scalars['Int']['output']>;
  lastUsed1Year: Maybe<Scalars['Int']['output']>;
  lastUsed7Days: Maybe<Scalars['Int']['output']>;
  lastUsed30Days: Maybe<Scalars['Int']['output']>;
  lastUsed90Days: Maybe<Scalars['Int']['output']>;
  notPermitted: Maybe<Scalars['Int']['output']>;
  sites: Maybe<Scalars['Int']['output']>;
  unverified: Maybe<Scalars['Int']['output']>;
  verified: Maybe<Scalars['Int']['output']>;
  waitingForReview: Maybe<Scalars['Int']['output']>;
};

export type AppGroupData = {
  externalUsers: Maybe<Scalars['Int']['output']>;
  groupSensitivityLabels: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  internalUsers: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  totalUsers: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type AppGroupsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<AppGroupData>;
};

export type AppPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<App>;
};

export type AppPermissionData = {
  apiName: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  isConsentRequired: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type AppPermissionsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<AppPermissionData>;
};

export type AppUsersPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<UserApp>;
};

export type AutomationExecution = {
  automationType: Scalars['String']['output'];
  completedAt: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parameters: Maybe<Scalars['String']['output']>;
  platform: Scalars['String']['output'];
  resources: Array<AutomationResource>;
  result: Maybe<Scalars['String']['output']>;
  status: AutomationStatus;
  tenantId: Scalars['String']['output'];
  userId: Maybe<Scalars['String']['output']>;
};

export type AutomationExecutionConnection = {
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<AutomationExecution>;
};

export type AutomationResource = {
  metadata: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  role: ResourceRole;
};

export enum AutomationStatus {
  Completed = 'completed',
  Failed = 'failed',
  PartialSuccess = 'partial_success',
  Pending = 'pending',
  Running = 'running'
}

export enum BlockedSitesEnum {
  All = 'all',
  BlockedSites = 'blockedSites',
  NoBlockedSites = 'noBlockedSites'
}

export type ChartCategory = {
  category: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ChartLink = {
  source: Scalars['ID']['output'];
  target: Scalars['ID']['output'];
};

export type ChartNode = {
  category: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  symbolSize: Maybe<Scalars['Float']['output']>;
  value: Maybe<Scalars['Float']['output']>;
  x: Maybe<Scalars['Float']['output']>;
  y: Maybe<Scalars['Float']['output']>;
};

export type Condition = {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ConditionFilterInput = {
  field: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  resourceType: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type ConditionInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DateRange = {
  endDate: InputMaybe<Scalars['String']['input']>;
  startDate: InputMaybe<Scalars['String']['input']>;
};

export type DateRangeFilterInput = {
  createdAt: InputMaybe<DateRange>;
  lastActivity: InputMaybe<DateRange>;
  modifiedAt: InputMaybe<DateRange>;
};

export type DateTimeFilter = {
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type DateTimeFilterInput = {
  createdAt: InputMaybe<TimeFilter>;
  lastActivity: InputMaybe<TimeFilter>;
  modifiedAt: InputMaybe<TimeFilter>;
};

export enum DefaultLinkPermission {
  Edit = 'Edit',
  View = 'View'
}

export enum DefaultSharingLinkType {
  AnonymousAccess = 'AnonymousAccess',
  Direct = 'Direct',
  Internal = 'Internal',
  None = 'None'
}

export type DownloadData = {
  base64: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type DrawerFile = {
  accessThrough: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fileSensitivityLabels: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  permissions: Array<PermissionObject>;
  type: Maybe<Scalars['String']['output']>;
};

export type DrawerFilesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<DrawerFile>;
};

export type DrawerLabel = {
  apps: Scalars['Int']['output'];
  color: Maybe<Scalars['String']['output']>;
  contentFormats: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  files: Scalars['Int']['output'];
  groups: Scalars['Int']['output'];
  hasProtection: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAppliable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sensitivity: Maybe<Scalars['Int']['output']>;
  sites: Scalars['Int']['output'];
  tooltip: Maybe<Scalars['String']['output']>;
  users: Scalars['Int']['output'];
};

export type DrawerLabelsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<DrawerLabel>;
};

export type DrawerSensitiveInfo = {
  apps: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  groups: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sites: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type DrawerSensitiveInfoPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<DrawerSensitiveInfo>;
};

export type File = {
  apps: Maybe<Scalars['Int']['output']>;
  azureId: Maybe<Scalars['ID']['output']>;
  createdBy: Maybe<UserAzureObject>;
  createdDate: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  externalUsersWithAccess: Maybe<Scalars['Int']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  folders: Maybe<Scalars['Int']['output']>;
  groupsWithAccess: Maybe<Scalars['Int']['output']>;
  help: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastModified: Maybe<Scalars['String']['output']>;
  lastModifiedBy: Maybe<UserAzureObject>;
  level: Maybe<Scalars['Int']['output']>;
  links: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['String']['output']>;
  path: Array<Path>;
  sensitiveData: Maybe<Scalars['Int']['output']>;
  sensitivity: Maybe<Scalars['Float']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  shareLink: Maybe<Scalars['String']['output']>;
  sharedExternally: Maybe<Scalars['Int']['output']>;
  sharedWithAnyone: Maybe<Scalars['Int']['output']>;
  sharedWithOrganization: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  sourceType: Maybe<Scalars['String']['output']>;
  tenantId: Maybe<Scalars['String']['output']>;
  topFileSensitivity: Maybe<Scalars['Float']['output']>;
  type: Maybe<Scalars['String']['output']>;
  usersWithAccess: Maybe<Scalars['Int']['output']>;
  usersWithEditAccess: Maybe<Scalars['Int']['output']>;
  webUrl: Maybe<Scalars['String']['output']>;
};

export type FileAppsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<App>;
};

export enum FileContainerType {
  All = 'all',
  AllDrives = 'allDrives',
  AllSites = 'allSites',
  Folders = 'folders',
  OneDriveDrives = 'oneDriveDrives',
  PersonalOneDriveSites = 'personalOneDriveSites',
  SharePointDrives = 'sharePointDrives',
  SharePointHubSites = 'sharePointHubSites',
  SharePointSites = 'sharePointSites',
  SharePointSubSites = 'sharePointSubSites',
  SharePointSystemDocumentLibrary = 'sharePointSystemDocumentLibrary',
  SharePointSystemPageLibrary = 'sharePointSystemPageLibrary'
}

export type FileFilterCounts = {
  all: Maybe<Scalars['Int']['output']>;
  allContainers: Maybe<Scalars['Int']['output']>;
  allDrives: Maybe<Scalars['Int']['output']>;
  allFiles: Maybe<Scalars['Int']['output']>;
  allMicrosoft: Maybe<Scalars['Int']['output']>;
  allSites: Maybe<Scalars['Int']['output']>;
  allStandard: Maybe<Scalars['Int']['output']>;
  appsWithAccess: Maybe<Scalars['Int']['output']>;
  archives: Maybe<Scalars['Int']['output']>;
  audio: Maybe<Scalars['Int']['output']>;
  createdLast1Day: Maybe<Scalars['Int']['output']>;
  createdLast1Year: Maybe<Scalars['Int']['output']>;
  createdLast7Days: Maybe<Scalars['Int']['output']>;
  createdLast30Days: Maybe<Scalars['Int']['output']>;
  createdLast90Days: Maybe<Scalars['Int']['output']>;
  externalUsers: Maybe<Scalars['Int']['output']>;
  folders: Maybe<Scalars['Int']['output']>;
  image: Maybe<Scalars['Int']['output']>;
  internalUsers: Maybe<Scalars['Int']['output']>;
  list: Maybe<Scalars['Int']['output']>;
  modifiedLast1Day: Maybe<Scalars['Int']['output']>;
  modifiedLast1Year: Maybe<Scalars['Int']['output']>;
  modifiedLast7Days: Maybe<Scalars['Int']['output']>;
  modifiedLast30Days: Maybe<Scalars['Int']['output']>;
  modifiedLast90Days: Maybe<Scalars['Int']['output']>;
  oneDrive: Maybe<Scalars['Int']['output']>;
  oneDriveDrives: Maybe<Scalars['Int']['output']>;
  onenote: Maybe<Scalars['Int']['output']>;
  other: Maybe<Scalars['Int']['output']>;
  pdf: Maybe<Scalars['Int']['output']>;
  personalOneDriveSites: Maybe<Scalars['Int']['output']>;
  sharePoint: Maybe<Scalars['Int']['output']>;
  sharePointDrives: Maybe<Scalars['Int']['output']>;
  sharePointHubSites: Maybe<Scalars['Int']['output']>;
  sharePointSites: Maybe<Scalars['Int']['output']>;
  sharePointSubSites: Maybe<Scalars['Int']['output']>;
  sharePointSystemDocumentLibrary: Maybe<Scalars['Int']['output']>;
  sharePointSystemPageLibrary: Maybe<Scalars['Int']['output']>;
  sharedWithAnyone: Maybe<Scalars['Int']['output']>;
  sharedWithLink: Maybe<Scalars['Int']['output']>;
  sharedWithOrganization: Maybe<Scalars['Int']['output']>;
  sheet: Maybe<Scalars['Int']['output']>;
  slides: Maybe<Scalars['Int']['output']>;
  videos: Maybe<Scalars['Int']['output']>;
  whiteboard: Maybe<Scalars['Int']['output']>;
  withLabel: Maybe<Scalars['Int']['output']>;
  withoutLabel: Maybe<Scalars['Int']['output']>;
  word: Maybe<Scalars['Int']['output']>;
};

export type FileGraph = {
  directReadAccess: Maybe<Array<GraphUser>>;
  directWriteAccess: Maybe<Array<GraphUser>>;
  directoryGroups: Maybe<Array<GraphGroup>>;
  groups: Maybe<Array<GraphGroup>>;
  path: Array<Path>;
  readLinks: Maybe<Array<GraphLink>>;
  securityGroups: Maybe<Array<GraphGroup>>;
  sharepointGroups: Maybe<Array<GraphGroup>>;
  users: Maybe<Array<GraphUser>>;
  writeLinks: Maybe<Array<GraphLink>>;
};

export type FileGroup = {
  email: Scalars['String']['output'];
  externalUsers: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  members: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  owners: Maybe<Scalars['Int']['output']>;
  readers: Maybe<Scalars['Int']['output']>;
  writers: Maybe<Scalars['Int']['output']>;
};

export type FileGroups = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<FileGroup>;
  path: Array<Path>;
};

export type FileLabels = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SensitivityLabel>;
  path: Array<Path>;
};

export type FileLinkUsersPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<GraphUser>;
};

export type FileLinks = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<Link>;
  path: Array<Path>;
};

export type FileSensitivity = {
  dataOccurrences: Maybe<Array<Maybe<SensitivityDataOccurrences>>>;
  files: Scalars['Int']['output'];
  folders: Scalars['Int']['output'];
  informationDistributionByType: Maybe<Array<Maybe<InformationDistributionByType>>>;
  mostSensitiveFiles: Array<Maybe<MostSensitiveFiles>>;
  mostSensitiveFoldersByMostSensitiveFile: Array<Maybe<MostSensitiveFoldersByMostSensitiveFile>>;
  mostSensitiveFoldersByOverall: Array<Maybe<MostSensitiveFoldersByOverall>>;
  overallScore: Scalars['Float']['output'];
  path: Array<Path>;
  sensitivityContentFiles: Maybe<Array<Maybe<SensitivityContent>>>;
  sensitivityContentFolders: Maybe<Array<Maybe<SensitivityContent>>>;
};

export enum FileType {
  All = 'all',
  AllMicrosoft = 'allMicrosoft',
  AllStandard = 'allStandard',
  Archives = 'archives',
  Audio = 'audio',
  Image = 'image',
  List = 'list',
  Onenote = 'onenote',
  Pdf = 'pdf',
  Sheet = 'sheet',
  Slides = 'slides',
  Videos = 'videos',
  Whiteboard = 'whiteboard',
  Word = 'word'
}

export type FileUsers = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<AccessCompact>;
  path: Array<Path>;
};

export type FileUsersCompact = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<Access>;
  path: Array<Path>;
};

export type FilesNodesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<Node>;
  path: Array<Path>;
  resultsOnAnotherLevel: Maybe<Scalars['Boolean']['output']>;
};

export type Finding = {
  affectedItems: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isHidden: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  resourceType: Maybe<Scalars['String']['output']>;
  resourceTypeEn: Maybe<Scalars['String']['output']>;
  severity: Maybe<Scalars['Int']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId: Maybe<Scalars['String']['output']>;
};

export type FindingFilterCounts = {
  all: Maybe<Scalars['Int']['output']>;
  appResource: Maybe<Scalars['Int']['output']>;
  createdLast1Day: Scalars['Int']['output'];
  createdLast1Year: Scalars['Int']['output'];
  createdLast7Days: Scalars['Int']['output'];
  createdLast30Days: Scalars['Int']['output'];
  createdLast90Days: Scalars['Int']['output'];
  criticalSeverity: Maybe<Scalars['Int']['output']>;
  driveResource: Maybe<Scalars['Int']['output']>;
  fileResource: Maybe<Scalars['Int']['output']>;
  groupResource: Maybe<Scalars['Int']['output']>;
  highSeverity: Maybe<Scalars['Int']['output']>;
  informationSeverity: Maybe<Scalars['Int']['output']>;
  listHidden: Maybe<Scalars['Int']['output']>;
  lowSeverity: Maybe<Scalars['Int']['output']>;
  mediumSeverity: Maybe<Scalars['Int']['output']>;
  modifiedLast1Day: Scalars['Int']['output'];
  modifiedLast1Year: Scalars['Int']['output'];
  modifiedLast7Days: Scalars['Int']['output'];
  modifiedLast30Days: Scalars['Int']['output'];
  modifiedLast90Days: Scalars['Int']['output'];
  siteResource: Maybe<Scalars['Int']['output']>;
  skipHidden: Maybe<Scalars['Int']['output']>;
  userResource: Maybe<Scalars['Int']['output']>;
};

export type FindingItemData = {
  assignedBy: Maybe<Scalars['String']['output']>;
  assignedTo: Maybe<Scalars['String']['output']>;
  detectedAt: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  itemType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  status: Maybe<Scalars['String']['output']>;
  taskId: Maybe<Scalars['String']['output']>;
};

export type FindingItemsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<FindingItemData>;
};

export type FindingPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<Finding>;
};

export enum FullyScannedSitesEnum {
  All = 'all',
  FullyScannedSites = 'fullyScannedSites',
  NoFullyScannedSites = 'noFullyScannedSites'
}

export enum GetAccessingGroupsSortEnum {
  AToZ = 'AToZ',
  ZToA = 'ZToA',
  IsExternalAsc = 'isExternalAsc',
  IsExternalDesc = 'isExternalDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc',
  UsersWithAccessAsc = 'usersWithAccessAsc',
  UsersWithAccessDesc = 'usersWithAccessDesc'
}

export enum GetAccountsSortEnum {
  EmailAsc = 'emailAsc',
  EmailDesc = 'emailDesc',
  IsInviteAsc = 'isInviteAsc',
  IsInviteDesc = 'isInviteDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc'
}

export enum GetAlertResourcesSortEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc'
}

export enum GetAlertsSortType {
  AssignedUserAsc = 'assignedUserAsc',
  AssignedUserDesc = 'assignedUserDesc',
  CreatedFromAsc = 'createdFromAsc',
  CreatedFromDesc = 'createdFromDesc',
  DetectedAtAsc = 'detectedAtAsc',
  DetectedAtDesc = 'detectedAtDesc',
  IsResolvedAsc = 'isResolvedAsc',
  IsResolvedDesc = 'isResolvedDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  ResolvedAtAsc = 'resolvedAtAsc',
  ResolvedAtDesc = 'resolvedAtDesc',
  ResourceNameAsc = 'resourceNameAsc',
  ResourceNameDesc = 'resourceNameDesc',
  SeverityAsc = 'severityAsc',
  SeverityDesc = 'severityDesc',
  SnoozedAtAsc = 'snoozedAtAsc',
  SnoozedAtDesc = 'snoozedAtDesc',
  StatusAsc = 'statusAsc',
  StatusDesc = 'statusDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc',
  ViolationsAsc = 'violationsAsc',
  ViolationsDesc = 'violationsDesc'
}

export enum GetAppFilesSortEnum {
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  CreatedByAsc = 'createdByAsc',
  CreatedByDesc = 'createdByDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  LinkAsc = 'linkAsc',
  LinkDesc = 'linkDesc',
  ModifiedAtAsc = 'modifiedAtAsc',
  ModifiedAtDesc = 'modifiedAtDesc',
  ModifiedByAsc = 'modifiedByAsc',
  ModifiedByDesc = 'modifiedByDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  SizeAsc = 'sizeAsc',
  SizeDesc = 'sizeDesc'
}

export enum GetAppPermissionsEnum {
  ApiNameAsc = 'apiNameAsc',
  ApiNameDesc = 'apiNameDesc',
  DescriptionAsc = 'descriptionAsc',
  DescriptionDesc = 'descriptionDesc',
  IsConsentRequiredAsc = 'isConsentRequiredAsc',
  IsConsentRequiredDesc = 'isConsentRequiredDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc'
}

export enum GetAppUsersSortEnum {
  AppsCountAsc = 'appsCountAsc',
  AppsCountDesc = 'appsCountDesc',
  CanAdminConsentAsc = 'canAdminConsentAsc',
  CanAdminConsentDesc = 'canAdminConsentDesc',
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  EmailDomainAsc = 'emailDomainAsc',
  EmailDomainDesc = 'emailDomainDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  GroupsCountAsc = 'groupsCountAsc',
  GroupsCountDesc = 'groupsCountDesc',
  IsExternalAsc = 'isExternalAsc',
  IsExternalDesc = 'isExternalDesc',
  LastSignInAsc = 'lastSignInAsc',
  LastSignInDesc = 'lastSignInDesc',
  LicensesAsc = 'licensesAsc',
  LicensesDesc = 'licensesDesc',
  MfaAsc = 'mfaAsc',
  MfaDesc = 'mfaDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SignInDisabledAsc = 'signInDisabledAsc',
  SignInDisabledDesc = 'signInDisabledDesc'
}

export enum GetAppsActivityEnum {
  All = 'all',
  Approved = 'approved',
  NotPermitted = 'notPermitted',
  WaitingForReview = 'waitingForReview'
}

export enum GetAppsApplicationEnum {
  AddIn = 'addIn',
  All = 'all',
  AppRegistration = 'appRegistration',
  Enterprise = 'enterprise'
}

export enum GetAppsApprovalStatusEnum {
  ActiveUsers = 'activeUsers',
  All = 'all',
  InactiveUsers = 'inactiveUsers'
}

export enum GetAppsExternalEnum {
  All = 'all',
  ExternalUsers = 'externalUsers',
  InternalUsers = 'internalUsers',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc'
}

export enum GetAppsPublisherStatusEnum {
  All = 'all',
  Unverified = 'unverified',
  Verified = 'verified'
}

export enum GetAppsSortEnum {
  AccessToEmailAsc = 'accessToEmailAsc',
  AccessToEmailDesc = 'accessToEmailDesc',
  AccessToFilesAsc = 'accessToFilesAsc',
  AccessToFilesDesc = 'accessToFilesDesc',
  AccessToUsersAsc = 'accessToUsersAsc',
  AccessToUsersDesc = 'accessToUsersDesc',
  AddInAppAsc = 'addInAppAsc',
  AddInAppDesc = 'addInAppDesc',
  AddInApplicationAsc = 'addInApplicationAsc',
  AddInApplicationDesc = 'addInApplicationDesc',
  ApprovalStatusAsc = 'approvalStatusAsc',
  ApprovalStatusDesc = 'approvalStatusDesc',
  ConnectedAsc = 'connectedAsc',
  ConnectedDesc = 'connectedDesc',
  EnterpriseAppAsc = 'enterpriseAppAsc',
  EnterpriseAppDesc = 'enterpriseAppDesc',
  ExternalUsersAsc = 'externalUsersAsc',
  ExternalUsersDesc = 'externalUsersDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  FilesWithSensitiveDataAsc = 'filesWithSensitiveDataAsc',
  FilesWithSensitiveDataDesc = 'filesWithSensitiveDataDesc',
  FilesWithSensitivityLabelsAsc = 'filesWithSensitivityLabelsAsc',
  FilesWithSensitivityLabelsDesc = 'filesWithSensitivityLabelsDesc',
  FirstAdminUserAsc = 'firstAdminUserAsc',
  FirstAdminUserDesc = 'firstAdminUserDesc',
  FirstAdminUsersAsc = 'firstAdminUsersAsc',
  FirstAdminUsersDesc = 'firstAdminUsersDesc',
  InactiveUsersAsc = 'inactiveUsersAsc',
  InactiveUsersDesc = 'inactiveUsersDesc',
  LastUsedAsc = 'lastUsedAsc',
  LastUsedDesc = 'lastUsedDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  RegisteredAppAsc = 'registeredAppAsc',
  RegisteredAppDesc = 'registeredAppDesc',
  SensitiveInfoAsc = 'sensitiveInfoAsc',
  SensitiveInfoDesc = 'sensitiveInfoDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  UsersAsc = 'usersAsc',
  UsersDesc = 'usersDesc'
}

export type GetAutomationExecutionsArgs = {
  automationType: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  platform: InputMaybe<Scalars['String']['input']>;
  sourceResourceId: InputMaybe<Scalars['String']['input']>;
  sourceResourceType: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<AutomationStatus>;
  targetResourceId: InputMaybe<Scalars['String']['input']>;
  targetResourceType: InputMaybe<Scalars['String']['input']>;
  triggeredByResourceId: InputMaybe<Scalars['String']['input']>;
  triggeredByResourceType: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['String']['input']>;
};

export enum GetDrawerLabelsSortEnum {
  AppsAsc = 'appsAsc',
  AppsDesc = 'appsDesc',
  ColorAsc = 'colorAsc',
  ColorDesc = 'colorDesc',
  ContentFormatsAsc = 'contentFormatsAsc',
  ContentFormatsDesc = 'contentFormatsDesc',
  DescriptionAsc = 'descriptionAsc',
  DescriptionDesc = 'descriptionDesc',
  FilesAss = 'filesAss',
  FilesDesc = 'filesDesc',
  GroupsAsc = 'groupsAsc',
  GroupsDesc = 'groupsDesc',
  HasProtectionAsc = 'hasProtectionAsc',
  HasProtectionDesc = 'hasProtectionDesc',
  IsActiveAsc = 'isActiveAsc',
  IsActiveDesc = 'isActiveDesc',
  IsAppliableAsc = 'isAppliableAsc',
  IsAppliableDesc = 'isAppliableDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SitesAsc = 'sitesAsc',
  SitesDesc = 'sitesDesc',
  TooltipAsc = 'tooltipAsc',
  TooltipDesc = 'tooltipDesc',
  UsersAsc = 'usersAsc',
  UsersDesc = 'usersDesc'
}

export enum GetDrawerSensitiveInfoSortEnum {
  AppsAsc = 'appsAsc',
  AppsDesc = 'appsDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  GroupsAsc = 'groupsAsc',
  GroupsDesc = 'groupsDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SitesAsc = 'sitesAsc',
  SitesDesc = 'sitesDesc',
  UsersAsc = 'usersAsc',
  UsersDesc = 'usersDesc'
}

export enum GetFileAppsEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc'
}

export enum GetFileDirectAccessEnum {
  Read = 'read',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  Write = 'write'
}

export enum GetFileDirectAccessUsersAccessType {
  Read = 'Read',
  Write = 'Write',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc'
}

export enum GetFileDirectAccessUsersSortType {
  AToZ = 'AToZ',
  ZToA = 'ZToA',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc'
}

export enum GetFileLinksSortType {
  AccessRevokedAsc = 'accessRevokedAsc',
  AccessRevokedDesc = 'accessRevokedDesc',
  ExternalUsersWithAccessAsc = 'externalUsersWithAccessAsc',
  ExternalUsersWithAccessDesc = 'externalUsersWithAccessDesc',
  GroupsWithAccessAsc = 'groupsWithAccessAsc',
  GroupsWithAccessDesc = 'groupsWithAccessDesc',
  PasswordRequiredAsc = 'passwordRequiredAsc',
  PasswordRequiredDesc = 'passwordRequiredDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SharedWithAnyoneAsc = 'sharedWithAnyoneAsc',
  SharedWithAnyoneDesc = 'sharedWithAnyoneDesc',
  SharedWithEveryoneExceptExternalUsersAsc = 'sharedWithEveryoneExceptExternalUsersAsc',
  SharedWithEveryoneExceptExternalUsersDesc = 'sharedWithEveryoneExceptExternalUsersDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc',
  UsersWithAccessAsc = 'usersWithAccessAsc',
  UsersWithAccessDesc = 'usersWithAccessDesc'
}

export enum GetFileUsersEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc'
}

export enum GetFilesSortType {
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  CreatedByAsc = 'createdByAsc',
  CreatedByDesc = 'createdByDesc',
  ExternalUsersWithAccessAsc = 'externalUsersWithAccessAsc',
  ExternalUsersWithAccessDesc = 'externalUsersWithAccessDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  FilesWithSensitivityLabelsAsc = 'filesWithSensitivityLabelsAsc',
  FilesWithSensitivityLabelsDesc = 'filesWithSensitivityLabelsDesc',
  GroupsWithAccessAsc = 'groupsWithAccessAsc',
  GroupsWithAccessDesc = 'groupsWithAccessDesc',
  LinkAsc = 'linkAsc',
  LinkDesc = 'linkDesc',
  ModifiedAtAsc = 'modifiedAtAsc',
  ModifiedAtDesc = 'modifiedAtDesc',
  ModifiedByAsc = 'modifiedByAsc',
  ModifiedByDesc = 'modifiedByDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  PathAsc = 'pathAsc',
  PathDesc = 'pathDesc',
  SensitiveInfoAsc = 'sensitiveInfoAsc',
  SensitiveInfoDesc = 'sensitiveInfoDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  SharedExternallyAsc = 'sharedExternallyAsc',
  SharedExternallyDesc = 'sharedExternallyDesc',
  SharedWithAnyoneAsc = 'sharedWithAnyoneAsc',
  SharedWithAnyoneDesc = 'sharedWithAnyoneDesc',
  SharedWithOrganizationAsc = 'sharedWithOrganizationAsc',
  SharedWithOrganizationDesc = 'sharedWithOrganizationDesc',
  SizeAsc = 'sizeAsc',
  SizeDesc = 'sizeDesc',
  UserWithEditAccessAsc = 'userWithEditAccessAsc',
  UserWithEditAccessDesc = 'userWithEditAccessDesc',
  UsersWithAccessAsc = 'usersWithAccessAsc',
  UsersWithAccessDesc = 'usersWithAccessDesc',
  UsersWithEditAccessAsc = 'usersWithEditAccessAsc',
  UsersWithEditAccessDesc = 'usersWithEditAccessDesc'
}

export enum GetGroupAppsEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc'
}

export enum GetGroupFilesSortEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  PathAsc = 'pathAsc',
  PathDesc = 'pathDesc',
  PermissionsAsc = 'permissionsAsc',
  PermissionsDesc = 'permissionsDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc'
}

export enum GetGroupMembersSortEnum {
  EmailDomainAsc = 'emailDomainAsc',
  EmailDomainDesc = 'emailDomainDesc',
  IsExternalAsc = 'isExternalAsc',
  IsExternalDesc = 'isExternalDesc',
  LastSignInAsc = 'lastSignInAsc',
  LastSignInDesc = 'lastSignInDesc',
  MemberThroughAsc = 'memberThroughAsc',
  MemberThroughDesc = 'memberThroughDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc'
}

export enum GetGroupSitesSortEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc'
}

export enum GetGroupsGraphTypeEnum {
  All = 'all',
  External = 'external',
  Internal = 'internal',
  Ms365 = 'ms365',
  Private = 'private',
  Public = 'public',
  Security = 'security',
  Sharepoint = 'sharepoint',
  System = 'system',
  Teams = 'teams',
  UserGroups = 'userGroups'
}

export enum GetGroupsSortType {
  AccessibleSitesAsc = 'accessibleSitesAsc',
  AccessibleSitesDesc = 'accessibleSitesDesc',
  ContainedGroupsAsc = 'containedGroupsAsc',
  ContainedGroupsDesc = 'containedGroupsDesc',
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  CreatedByAsc = 'createdByAsc',
  CreatedByDesc = 'createdByDesc',
  ExternalAsc = 'externalAsc',
  ExternalDesc = 'externalDesc',
  ExternalUsersAsc = 'externalUsersAsc',
  ExternalUsersDesc = 'externalUsersDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  FilesWithSensitivityLabelsAsc = 'filesWithSensitivityLabelsAsc',
  FilesWithSensitivityLabelsDesc = 'filesWithSensitivityLabelsDesc',
  IsMemberOfGroupsAsc = 'isMemberOfGroupsAsc',
  IsMemberOfGroupsDesc = 'isMemberOfGroupsDesc',
  MembersAsc = 'membersAsc',
  MembersDesc = 'membersDesc',
  ModifiedByAsc = 'modifiedByAsc',
  ModifiedByDesc = 'modifiedByDesc',
  ModifiedOnAsc = 'modifiedOnAsc',
  ModifiedOnDesc = 'modifiedOnDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  NestedExternalUsersAsc = 'nestedExternalUsersAsc',
  NestedExternalUsersDesc = 'nestedExternalUsersDesc',
  NestedMembersAsc = 'nestedMembersAsc',
  NestedMembersDesc = 'nestedMembersDesc',
  SensitiveInfoAsc = 'sensitiveInfoAsc',
  SensitiveInfoDesc = 'sensitiveInfoDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  TotalExternalUsersAsc = 'totalExternalUsersAsc',
  TotalExternalUsersDesc = 'totalExternalUsersDesc',
  TotalUsersAsc = 'totalUsersAsc',
  TotalUsersDesc = 'totalUsersDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc'
}

export enum GetPoliciesSortType {
  AssignedUsersAsc = 'assignedUsersAsc',
  AssignedUsersDesc = 'assignedUsersDesc',
  LastDetectionAsc = 'lastDetectionAsc',
  LastDetectionDesc = 'lastDetectionDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SeverityAsc = 'severityAsc',
  SeverityDesc = 'severityDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc',
  ViolationsAsc = 'violationsAsc',
  ViolationsDesc = 'violationsDesc'
}

export enum GetResourceAlertsSortEnum {
  DetectedAtAsc = 'detectedAtAsc',
  DetectedAtDesc = 'detectedAtDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  ResolvedAtAsc = 'resolvedAtAsc',
  ResolvedAtDesc = 'resolvedAtDesc',
  SeverityAsc = 'severityAsc',
  SeverityDesc = 'severityDesc',
  StatusAsc = 'statusAsc',
  StatusDesc = 'statusDesc'
}

export enum GetSensitiveInfoDrawerSortEnum {
  DetectedBy1SecurityAsc = 'detectedBy1SecurityAsc',
  DetectedBy1SecurityDesc = 'detectedBy1SecurityDesc',
  DetectedByPurviewAsc = 'detectedByPurviewAsc',
  DetectedByPurviewDesc = 'detectedByPurviewDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  PathAsc = 'pathAsc',
  PathDesc = 'pathDesc',
  SharedExternallyAsc = 'sharedExternallyAsc',
  SharedExternallyDesc = 'sharedExternallyDesc',
  SharedWithAnyoneAsc = 'sharedWithAnyoneAsc',
  SharedWithAnyoneDesc = 'sharedWithAnyoneDesc',
  SharedWithOrganizationAsc = 'sharedWithOrganizationAsc',
  SharedWithOrganizationDesc = 'sharedWithOrganizationDesc',
  UsersWithAccessAsc = 'usersWithAccessAsc',
  UsersWithAccessDesc = 'usersWithAccessDesc'
}

export enum GetSensitiveInfoSortEnum {
  AppsAsc = 'appsAsc',
  AppsDesc = 'appsDesc',
  ConfidenceLevelAsc = 'confidenceLevelAsc',
  ConfidenceLevelDesc = 'confidenceLevelDesc',
  DetectionMechanismAsc = 'detectionMechanismAsc',
  DetectionMechanismDesc = 'detectionMechanismDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  FilesDetectedBy1SecurityPercentAsc = 'filesDetectedBy1SecurityPercentAsc',
  FilesDetectedBy1SecurityPercentDesc = 'filesDetectedBy1SecurityPercentDesc',
  FilesDetectedByPurviewPercentAsc = 'filesDetectedByPurviewPercentAsc',
  FilesDetectedByPurviewPercentDesc = 'filesDetectedByPurviewPercentDesc',
  GroupsAsc = 'groupsAsc',
  GroupsDesc = 'groupsDesc',
  IsActiveAsc = 'isActiveAsc',
  IsActiveDesc = 'isActiveDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  PublisherAsc = 'publisherAsc',
  PublisherDesc = 'publisherDesc',
  SitesAsc = 'sitesAsc',
  SitesDesc = 'sitesDesc',
  UsersAsc = 'usersAsc',
  UsersDesc = 'usersDesc'
}

export enum GetSensitivityLabelFilesSortEnum {
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  CreatedByAsc = 'createdByAsc',
  CreatedByDesc = 'createdByDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  LinkAsc = 'linkAsc',
  LinkDesc = 'linkDesc',
  ModifiedAtAsc = 'modifiedAtAsc',
  ModifiedAtDesc = 'modifiedAtDesc',
  ModifiedByAsc = 'modifiedByAsc',
  ModifiedByDesc = 'modifiedByDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  PathAsc = 'pathAsc',
  PathDesc = 'pathDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SharedExternallyAsc = 'sharedExternallyAsc',
  SharedExternallyDesc = 'sharedExternallyDesc',
  SharedWithAnyoneAsc = 'sharedWithAnyoneAsc',
  SharedWithAnyoneDesc = 'sharedWithAnyoneDesc',
  SharedWithOrganizationAsc = 'sharedWithOrganizationAsc',
  SharedWithOrganizationDesc = 'sharedWithOrganizationDesc',
  SizeAsc = 'sizeAsc',
  SizeDesc = 'sizeDesc',
  UsersWithAccessAsc = 'usersWithAccessAsc',
  UsersWithAccessDesc = 'usersWithAccessDesc'
}

export enum GetSensitivityLabelsSortEnum {
  AppsAsc = 'appsAsc',
  AppsDesc = 'appsDesc',
  ColorAsc = 'colorAsc',
  ColorDesc = 'colorDesc',
  ContentFormatsAsc = 'contentFormatsAsc',
  ContentFormatsDesc = 'contentFormatsDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  GroupsAsc = 'groupsAsc',
  GroupsDesc = 'groupsDesc',
  HasProtectionAsc = 'hasProtectionAsc',
  HasProtectionDesc = 'hasProtectionDesc',
  IsActiveAsc = 'isActiveAsc',
  IsActiveDesc = 'isActiveDesc',
  IsAppliableAsc = 'isAppliableAsc',
  IsAppliableDesc = 'isAppliableDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  PriorityAsc = 'priorityAsc',
  PriorityDesc = 'priorityDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SitesAsc = 'sitesAsc',
  SitesDesc = 'sitesDesc',
  UsersAsc = 'usersAsc',
  UsersDesc = 'usersDesc'
}

export enum GetSiteFilesSortEnum {
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  CreatedByAsc = 'createdByAsc',
  CreatedByDesc = 'createdByDesc',
  ExternalUsersWithAccessAsc = 'externalUsersWithAccessAsc',
  ExternalUsersWithAccessDesc = 'externalUsersWithAccessDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  GroupsWithAccessAsc = 'groupsWithAccessAsc',
  GroupsWithAccessDesc = 'groupsWithAccessDesc',
  ModifiedAtAsc = 'modifiedAtAsc',
  ModifiedAtDesc = 'modifiedAtDesc',
  ModifiedByAsc = 'modifiedByAsc',
  ModifiedByDesc = 'modifiedByDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  SharedWithAnyoneAsc = 'sharedWithAnyoneAsc',
  SharedWithAnyoneDesc = 'sharedWithAnyoneDesc',
  SizeAsc = 'sizeAsc',
  SizeDesc = 'sizeDesc',
  UsersWithAccessAsc = 'usersWithAccessAsc',
  UsersWithAccessDesc = 'usersWithAccessDesc',
  UsersWithEditAccessAsc = 'usersWithEditAccessAsc',
  UsersWithEditAccessDesc = 'usersWithEditAccessDesc'
}

export enum GetSiteGroupsSortEnum {
  AccessThroughAsc = 'accessThroughAsc',
  AccessThroughDesc = 'accessThroughDesc',
  DirectExternalUsersAsc = 'directExternalUsersAsc',
  DirectExternalUsersDesc = 'directExternalUsersDesc',
  DirectInternalUsersAsc = 'directInternalUsersAsc',
  DirectInternalUsersDesc = 'directInternalUsersDesc',
  HighestSitePermissionAsc = 'highestSitePermissionAsc',
  HighestSitePermissionDesc = 'highestSitePermissionDesc',
  IndirectExternalUsersAsc = 'indirectExternalUsersAsc',
  IndirectExternalUsersDesc = 'indirectExternalUsersDesc',
  IndirectInternalUsersAsc = 'indirectInternalUsersAsc',
  IndirectInternalUsersDesc = 'indirectInternalUsersDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  TotalDirectUsersAsc = 'totalDirectUsersAsc',
  TotalDirectUsersDesc = 'totalDirectUsersDesc',
  TotalIndirectUsersAsc = 'totalIndirectUsersAsc',
  TotalIndirectUsersDesc = 'totalIndirectUsersDesc',
  TotalUsersAsc = 'totalUsersAsc',
  TotalUsersDesc = 'totalUsersDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc'
}

export enum GetSiteSubsitesSortEnum {
  AToZ = 'AToZ',
  ZToA = 'ZToA',
  ActivityAsc = 'activityAsc',
  ActivityDesc = 'activityDesc',
  CreatedOnAsc = 'createdOnAsc',
  CreatedOnDesc = 'createdOnDesc',
  DrivesAsc = 'drivesAsc',
  DrivesDesc = 'drivesDesc',
  ExternalUsersWithAccessAsc = 'externalUsersWithAccessAsc',
  ExternalUsersWithAccessDesc = 'externalUsersWithAccessDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  GroupsWithAccessAsc = 'groupsWithAccessAsc',
  GroupsWithAccessDesc = 'groupsWithAccessDesc',
  InheritsPermissionsAsc = 'inheritsPermissionsAsc',
  InheritsPermissionsDesc = 'inheritsPermissionsDesc',
  IsHubSiteAsc = 'isHubSiteAsc',
  IsHubSiteDesc = 'isHubSiteDesc',
  LastActivityAsc = 'lastActivityAsc',
  LastActivityDesc = 'lastActivityDesc',
  ListsAsc = 'listsAsc',
  ListsDesc = 'listsDesc',
  ModifiedOnAsc = 'modifiedOnAsc',
  ModifiedOnDesc = 'modifiedOnDesc',
  NotebooksAsc = 'notebooksAsc',
  NotebooksDesc = 'notebooksDesc',
  PagesAsc = 'pagesAsc',
  PagesDesc = 'pagesDesc',
  PrivacyAsc = 'privacyAsc',
  PrivacyDesc = 'privacyDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SubsiteOfAsc = 'subsiteOfAsc',
  SubsiteOfDesc = 'subsiteOfDesc',
  SubsitesAsc = 'subsitesAsc',
  SubsitesDesc = 'subsitesDesc',
  TeamsChannelsAsc = 'teamsChannelsAsc',
  TeamsChannelsDesc = 'teamsChannelsDesc',
  UsersWithAccessAsc = 'usersWithAccessAsc',
  UsersWithAccessDesc = 'usersWithAccessDesc'
}

export enum GetSiteUsersSortEnum {
  EmailDomainAsc = 'emailDomainAsc',
  EmailDomainDesc = 'emailDomainDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc'
}

export enum GetSitesAccessEnum {
  All = 'all',
  ExternalUsers = 'externalUsers',
  InternalUsers = 'internalUsers'
}

export enum GetSitesActivityEnum {
  All = 'all',
  High = 'high',
  Low = 'low',
  Medium = 'medium'
}

export enum GetSitesPrivacyEnum {
  All = 'all',
  Private = 'private',
  Public = 'public'
}

export enum GetSitesSortEnum {
  ActivityAsc = 'activityAsc',
  ActivityDesc = 'activityDesc',
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  CreatedOnAsc = 'createdOnAsc',
  CreatedOnDesc = 'createdOnDesc',
  DirectUsersWithAccessAsc = 'directUsersWithAccessAsc',
  DirectUsersWithAccessDesc = 'directUsersWithAccessDesc',
  DrivesAsc = 'drivesAsc',
  DrivesDesc = 'drivesDesc',
  ExternalUsersAsc = 'externalUsersAsc',
  ExternalUsersDesc = 'externalUsersDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  FilesSizeAsc = 'filesSizeAsc',
  FilesSizeDesc = 'filesSizeDesc',
  FilesWithSensitivityLabelsAsc = 'filesWithSensitivityLabelsAsc',
  FilesWithSensitivityLabelsDesc = 'filesWithSensitivityLabelsDesc',
  GroupsWithAccessAsc = 'groupsWithAccessAsc',
  GroupsWithAccessDesc = 'groupsWithAccessDesc',
  IndirectUsersWithAccessAsc = 'indirectUsersWithAccessAsc',
  IndirectUsersWithAccessDesc = 'indirectUsersWithAccessDesc',
  IsBlockedAsc = 'isBlockedAsc',
  IsBlockedDesc = 'isBlockedDesc',
  IsFullyScannedAsc = 'isFullyScannedAsc',
  IsFullyScannedDesc = 'isFullyScannedDesc',
  IsTeamsAsc = 'isTeamsAsc',
  IsTeamsDesc = 'isTeamsDesc',
  LastActivityAsc = 'lastActivityAsc',
  LastActivityDesc = 'lastActivityDesc',
  ListsAsc = 'listsAsc',
  ListsDesc = 'listsDesc',
  MembersAsc = 'membersAsc',
  MembersDesc = 'membersDesc',
  ModifiedAtAsc = 'modifiedAtAsc',
  ModifiedAtDesc = 'modifiedAtDesc',
  ModifiedOnAsc = 'modifiedOnAsc',
  ModifiedOnDesc = 'modifiedOnDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  NotebooksAsc = 'notebooksAsc',
  NotebooksDesc = 'notebooksDesc',
  OwnersAsc = 'ownersAsc',
  OwnersDesc = 'ownersDesc',
  PagesAsc = 'pagesAsc',
  PagesDesc = 'pagesDesc',
  PrivacyAsc = 'privacyAsc',
  PrivacyDesc = 'privacyDesc',
  SensitiveInfoAsc = 'sensitiveInfoAsc',
  SensitiveInfoDesc = 'sensitiveInfoDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  SubsitesAsc = 'subsitesAsc',
  SubsitesDesc = 'subsitesDesc',
  TeamsChannelsAsc = 'teamsChannelsAsc',
  TeamsChannelsDesc = 'teamsChannelsDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc'
}

export enum GetSitesTypeEnum {
  All = 'all',
  Hubsite = 'hubsite',
  Site = 'site',
  Subsite = 'subsite'
}

export enum GetUserFilesSortEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  PathAsc = 'pathAsc',
  PathDesc = 'pathDesc',
  PermissionsAsc = 'permissionsAsc',
  PermissionsDesc = 'permissionsDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc'
}

export enum GetUserGroupsSortEnum {
  AccessThroughAsc = 'accessThroughAsc',
  AccessThroughDesc = 'accessThroughDesc',
  DirectExternalUsersAsc = 'directExternalUsersAsc',
  DirectExternalUsersDesc = 'directExternalUsersDesc',
  DirectInternalUsersAsc = 'directInternalUsersAsc',
  DirectInternalUsersDesc = 'directInternalUsersDesc',
  HighestSitePermissionAsc = 'highestSitePermissionAsc',
  HighestSitePermissionDesc = 'highestSitePermissionDesc',
  IndirectExternalUsersAsc = 'indirectExternalUsersAsc',
  IndirectExternalUsersDesc = 'indirectExternalUsersDesc',
  IndirectInternalUsersAsc = 'indirectInternalUsersAsc',
  IndirectInternalUsersDesc = 'indirectInternalUsersDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  TotalDirectUsersAsc = 'totalDirectUsersAsc',
  TotalDirectUsersDesc = 'totalDirectUsersDesc',
  TotalIndirectUsersAsc = 'totalIndirectUsersAsc',
  TotalIndirectUsersDesc = 'totalIndirectUsersDesc',
  TotalUsersWithAccessAsc = 'totalUsersWithAccessAsc',
  TotalUsersWithAccessDesc = 'totalUsersWithAccessDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc'
}

export type GetUserSitesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<UserSite>;
};

export enum GetUserSitesSortEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc'
}

export enum GetUsersLicensesEnum {
  All = 'all',
  NoLicense = 'noLicense',
  WithLicense = 'withLicense'
}

export enum GetUsersSortEnum {
  AppsCountAsc = 'appsCountAsc',
  AppsCountDesc = 'appsCountDesc',
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  EmailAsc = 'emailAsc',
  EmailDesc = 'emailDesc',
  EmailDomainAsc = 'emailDomainAsc',
  EmailDomainDesc = 'emailDomainDesc',
  FilesAsc = 'filesAsc',
  FilesDesc = 'filesDesc',
  FilesWithSensitiveDataAsc = 'filesWithSensitiveDataAsc',
  FilesWithSensitiveDataDesc = 'filesWithSensitiveDataDesc',
  FilesWithSensitivityLabelsAsc = 'filesWithSensitivityLabelsAsc',
  FilesWithSensitivityLabelsDesc = 'filesWithSensitivityLabelsDesc',
  GroupsCountAsc = 'groupsCountAsc',
  GroupsCountDesc = 'groupsCountDesc',
  IsExternalAsc = 'isExternalAsc',
  IsExternalDesc = 'isExternalDesc',
  LastSignInAsc = 'lastSignInAsc',
  LastSignInDesc = 'lastSignInDesc',
  LicensesAsc = 'licensesAsc',
  LicensesDesc = 'licensesDesc',
  MfaAsc = 'mfaAsc',
  MfaDesc = 'mfaDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitiveInfoAsc = 'sensitiveInfoAsc',
  SensitiveInfoDesc = 'sensitiveInfoDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  SignInDisabledAsc = 'signInDisabledAsc',
  SignInDisabledDesc = 'signInDisabledDesc'
}

export enum GetUsersTypeEnum {
  All = 'all',
  ExternalUsers = 'externalUsers',
  InternalUsers = 'internalUsers'
}

export type Graph = {
  edges: Array<GraphEdge>;
  legend: Array<GraphLegend>;
  nodes: Array<GraphNode>;
};

export type GraphEdge = {
  from: Scalars['ID']['output'];
  to: Scalars['ID']['output'];
};

export type GraphFilters = {
  permissions: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GraphGroup = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Maybe<Array<Scalars['String']['output']>>;
  users: Scalars['Int']['output'];
};

export type GraphLegend = {
  color: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type GraphLink = {
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  type: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type GraphNode = {
  color: Maybe<Scalars['String']['output']>;
  drawerDataId: Maybe<Scalars['String']['output']>;
  files: Maybe<Scalars['String']['output']>;
  filters: Maybe<GraphFilters>;
  groups: Maybe<Scalars['String']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  page: Maybe<Scalars['String']['output']>;
  resource: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  users: Maybe<Scalars['String']['output']>;
};

export type GraphUser = {
  email: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  userName: Scalars['String']['output'];
};

export type Group = {
  accessThrough: Maybe<Array<Scalars['String']['output']>>;
  accessibleFiles: Maybe<Scalars['Int']['output']>;
  accessibleSites: Maybe<Scalars['Int']['output']>;
  containedGroups: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  externalUsers: Maybe<Scalars['Int']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  help: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternal: Maybe<Scalars['Boolean']['output']>;
  isMemberOfGroups: Maybe<Scalars['Int']['output']>;
  isTeams: Maybe<Scalars['Boolean']['output']>;
  link: Maybe<Scalars['String']['output']>;
  members: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nestedExternalUsers: Maybe<Scalars['Int']['output']>;
  nestedMembers: Maybe<Scalars['Int']['output']>;
  permissions: Maybe<Array<Scalars['String']['output']>>;
  privacy: Maybe<Scalars['String']['output']>;
  roles: Maybe<Array<Scalars['String']['output']>>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  totalExternalUsers: Maybe<Scalars['Int']['output']>;
  totalUsers: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export enum GroupAccessType {
  All = 'all',
  ExternalUsers = 'externalUsers',
  InternalUsers = 'internalUsers'
}

export type GroupAppsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<App>;
};

export type GroupFiles = {
  files: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  sharedExternally: Scalars['Boolean']['output'];
  sharedWithAnyone: Scalars['Boolean']['output'];
  size: Maybe<Scalars['Int']['output']>;
  sourceType: Maybe<Scalars['String']['output']>;
  usersWithAccess: Scalars['Int']['output'];
  webUrl: Maybe<Scalars['String']['output']>;
};

export type GroupFilesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<GroupFiles>;
};

export type GroupFilterCounts = {
  all: Scalars['Int']['output'];
  allTypes: Scalars['Int']['output'];
  allUsers: Scalars['Int']['output'];
  directory: Scalars['Int']['output'];
  externalUsers: Scalars['Int']['output'];
  internalUsers: Scalars['Int']['output'];
  ms365: Scalars['Int']['output'];
  security: Scalars['Int']['output'];
  sharepoint: Scalars['Int']['output'];
};

export type GroupGraph = {
  mainGroup: GroupGraphElement;
  nestedGroups: Array<GroupGraphElement>;
  parentGroups: Array<GroupGraphElement>;
};

export type GroupGraphElement = {
  azureId: Scalars['ID']['output'];
  childId: Maybe<Scalars['String']['output']>;
  files: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type GroupGroups = {
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  usersWithAccess: Scalars['Int']['output'];
};

export type GroupGroupsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<GroupGroups>;
};

export type GroupMemberPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<GroupUser>;
};

export type GroupPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<Group>;
};

export type GroupSites = {
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Scalars['String']['output'];
  usersWithAccess: Scalars['Int']['output'];
};

export type GroupSitesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<GroupSites>;
};

export enum GroupType {
  All = 'all',
  Directory = 'directory',
  Ms365 = 'ms365',
  Security = 'security',
  Sharepoint = 'sharepoint'
}

export type GroupUser = {
  avatar: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
  groups: Array<NestedGroup>;
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  roles: Array<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type GroupsGraph = {
  categories: Array<ChartCategory>;
  links: Array<ChartLink>;
  nodes: Array<ChartNode>;
};

export type InformationDistributionByType = {
  count: Scalars['Int']['output'];
  sensitivityType: Scalars['String']['output'];
};

export type InviteResponse = {
  email: Scalars['String']['output'];
  inviteCode: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum LabelType {
  All = 'all',
  WithLabel = 'withLabel',
  WithoutLabel = 'withoutLabel'
}

export type Link = {
  groups: Maybe<Array<LinkGroup>>;
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  users: Maybe<Array<LinkUser>>;
  webUrl: Scalars['String']['output'];
};

export type LinkAzure = {
  preventsDownload: Maybe<Scalars['Boolean']['output']>;
  scope: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  webUrl: Maybe<Scalars['String']['output']>;
};

export type LinkGroup = {
  emailDomain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum LinkType {
  All = 'all',
  Edit = 'edit',
  Review = 'review',
  View = 'view'
}

export type LinkUser = {
  avatar: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  roles: Array<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export enum LocationType {
  OneDrive = 'oneDrive',
  SharePoint = 'sharePoint'
}

export type MostSensitiveFiles = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  sensitivity: Scalars['Int']['output'];
  webUrl: Maybe<Scalars['String']['output']>;
};

export type MostSensitiveFoldersByMostSensitiveFile = {
  highestFileSensitivity: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  webUrl: Maybe<Scalars['String']['output']>;
};

export type MostSensitiveFoldersByOverall = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  overallSensitivity: Scalars['Int']['output'];
  webUrl: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  _: Maybe<Scalars['Boolean']['output']>;
  acceptInvite: Maybe<Tokens>;
  activateSensitiveInfo: Scalars['Boolean']['output'];
  assignMSOfficeLicense: Maybe<Scalars['Boolean']['output']>;
  checkTaskStatus: Scalars['String']['output'];
  createPolicy: Scalars['Boolean']['output'];
  deactivateSensitiveInfo: Scalars['Boolean']['output'];
  editAlert: Scalars['Boolean']['output'];
  editPolicy: Scalars['Boolean']['output'];
  generateShortUrl: Scalars['String']['output'];
  inviteTo1Security: InviteResponse;
  logout: Scalars['Boolean']['output'];
  logoutTenant: Maybe<Scalars['String']['output']>;
  removeAccountOrInvitationFromOrganization: Maybe<Scalars['Boolean']['output']>;
  removeTenantFrom1Security: Maybe<Scalars['Boolean']['output']>;
  removeTenantFromOrganization: Maybe<Scalars['Boolean']['output']>;
  removeUserFromGroup: Maybe<Scalars['Boolean']['output']>;
  requestRefreshTenant: Maybe<Scalars['Boolean']['output']>;
  resolveAlert: Scalars['Boolean']['output'];
  revertAlert: Scalars['Boolean']['output'];
  sendEmailMessageTo1Security: Scalars['Boolean']['output'];
  sendUpgradeRequestEmail: Scalars['Boolean']['output'];
  sendWaitlistEmail: Scalars['Boolean']['output'];
  setCurrentTenant: Maybe<Scalars['Boolean']['output']>;
  setDisplayFinding: Scalars['Boolean']['output'];
  setSiteConfiguration: Scalars['Boolean']['output'];
  setViewAs: Maybe<Scalars['Boolean']['output']>;
  signIn: Maybe<Tokens>;
  switchOrganization: Maybe<Scalars['Boolean']['output']>;
  unassignLicenses: Maybe<Scalars['Boolean']['output']>;
  updatePolicy: Scalars['Boolean']['output'];
  updateTask: SecurityTask;
  verifyEmail: Maybe<Tokens>;
  verifyInvite: VerifyResponse;
};


export type MutationAcceptInviteArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  inviteCode: InputMaybe<Scalars['String']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  token: InputMaybe<Scalars['String']['input']>;
};


export type MutationActivateSensitiveInfoArgs = {
  sensitiveInfoIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationCheckTaskStatusArgs = {
  resourceId: Scalars['ID']['input'];
  taskId: Scalars['ID']['input'];
};


export type MutationCreatePolicyArgs = {
  assignment: InputMaybe<Scalars['String']['input']>;
  automations: InputMaybe<Scalars['String']['input']>;
  conditions: InputMaybe<Scalars['String']['input']>;
  defaultUser: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  selectedResources: InputMaybe<Scalars['String']['input']>;
  severity: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationDeactivateSensitiveInfoArgs = {
  sensitiveInfoIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationEditAlertArgs = {
  assignedUser: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isResolved: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  severity: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditPolicyArgs = {
  assignment: InputMaybe<Scalars['String']['input']>;
  automations: InputMaybe<Scalars['String']['input']>;
  conditions: InputMaybe<Scalars['String']['input']>;
  defaultUser: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  selectedResources: InputMaybe<Scalars['String']['input']>;
  severity: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationGenerateShortUrlArgs = {
  url: Scalars['String']['input'];
};


export type MutationInviteTo1SecurityArgs = {
  email: Scalars['String']['input'];
  role: InputMaybe<Scalars['String']['input']>;
};


export type MutationLogoutArgs = {
  allDevices: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLogoutTenantArgs = {
  clientCallback: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationRemoveAccountOrInvitationFromOrganizationArgs = {
  accountId: InputMaybe<Scalars['String']['input']>;
  invitationId: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveTenantFrom1SecurityArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationRemoveTenantFromOrganizationArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationRemoveUserFromGroupArgs = {
  groupId: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestRefreshTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationResolveAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRevertAlertArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendEmailMessageTo1SecurityArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  message: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
};


export type MutationSendUpgradeRequestEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendWaitlistEmailArgs = {
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};


export type MutationSetCurrentTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationSetDisplayFindingArgs = {
  findingId: InputMaybe<Scalars['ID']['input']>;
  hide: Scalars['Boolean']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetSiteConfigurationArgs = {
  anonymousLinkExpirationInDays: InputMaybe<Scalars['Int']['input']>;
  defaultLinkPermission: InputMaybe<DefaultLinkPermission>;
  defaultSharingLinkType: InputMaybe<DefaultSharingLinkType>;
  drawerDataId: Scalars['ID']['input'];
  externalUserExpirationInDays: InputMaybe<Scalars['Int']['input']>;
  overrideTenantAnonymousLinkExpirationPolicy: InputMaybe<Scalars['Boolean']['input']>;
  overrideTenantExternalUserExpirationPolicy: InputMaybe<Scalars['Boolean']['input']>;
  sharingAllowedDomainList: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sharingBlockedDomainList: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sharingCapability: InputMaybe<SharingCapability>;
  siteName: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetViewAsArgs = {
  isAdminMode: InputMaybe<Scalars['Boolean']['input']>;
  viewingAs: InputMaybe<Scalars['String']['input']>;
};


export type MutationSignInArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  inviteCode: InputMaybe<Scalars['String']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  referralCode: InputMaybe<Scalars['String']['input']>;
  token: InputMaybe<Scalars['String']['input']>;
};


export type MutationSwitchOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationUpdatePolicyArgs = {
  automations: InputMaybe<Array<ActionInput>>;
  conditions: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isDisabled: InputMaybe<Scalars['Boolean']['input']>;
  maxEmailsPerDay: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  notificationEmails: Array<Scalars['String']['input']>;
  severity: Scalars['String']['input'];
  tenantId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  users: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateTaskArgs = {
  assignedTo: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['ID']['input'];
  taskStatus: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyEmailArgs = {
  email: InputMaybe<Scalars['String']['input']>;
  emailVerificationCode: InputMaybe<Scalars['String']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  token: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyInviteArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type NestedGroup = {
  accessThrough: Scalars['String']['output'];
  accessType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type NewFileGroups = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<NewFileGroupsAccess>;
  path: Array<Path>;
};

export type NewFileGroupsAccess = {
  accessThrough: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  directExternalUsers: Maybe<Scalars['Int']['output']>;
  directInternalUsers: Maybe<Scalars['Int']['output']>;
  groupSensitivityLabels: Maybe<Scalars['String']['output']>;
  highestSitePermission: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  indirectExternalUsers: Maybe<Scalars['Int']['output']>;
  indirectInternalUsers: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  totalDirectUsers: Maybe<Scalars['Int']['output']>;
  totalIndirectUsers: Maybe<Scalars['Int']['output']>;
  totalUsers: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type NewFileLinks = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<NewLink>;
  path: Array<Path>;
};

export type NewFileUsers = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<NewFileUsersAccess>;
  path: Array<Path>;
};

export type NewFileUsersAccess = {
  accessibleFiles: Maybe<Scalars['Int']['output']>;
  avatar: Maybe<Scalars['String']['output']>;
  azureRegisteredAt: Maybe<Scalars['String']['output']>;
  canAdminConsent: Maybe<Scalars['Boolean']['output']>;
  connectedApps: Maybe<Scalars['Int']['output']>;
  emailDomain: Maybe<Scalars['String']['output']>;
  hasMfa: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  isExternal: Maybe<Scalars['Boolean']['output']>;
  lastSignIn: Maybe<Scalars['String']['output']>;
  licenses: Array<Maybe<Scalars['String']['output']>>;
  name: Maybe<Scalars['String']['output']>;
  permissions: Array<PermissionObject>;
  signInDisabledAt: Maybe<Scalars['String']['output']>;
  totalGroupMemberships: Maybe<Scalars['Int']['output']>;
};

export type NewGroupFiles = {
  fileSensitivityLabels: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Maybe<Scalars['String']['output']>;
  permissions: Array<PermissionObject>;
};

export type NewGroupFilesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<NewGroupFiles>;
};

export type NewGroupMembersPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<NewGroupUser>;
};

export type NewGroupSites = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<PermissionObject>;
};

export type NewGroupSitesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<UserSite>;
};

export type NewGroupUser = {
  accessThrough: Array<AccessThroughName>;
  avatar: Maybe<Scalars['String']['output']>;
  emailDomain: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  lastSignIn: Maybe<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
};

export type NewLink = {
  accessRevoked: Maybe<Scalars['String']['output']>;
  externalUsersWithAccess: Scalars['Int']['output'];
  groupsWithAccess: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  passwordRequired: Maybe<Scalars['Boolean']['output']>;
  sharedWithAnyone: Scalars['Boolean']['output'];
  sharedWithEveryoneExceptExternalUsers: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  usersWithAccess: Scalars['Int']['output'];
  webUrl: Scalars['String']['output'];
};

export type NewSiteGroupsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<NewFileGroupsAccess>;
};

export type NewSiteUser = {
  emailDomain: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<SiteUserPermission>;
};

export type NewSiteUserPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<NewSiteUser>;
};

export type Node = {
  appsWithAccess: Maybe<Scalars['Int']['output']>;
  azureId: Maybe<Scalars['ID']['output']>;
  createdBy: Maybe<UserAzureObject>;
  createdDate: Maybe<Scalars['String']['output']>;
  externalUsersWithAccess: Maybe<Scalars['Int']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  folders: Maybe<Scalars['Int']['output']>;
  groupsWithAccess: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  lastModified: Maybe<Scalars['String']['output']>;
  lastModifiedBy: Maybe<UserAzureObject>;
  level: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  parentId: Maybe<Scalars['String']['output']>;
  path: Maybe<Scalars['String']['output']>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivity: Maybe<Scalars['Float']['output']>;
  sensitivityContentFiles: Maybe<Array<Maybe<SensitivityContent>>>;
  sensitivityInformationDistribution: Maybe<Array<Maybe<InformationDistributionByType>>>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  shareLink: Maybe<Scalars['String']['output']>;
  sharedExternally: Maybe<Scalars['Int']['output']>;
  sharedWithAnyone: Maybe<Scalars['Int']['output']>;
  sharedWithOrganization: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['String']['output']>;
  sourceType: Maybe<Scalars['String']['output']>;
  tenantId: Maybe<Scalars['String']['output']>;
  topFileSensitivity: Maybe<Scalars['Float']['output']>;
  type: Maybe<Scalars['String']['output']>;
  usersWithAccess: Maybe<Scalars['Int']['output']>;
  usersWithEditAccess: Maybe<Scalars['Int']['output']>;
  webUrl: Maybe<Scalars['String']['output']>;
};

export type OnboardingData = {
  orgId: Maybe<Scalars['String']['output']>;
  permissions: Maybe<Array<Maybe<Permission>>>;
};

export type Organization = {
  accessType: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  referralCode: Maybe<Scalars['String']['output']>;
};

export enum OrphanedIndicatorsEnum {
  All = 'all',
  NoActivityLastYear = 'noActivityLastYear',
  NoDirectUsers = 'noDirectUsers',
  NoOwners = 'noOwners',
  NoUsers = 'noUsers'
}

export type Path = {
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type Permission = {
  isValid: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type PermissionAzure = {
  grantedTo: Maybe<UserAzureObject>;
  grantedToIdentities: Maybe<Array<Maybe<UserAzureObject>>>;
  grantedToIdentitiesV2: Maybe<Array<Maybe<UserAzureObject>>>;
  grantedToV2: Maybe<UserAzureObject>;
  hasPassword: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  link: Maybe<LinkAzure>;
  roles: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shareId: Maybe<Scalars['String']['output']>;
};

export type PermissionObject = {
  accessThrough: Array<AccessThrough>;
  levelName: Scalars['String']['output'];
  permission: Scalars['String']['output'];
};

export enum PersonalSitesEnum {
  All = 'all',
  ShowPersonalSites = 'showPersonalSites'
}

export type Policy = {
  activeScan: Maybe<Scalars['Boolean']['output']>;
  assignedUsers: Maybe<Scalars['Int']['output']>;
  automations: Maybe<Scalars['String']['output']>;
  conditions: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isTemplate: Maybe<Scalars['Boolean']['output']>;
  lastDetection: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  severity: Scalars['String']['output'];
  type: Scalars['String']['output'];
  violations: Maybe<Scalars['Int']['output']>;
};

export type PolicyAlerts = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Maybe<Scalars['String']['output']>;
};

export type PolicyHistoryEntry = {
  action: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  newState: Maybe<Scalars['String']['output']>;
  previousState: Maybe<Scalars['String']['output']>;
  userEmail: Maybe<Scalars['String']['output']>;
  userName: Maybe<Scalars['String']['output']>;
};

export type PolicyHistoryResponse = {
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<PolicyHistoryEntry>;
};

export type PolicyPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<Policy>;
};

export type Query = {
  _: Maybe<Scalars['Boolean']['output']>;
  checkTenantConfig: Maybe<TenantConfigChecks>;
  chooseConnectedTenant: Maybe<Scalars['String']['output']>;
  connectTenant: Maybe<Scalars['String']['output']>;
  decryptUrl: Scalars['String']['output'];
  downloadAlertsData: DownloadData;
  downloadAppFilesData: DownloadData;
  downloadAppPermissionsData: DownloadData;
  downloadAppUsersData: DownloadData;
  downloadAppsData: DownloadData;
  downloadFilesData: DownloadData;
  downloadGroupAppsData: DownloadData;
  downloadGroupFilesData: DownloadData;
  downloadGroupUsersData: DownloadData;
  downloadGroupsData: DownloadData;
  downloadGroupsSitesData: DownloadData;
  downloadSiteUsersData: DownloadData;
  downloadSitesData: DownloadData;
  downloadUsersData: DownloadData;
  getAIAnswer: Scalars['String']['output'];
  getAccessedGroups: GroupGroupsPagination;
  getAccessingGroups: GroupGroupsPagination;
  getAccountOrganizations: Maybe<Array<Maybe<Organization>>>;
  getAccountUsers: Maybe<Array<Maybe<AccountUser>>>;
  getAccounts: AccountPagination;
  getActiveSensitiveData: Array<Maybe<Scalars['ID']['output']>>;
  getAlert: Alert;
  getAlertHistory: PolicyHistoryResponse;
  getAlertResources: AlertResourcesPagination;
  getAlertResults: AlertResultsResponse;
  getAlerts: AlertPagination;
  getAllConnectedTenants: Maybe<Array<Maybe<Tenant>>>;
  getApp: App;
  getAppAlerts: ResourceAlertsPagination;
  getAppFiles: AppFilesPagination;
  getAppFilesItemsCount: Scalars['Int']['output'];
  getAppFilterCounts: AppFilterCounts;
  getAppGroups: AppGroupsPagination;
  getAppLabels: DrawerLabelsPagination;
  getAppPermissions: AppPermissionsPagination;
  getAppPermissionsItemsCount: Scalars['Int']['output'];
  getAppSensitiveInfo: DrawerSensitiveInfoPagination;
  getAppUsers: AppUsersPagination;
  getAppUsersItemsCount: Scalars['Int']['output'];
  getApps: AppPagination;
  getAutomationExecution: Maybe<AutomationExecution>;
  getAutomationExecutions: AutomationExecutionConnection;
  getCurrentOrganization: Maybe<Organization>;
  getCurrentTenant: Maybe<Tenant>;
  getCurrentTenantAzureId: Maybe<Scalars['String']['output']>;
  getFile: File;
  getFileAlerts: ResourceAlertsPagination;
  getFileApps: FileAppsPagination;
  getFileAppsItemsCount: Scalars['Int']['output'];
  getFileDirectAccess: FileUsers;
  getFileDirectAccessUsers: FileLinkUsersPagination;
  getFileFilterCounts: FileFilterCounts;
  getFileGraph: Graph;
  getFileGroups: NewFileGroups;
  getFileGroupsItemsCount: Scalars['Int']['output'];
  getFileItemsCount: Scalars['Int']['output'];
  getFileLinkUsers: FileLinkUsersPagination;
  getFileLinks: NewFileLinks;
  getFileLinksItemsCount: Scalars['Int']['output'];
  getFileSensitiveInfo: DrawerSensitiveInfoPagination;
  getFileSensitivity: FileSensitivity;
  getFileSensitivityLabels: FileLabels;
  getFileUsers: NewFileUsers;
  getFileUsersItemsCount: Scalars['Int']['output'];
  getFiles: FilesNodesPagination;
  getFinding: Finding;
  getFindingItems: FindingItemsPagination;
  getFindings: FindingPagination;
  getFindingsFilterCount: FindingFilterCounts;
  getGroup: Group;
  getGroupAlerts: ResourceAlertsPagination;
  getGroupApps: GroupAppsPagination;
  getGroupAppsItemsCount: Scalars['Int']['output'];
  getGroupFiles: NewGroupFilesPagination;
  getGroupFilesItemsCount: Scalars['Int']['output'];
  getGroupFilterCounts: GroupFilterCounts;
  getGroupGraph: SiteGroupGraph;
  getGroupLabels: DrawerLabelsPagination;
  getGroupMembers: NewGroupMembersPagination;
  getGroupMembersItemsCount: Scalars['Int']['output'];
  getGroupSensitiveInfo: DrawerSensitiveInfoPagination;
  getGroupSites: NewGroupSitesPagination;
  getGroupSitesItemsCount: Scalars['Int']['output'];
  getGroups: GroupPagination;
  getGroupsGraph: GroupsGraph;
  getLivePolicyPreview: PolicyAlerts;
  getMe: Account;
  getOnboardingData: OnboardingData;
  getOrganizations: Maybe<Array<Maybe<Organization>>>;
  getPolicies: PolicyPagination;
  getPolicy: Policy;
  getPolicyActivityTimeline: ActivityTimelineResponse;
  getPolicyHistory: PolicyHistoryResponse;
  getResourceActivityTimeline: ActivityTimelineResponse;
  getScanResourceStatus: Maybe<TenantResourceScanStatusChecks>;
  getSecurityTask: SecurityTask;
  getSecurityTasks: SecurityTasksPagination;
  getSecurityTasksFilterCount: SecurityTasksFilterCounts;
  getSensitiveData: SensitiveInfoPagination;
  getSensitiveInfo: SensitiveInfo;
  getSensitiveInfoAlerts: ResourceAlertsPagination;
  getSensitiveInfoApps: SensitiveInfoAppsPagination;
  getSensitiveInfoFiles: Maybe<SensitiveInfoFilesPagination>;
  getSensitiveInfoGroups: SensitiveInfoGroupsPagination;
  getSensitiveInfoSites: SensitiveInfoSitesPagination;
  getSensitiveInfoUsers: SensitiveInfoUsersPagination;
  getSensitivityLabel: SensitivityLabel;
  getSensitivityLabelAlerts: ResourceAlertsPagination;
  getSensitivityLabelFiles: Maybe<SensitivityLabelFilesPagination>;
  getSensitivityLabelGroups: GroupPagination;
  getSensitivityLabels: SensitivityLabelsPagination;
  getSite: Site;
  getSiteAlerts: ResourceAlertsPagination;
  getSiteConfiguration: SiteConfiguration;
  getSiteFiles: SiteFilesPagination;
  getSiteFilesItemsCount: Scalars['Int']['output'];
  getSiteFilterCounts: SiteFilterCounts;
  getSiteGraph: Array<SiteGraph>;
  getSiteGroups: NewSiteGroupsPagination;
  getSiteGroupsGraph: Graph;
  getSiteGroupsItemsCount: Scalars['Int']['output'];
  getSiteLabels: DrawerLabelsPagination;
  getSiteSensitiveInfo: DrawerSensitiveInfoPagination;
  getSiteSubsites: SitesSitesPagination;
  getSiteUsers: NewSiteUserPagination;
  getSiteUsersItemsCount: Scalars['Int']['output'];
  getSites: SitePagination;
  getSitesGraph: SitesGraph;
  getSubsiteGraph: SubsiteGraph;
  getTenantList: Maybe<TenantPagination>;
  getTenantSensitiveInfoRefreshStatus: Scalars['String']['output'];
  getUser: User;
  getUserAlerts: ResourceAlertsPagination;
  getUserApps: AppPagination;
  getUserAppsItemsCount: Scalars['Int']['output'];
  getUserFiles: DrawerFilesPagination;
  getUserFilesItemsCount: Scalars['Int']['output'];
  getUserFilterCounts: UserFilterCounts;
  getUserGroups: NewSiteGroupsPagination;
  getUserGroupsGraph: Graph;
  getUserGroupsItemsCount: Scalars['Int']['output'];
  getUserLabels: DrawerLabelsPagination;
  getUserSensitiveInfo: DrawerSensitiveInfoPagination;
  getUserSensitiveInfoItemsCount: Scalars['Int']['output'];
  getUserSites: GetUserSitesPagination;
  getUserSitesItemsCount: Scalars['Int']['output'];
  getUsers: UserPagination;
  searchOrganizations: Maybe<Array<Maybe<SearchOrganization>>>;
  searchResources: SearchResourcesResponse;
};


export type QueryChooseConnectedTenantArgs = {
  clientCallback: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryConnectTenantArgs = {
  clientCallback: InputMaybe<Scalars['String']['input']>;
};


export type QueryDecryptUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDownloadAlertsDataArgs = {
  conditionFilters: InputMaybe<Array<ConditionFilterInput>>;
  filters: InputMaybe<AlertFiltersInput>;
  resourceTypes: InputMaybe<Array<Scalars['String']['input']>>;
  riskLevel: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
  timeFrom: InputMaybe<Scalars['String']['input']>;
  timeTo: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadAppFilesDataArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadAppPermissionsDataArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadAppUsersDataArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetAppUsersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadAppsDataArgs = {
  applicationType: InputMaybe<Array<InputMaybe<GetAppsApplicationEnum>>>;
  approvalStatus: InputMaybe<Array<InputMaybe<GetAppsApprovalStatusEnum>>>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  email: InputMaybe<Scalars['String']['input']>;
  external: InputMaybe<Array<InputMaybe<GetAppsExternalEnum>>>;
  permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publisherStatus: InputMaybe<Array<InputMaybe<GetAppsPublisherStatusEnum>>>;
  sort: InputMaybe<GetAppsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  textUser: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
  userActivity: InputMaybe<Array<InputMaybe<GetAppsActivityEnum>>>;
};


export type QueryDownloadFilesDataArgs = {
  access: InputMaybe<Array<InputMaybe<AccessType>>>;
  additionalResults: InputMaybe<Scalars['Boolean']['input']>;
  createdBy: InputMaybe<Scalars['String']['input']>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  email: InputMaybe<Scalars['String']['input']>;
  fileContainers: InputMaybe<Array<InputMaybe<FileContainerType>>>;
  fileTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filesAccessibleToUser: InputMaybe<Scalars['String']['input']>;
  folderId: InputMaybe<Scalars['ID']['input']>;
  folderName: InputMaybe<Scalars['String']['input']>;
  lastModifiedBy: InputMaybe<Scalars['String']['input']>;
  listType: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort: InputMaybe<GetFilesSortType>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
};


export type QueryDownloadGroupAppsDataArgs = {
  drawerDataId: Scalars['ID']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  groupName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupAppsEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadGroupFilesDataArgs = {
  drawerDataId: Scalars['ID']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  groupName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupFilesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadGroupUsersDataArgs = {
  drawerDataId: Scalars['ID']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  groupName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupMembersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadGroupsDataArgs = {
  access: InputMaybe<Array<GroupAccessType>>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  email: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupsSortType>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
  type: InputMaybe<Array<GroupType>>;
};


export type QueryDownloadGroupsSitesDataArgs = {
  drawerDataId: Scalars['ID']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  groupName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupSitesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadSiteUsersDataArgs = {
  drawerDataId: Scalars['ID']['input'];
  email: InputMaybe<Scalars['String']['input']>;
  permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSiteUsersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryDownloadSitesDataArgs = {
  access: InputMaybe<Array<InputMaybe<GetSitesAccessEnum>>>;
  activity: InputMaybe<Array<InputMaybe<GetSitesActivityEnum>>>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  email: InputMaybe<Scalars['String']['input']>;
  privacy: InputMaybe<Array<InputMaybe<GetSitesPrivacyEnum>>>;
  sort: InputMaybe<GetSitesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
  type: InputMaybe<Array<InputMaybe<GetSitesTypeEnum>>>;
};


export type QueryDownloadUsersDataArgs = {
  dateRange: InputMaybe<UserDateRangeFilterInput>;
  email: InputMaybe<Scalars['String']['input']>;
  isAppUser: InputMaybe<Scalars['Boolean']['input']>;
  licenses: InputMaybe<Array<InputMaybe<GetUsersLicensesEnum>>>;
  sort: InputMaybe<GetUsersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<UserDateTimeFilterInput>;
  type: InputMaybe<Array<InputMaybe<GetUsersTypeEnum>>>;
};


export type QueryGetAiAnswerArgs = {
  input: Scalars['String']['input'];
};


export type QueryGetAccessedGroupsArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAccessingGroupsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAccessingGroupsArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAccessingGroupsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAccountsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAccountsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAlertArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetAlertHistoryArgs = {
  alertId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAlertResourcesArgs = {
  alertName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAlertResourcesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAlertResultsArgs = {
  conditionFilters: InputMaybe<Array<ConditionFilterInput>>;
  filters: InputMaybe<AlertFiltersInput>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  resourceTypes: InputMaybe<Array<Scalars['String']['input']>>;
  riskLevel: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
  timeFrom: InputMaybe<Scalars['String']['input']>;
  timeTo: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAlertsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAlertsSortType>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
};


export type QueryGetAppAlertsArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetResourceAlertsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppFilesArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAppFilesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppFilesItemsCountArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppGroupsArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAppGroupsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppLabelsArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetDrawerLabelsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppPermissionsArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAppPermissionsEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppPermissionsItemsCountArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppSensitiveInfoArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppUsersArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAppUsersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppUsersItemsCountArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAppsArgs = {
  applicationType: InputMaybe<Array<InputMaybe<GetAppsApplicationEnum>>>;
  approvalStatus: InputMaybe<Array<InputMaybe<GetAppsApprovalStatusEnum>>>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  external: InputMaybe<Array<InputMaybe<GetAppsExternalEnum>>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  policyId: InputMaybe<Scalars['ID']['input']>;
  publisherStatus: InputMaybe<Array<InputMaybe<GetAppsPublisherStatusEnum>>>;
  sort: InputMaybe<GetAppsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  textUser: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
  userActivity: InputMaybe<Array<InputMaybe<GetAppsActivityEnum>>>;
};


export type QueryGetAutomationExecutionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAutomationExecutionsArgs = {
  automationType: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform: InputMaybe<Scalars['String']['input']>;
  sourceResourceId: InputMaybe<Scalars['String']['input']>;
  sourceResourceType: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<AutomationStatus>;
  targetResourceId: InputMaybe<Scalars['String']['input']>;
  targetResourceType: InputMaybe<Scalars['String']['input']>;
  triggeredByResourceId: InputMaybe<Scalars['String']['input']>;
  triggeredByResourceType: InputMaybe<Scalars['String']['input']>;
  userId: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileArgs = {
  folderId: Scalars['ID']['input'];
  folderName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileAlertsArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetResourceAlertsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileAppsArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAppsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileAppsItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileDirectAccessArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  type: GetFileDirectAccessEnum;
};


export type QueryGetFileDirectAccessUsersArgs = {
  accessType: GetFileDirectAccessUsersAccessType;
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetFileDirectAccessUsersSortType>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileGraphArgs = {
  fileId: InputMaybe<Scalars['ID']['input']>;
  fileName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileGroupsArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetFileGroupsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Array<GroupType>>;
};


export type QueryGetFileGroupsItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileItemsCountArgs = {
  access: InputMaybe<Array<InputMaybe<AccessType>>>;
  additionalResults: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: InputMaybe<DateRange>;
  createdBy: InputMaybe<Scalars['String']['input']>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  fileContainers: InputMaybe<Array<InputMaybe<FileContainerType>>>;
  fileTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filesAccessibleToUser: InputMaybe<Scalars['String']['input']>;
  folderId: InputMaybe<Scalars['ID']['input']>;
  folderName: InputMaybe<Scalars['String']['input']>;
  labels: InputMaybe<Array<InputMaybe<LabelType>>>;
  lastModifiedBy: InputMaybe<Scalars['String']['input']>;
  listType: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt: InputMaybe<DateRange>;
  sort: InputMaybe<GetFilesSortType>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
};


export type QueryGetFileLinkUsersArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileLinksArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetFileLinksSortType>;
  type: InputMaybe<Array<LinkType>>;
};


export type QueryGetFileLinksItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileSensitiveInfoArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileSensitivityArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileSensitivityLabelsArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetDrawerLabelsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileUsersArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort: InputMaybe<GetFileUsersEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFileUsersItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  fileName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFilesArgs = {
  access: InputMaybe<Array<InputMaybe<AccessType>>>;
  additionalResults: InputMaybe<Scalars['Boolean']['input']>;
  createdAt: InputMaybe<DateRange>;
  createdBy: InputMaybe<Scalars['String']['input']>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  fileContainers: InputMaybe<Array<InputMaybe<FileContainerType>>>;
  fileTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filesAccessibleToUser: InputMaybe<Scalars['String']['input']>;
  folderId: InputMaybe<Scalars['ID']['input']>;
  folderName: InputMaybe<Scalars['String']['input']>;
  labels: InputMaybe<Array<InputMaybe<LabelType>>>;
  lastModifiedBy: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  listType: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  modifiedAt: InputMaybe<DateRange>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetFilesSortType>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
};


export type QueryGetFindingArgs = {
  drawerDataId: Scalars['ID']['input'];
};


export type QueryGetFindingItemsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFindingsArgs = {
  dateRange: InputMaybe<DateRangeFilterInput>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  severity: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showHidden: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
  type: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetGroupArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  groupName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupAlertsArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetResourceAlertsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupAppsArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetGroupAppsEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupAppsItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupFilesArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetGroupFilesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupFilesItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupGraphArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupLabelsArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetDrawerLabelsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupMembersArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetGroupMembersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetGroupMembersItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupSensitiveInfoArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupSitesArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetGroupSitesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupSitesItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  groupName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGroupsArgs = {
  access: InputMaybe<Array<GroupAccessType>>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  policyId: InputMaybe<Scalars['ID']['input']>;
  sort: InputMaybe<GetGroupsSortType>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
  type: InputMaybe<Array<GroupType>>;
};


export type QueryGetGroupsGraphArgs = {
  text: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<GetGroupsGraphTypeEnum>;
};


export type QueryGetLivePolicyPreviewArgs = {
  conditions: Scalars['String']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};


export type QueryGetOnboardingDataArgs = {
  appId: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPoliciesArgs = {
  filters: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetPoliciesSortType>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPolicyArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetPolicyActivityTimelineArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  policyId: Scalars['ID']['input'];
};


export type QueryGetPolicyHistoryArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  policyId: Scalars['ID']['input'];
};


export type QueryGetResourceActivityTimelineArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  resourceId: Scalars['ID']['input'];
  resourceType: Scalars['String']['input'];
};


export type QueryGetSecurityTaskArgs = {
  drawerDataId: Scalars['ID']['input'];
};


export type QueryGetSecurityTasksArgs = {
  assignment: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  hasAutoFix: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  severity: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showHidden: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sort: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  task: InputMaybe<TaskAssignmentFilterInput>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
  type: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetSensitiveDataArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  policyId: InputMaybe<Scalars['ID']['input']>;
  sort: InputMaybe<GetSensitiveInfoSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitiveInfoArgs = {
  drawerDataId: Scalars['ID']['input'];
  sensitiveInfoName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitiveInfoAlertsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetResourceAlertsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitiveInfoAppsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetAppsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitiveInfoFilesArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSensitiveInfoDrawerSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitiveInfoGroupsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupsSortType>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitiveInfoSitesArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSitesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitiveInfoUsersArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetAppUsersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitivityLabelArgs = {
  drawerDataId: Scalars['ID']['input'];
  sensitivityLabelName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitivityLabelAlertsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitivityLabelName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetResourceAlertsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitivityLabelFilesArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitivityLabelName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSensitivityLabelFilesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitivityLabelGroupsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitivityLabelName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupsSortType>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSensitivityLabelsArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  policyId: InputMaybe<Scalars['ID']['input']>;
  sort: InputMaybe<GetSensitivityLabelsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteAlertsArgs = {
  appName: InputMaybe<Scalars['String']['input']>;
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetResourceAlertsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteConfigurationArgs = {
  drawerDataId: Scalars['ID']['input'];
  siteName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteFilesArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSiteFilesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteFilesItemsCountArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteGraphArgs = {
  drawerDataId: Scalars['ID']['input'];
  siteName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteGroupsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSiteGroupsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Array<GroupType>>;
};


export type QueryGetSiteGroupsGraphArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteGroupsItemsCountArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteLabelsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetDrawerLabelsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteSensitiveInfoArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteSubsitesArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSiteSubsitesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteUsersArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteName: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSiteUsersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSiteUsersItemsCountArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  siteName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSitesArgs = {
  access: InputMaybe<Array<InputMaybe<GetSitesAccessEnum>>>;
  activity: InputMaybe<Array<InputMaybe<GetSitesActivityEnum>>>;
  blockedSites: InputMaybe<Array<InputMaybe<BlockedSitesEnum>>>;
  createdAt: InputMaybe<DateRange>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  fullyScannedSites: InputMaybe<Array<InputMaybe<FullyScannedSitesEnum>>>;
  lastActivityAt: InputMaybe<DateRange>;
  limit: InputMaybe<Scalars['Int']['input']>;
  modifiedAt: InputMaybe<DateRange>;
  offset: InputMaybe<Scalars['Int']['input']>;
  orphanedIndicators: InputMaybe<Array<InputMaybe<OrphanedIndicatorsEnum>>>;
  personalSites: InputMaybe<Array<InputMaybe<PersonalSitesEnum>>>;
  policyId: InputMaybe<Scalars['ID']['input']>;
  privacy: InputMaybe<Array<InputMaybe<GetSitesPrivacyEnum>>>;
  sort: InputMaybe<GetSitesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<DateTimeFilterInput>;
  type: InputMaybe<Array<InputMaybe<GetSitesTypeEnum>>>;
  user: InputMaybe<UserType>;
};


export type QueryGetSitesGraphArgs = {
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetSubsiteGraphArgs = {
  drawerDataId: Scalars['ID']['input'];
  siteName: InputMaybe<Scalars['String']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTenantListArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<TenantSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserArgs = {
  drawerDataId: Scalars['ID']['input'];
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserAlertsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetResourceAlertsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  userName: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserAppsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<UserAppsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserAppsItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserFilesArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetUserFilesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserFilesItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserGroupsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetUserGroupsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  type: InputMaybe<Array<GroupType>>;
  username: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetUserGroupsGraphArgs = {
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserGroupsItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserLabelsArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetDrawerLabelsSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserSensitiveInfoArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserSensitiveInfoItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserSitesArgs = {
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetUserSitesSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserSitesItemsCountArgs = {
  drawerDataId: Scalars['ID']['input'];
  text: InputMaybe<Scalars['String']['input']>;
  username: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUsersArgs = {
  dateRange: InputMaybe<UserDateRangeFilterInput>;
  isAppUser: InputMaybe<Scalars['Boolean']['input']>;
  licenses: InputMaybe<Array<InputMaybe<GetUsersLicensesEnum>>>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  policyId: InputMaybe<Scalars['ID']['input']>;
  sort: InputMaybe<GetUsersSortEnum>;
  text: InputMaybe<Scalars['String']['input']>;
  time: InputMaybe<UserDateTimeFilterInput>;
  type: InputMaybe<Array<InputMaybe<GetUsersTypeEnum>>>;
};


export type QuerySearchOrganizationsArgs = {
  searchQuery: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchResourcesArgs = {
  limit: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};

export type ResourceAlertsPagination = {
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<AlertResult>;
};

export enum ResourceRole {
  Source = 'source',
  Target = 'target',
  TriggeredBy = 'triggered_by'
}

export enum ResourceStatus {
  ExitedWithError = 'exited_with_error',
  Idle = 'idle',
  Pending = 'pending',
  Success = 'success'
}

export enum ScanStatus {
  ExitedWithError = 'exited_with_error',
  Fresh = 'fresh',
  Pending = 'pending',
  Updated = 'updated'
}

export type SearchOrganization = {
  id: Maybe<Scalars['String']['output']>;
  label: Maybe<Scalars['String']['output']>;
};

export type SearchResourceNode = {
  displayName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SearchResourcesResponse = {
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<SearchResourceNode>;
};

export type SecurityDescription = {
  color: Maybe<Scalars['String']['output']>;
  link: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type SecurityTask = {
  affectedItemId: Maybe<Scalars['String']['output']>;
  affectedItemName: Maybe<Scalars['String']['output']>;
  assignedBy: Maybe<Scalars['String']['output']>;
  assignedById: Maybe<Scalars['String']['output']>;
  assignedTo: Maybe<Scalars['String']['output']>;
  assignedToId: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  findingId: Maybe<Scalars['String']['output']>;
  graph: Maybe<SecurityTaskGraph>;
  hidden: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  resourceType: Maybe<Scalars['String']['output']>;
  resourceTypeEn: Maybe<Scalars['String']['output']>;
  severity: Maybe<Scalars['Int']['output']>;
  tags: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  taskStatus: Maybe<Scalars['String']['output']>;
};

export type SecurityTaskEdge = {
  from: Scalars['ID']['output'];
  to: Scalars['ID']['output'];
};

export type SecurityTaskGraph = {
  description: Array<SecurityDescription>;
  edges: Array<SecurityTaskEdge>;
  nodes: Array<SecurityTaskNode>;
};

export type SecurityTaskNode = {
  icon: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  users: Maybe<Scalars['Int']['output']>;
};

export type SecurityTasksFilterCounts = {
  all: Maybe<Scalars['Int']['output']>;
  appResource: Maybe<Scalars['Int']['output']>;
  autoAssigned: Maybe<Scalars['Int']['output']>;
  closed: Maybe<Scalars['Int']['output']>;
  createdLast1Day: Scalars['Int']['output'];
  createdLast1Year: Scalars['Int']['output'];
  createdLast7Days: Scalars['Int']['output'];
  createdLast30Days: Scalars['Int']['output'];
  createdLast90Days: Scalars['Int']['output'];
  criticalSeverity: Maybe<Scalars['Int']['output']>;
  driveResource: Maybe<Scalars['Int']['output']>;
  falsePositive: Maybe<Scalars['Int']['output']>;
  fileResource: Maybe<Scalars['Int']['output']>;
  groupResource: Maybe<Scalars['Int']['output']>;
  highSeverity: Maybe<Scalars['Int']['output']>;
  inReview: Maybe<Scalars['Int']['output']>;
  informationSeverity: Maybe<Scalars['Int']['output']>;
  listHidden: Maybe<Scalars['Int']['output']>;
  lowSeverity: Maybe<Scalars['Int']['output']>;
  mediumSeverity: Maybe<Scalars['Int']['output']>;
  modifiedLast1Day: Scalars['Int']['output'];
  modifiedLast1Year: Scalars['Int']['output'];
  modifiedLast7Days: Scalars['Int']['output'];
  modifiedLast30Days: Scalars['Int']['output'];
  modifiedLast90Days: Scalars['Int']['output'];
  open: Maybe<Scalars['Int']['output']>;
  resolved: Maybe<Scalars['Int']['output']>;
  siteResource: Maybe<Scalars['Int']['output']>;
  skipHidden: Maybe<Scalars['Int']['output']>;
  userAssigned: Maybe<Scalars['Int']['output']>;
  userResource: Maybe<Scalars['Int']['output']>;
  waitingForReview: Maybe<Scalars['Int']['output']>;
};

export type SecurityTasksPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<SecurityTask>;
};

export type SensitiveInfo = {
  apps: Maybe<Scalars['Int']['output']>;
  confidenceLevel: Maybe<Scalars['String']['output']>;
  detectionMechanism: Maybe<Scalars['String']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  filesDetectedBy1SecurityPercent: Maybe<Scalars['Float']['output']>;
  filesDetectedByPurviewPercent: Maybe<Scalars['Float']['output']>;
  groups: Maybe<Scalars['Int']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  publisher: Maybe<Scalars['String']['output']>;
  sites: Maybe<Scalars['Int']['output']>;
  users: Maybe<Scalars['Int']['output']>;
};

export type SensitiveInfoAppData = {
  accessFrom: Maybe<Scalars['String']['output']>;
  addInApplication: Maybe<Scalars['Boolean']['output']>;
  approvalStatus: Maybe<Scalars['String']['output']>;
  connected: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  emailsAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  enterpriseApplication: Maybe<Scalars['Boolean']['output']>;
  externalUsers: Maybe<Scalars['Int']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  filesAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  filesWithSensitiveData: Maybe<Scalars['Int']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  firstAdminUser: Maybe<Scalars['String']['output']>;
  groups: Maybe<Scalars['Int']['output']>;
  homepage: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  inactiveUsers: Maybe<Scalars['Int']['output']>;
  lastUsed: Maybe<Scalars['String']['output']>;
  logoUrl: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  permissions: Maybe<Scalars['Int']['output']>;
  publisherName: Maybe<Scalars['String']['output']>;
  registeredApplication: Maybe<Scalars['Boolean']['output']>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivity: Maybe<Scalars['String']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  users: Maybe<Scalars['Int']['output']>;
  usersAccess: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  usersWithAccess: Maybe<Scalars['Int']['output']>;
};

export type SensitiveInfoAppsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SensitiveInfoAppData>;
};

export type SensitiveInfoFileData = {
  detectedBy1Security: Maybe<Scalars['Boolean']['output']>;
  detectedByPurview: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  sharedExternally: Scalars['Int']['output'];
  sharedWithAnyone: Scalars['Int']['output'];
  sharedWithOrganization: Scalars['Boolean']['output'];
  usersWithAccess: Scalars['Int']['output'];
  webUrl: Maybe<Scalars['String']['output']>;
};

export type SensitiveInfoFilesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SensitiveInfoFileData>;
};

export type SensitiveInfoGroupData = {
  accessThrough: Maybe<Array<Scalars['String']['output']>>;
  accessibleFiles: Maybe<Scalars['Int']['output']>;
  accessibleSites: Maybe<Scalars['Int']['output']>;
  containedGroups: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  externalUsers: Maybe<Scalars['Int']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isExternal: Maybe<Scalars['Boolean']['output']>;
  isMemberOfGroups: Maybe<Scalars['Int']['output']>;
  isTeams: Maybe<Scalars['Boolean']['output']>;
  members: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nestedExternalUsers: Maybe<Scalars['Int']['output']>;
  nestedMembers: Maybe<Scalars['Int']['output']>;
  permissions: Maybe<Array<Scalars['String']['output']>>;
  privacy: Maybe<Scalars['String']['output']>;
  roles: Maybe<Array<Scalars['String']['output']>>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  totalExternalUsers: Maybe<Scalars['Int']['output']>;
  totalUsers: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export type SensitiveInfoGroupsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SensitiveInfoGroupData>;
};

export type SensitiveInfoPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<SensitiveInfo>;
};

export type SensitiveInfoSiteData = {
  activity: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  directUsersWithAccess: Maybe<Scalars['Int']['output']>;
  drives: Maybe<Scalars['Int']['output']>;
  externalUsersWithAccess: Maybe<Scalars['Int']['output']>;
  files: Scalars['Int']['output'];
  filesSize: Maybe<Scalars['String']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  groupsWithAccess: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  indirectUsersWithAccess: Maybe<Scalars['Int']['output']>;
  isHubSite: Maybe<Scalars['Boolean']['output']>;
  lastActivity: Maybe<Scalars['String']['output']>;
  lists: Maybe<Scalars['Int']['output']>;
  modifiedAt: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  notebooks: Maybe<Scalars['Int']['output']>;
  owners: Maybe<Scalars['Int']['output']>;
  pages: Maybe<Scalars['Int']['output']>;
  path: Maybe<Scalars['String']['output']>;
  privacy: Maybe<Scalars['String']['output']>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  subsites: Scalars['Int']['output'];
  type: Maybe<Scalars['String']['output']>;
  usersWithAccess: Maybe<Scalars['Int']['output']>;
  webUrl: Maybe<Scalars['String']['output']>;
};

export type SensitiveInfoSitesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SensitiveInfoSiteData>;
};

export type SensitiveInfoUserData = {
  accessibleFiles: Maybe<Scalars['Int']['output']>;
  avatar: Maybe<Scalars['String']['output']>;
  azureRegisteredAt: Maybe<Scalars['String']['output']>;
  canAdminConsent: Maybe<Scalars['Boolean']['output']>;
  connectedApps: Maybe<Scalars['Int']['output']>;
  emailDomain: Maybe<Scalars['String']['output']>;
  hasMfa: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isExternal: Maybe<Scalars['Boolean']['output']>;
  lastSignIn: Maybe<Scalars['String']['output']>;
  licenses: Array<Maybe<Scalars['String']['output']>>;
  signInDisabledAt: Maybe<Scalars['String']['output']>;
  totalGroupMemberships: Maybe<Scalars['Int']['output']>;
  userName: Scalars['String']['output'];
};

export type SensitiveInfoUsersPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SensitiveInfoUserData>;
};

export type SensitivityContent = {
  count: Scalars['Int']['output'];
  sensitivityLevel: Scalars['String']['output'];
};

export type SensitivityDataOccurrences = {
  compliance: Array<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  keyword: Scalars['String']['output'];
};

export type SensitivityLabel = {
  apps: Maybe<Scalars['Int']['output']>;
  color: Maybe<Scalars['String']['output']>;
  contentFormats: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  groups: Maybe<Scalars['Int']['output']>;
  hasProtection: Maybe<Scalars['Boolean']['output']>;
  id: Maybe<Scalars['String']['output']>;
  isActive: Maybe<Scalars['Boolean']['output']>;
  isAppliable: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  priority: Maybe<Scalars['Int']['output']>;
  sites: Maybe<Scalars['Int']['output']>;
  tooltip: Maybe<Scalars['String']['output']>;
  users: Maybe<Scalars['Int']['output']>;
};

export type SensitivityLabelFileData = {
  createdBy: Maybe<Scalars['String']['output']>;
  createdDate: Maybe<Scalars['String']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModified: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path: Maybe<Scalars['String']['output']>;
  sensitivity: Maybe<Scalars['Float']['output']>;
  sharedExternally: Maybe<Scalars['Int']['output']>;
  sharedWithAnyone: Maybe<Scalars['Int']['output']>;
  sharedWithOrganization: Maybe<Scalars['Boolean']['output']>;
  size: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  usersWithAccess: Maybe<Scalars['Int']['output']>;
  webUrl: Maybe<Scalars['String']['output']>;
};

export type SensitivityLabelFilesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SensitivityLabelFileData>;
};

export type SensitivityLabelsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<SensitivityLabel>;
};

export enum SharingCapability {
  Disabled = 'Disabled',
  ExistingExternalUserSharingOnly = 'ExistingExternalUserSharingOnly',
  ExternalUserAndGuestSharing = 'ExternalUserAndGuestSharing',
  ExternalUserSharingOnly = 'ExternalUserSharingOnly'
}

export type Site = {
  activity: Maybe<Scalars['String']['output']>;
  channelType: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  directUsersWithAccess: Maybe<Scalars['Int']['output']>;
  drives: Maybe<Scalars['Int']['output']>;
  externalUsersWithAccess: Maybe<Scalars['Int']['output']>;
  files: Scalars['Int']['output'];
  filesSize: Maybe<Scalars['String']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  groupsWithAccess: Maybe<Scalars['Int']['output']>;
  help: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indirectUsersWithAccess: Maybe<Scalars['Int']['output']>;
  isBlocked: Maybe<Scalars['Boolean']['output']>;
  isChannelSite: Maybe<Scalars['Boolean']['output']>;
  isFullyScanned: Maybe<Scalars['Boolean']['output']>;
  isHubSite: Maybe<Scalars['Boolean']['output']>;
  isTeamsSite: Maybe<Scalars['Boolean']['output']>;
  lastActivity: Maybe<Scalars['String']['output']>;
  link: Maybe<Scalars['String']['output']>;
  lists: Maybe<Scalars['Int']['output']>;
  modifiedAt: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  notebooks: Maybe<Scalars['Int']['output']>;
  owners: Maybe<Scalars['Int']['output']>;
  pages: Maybe<Scalars['Int']['output']>;
  path: Maybe<Scalars['String']['output']>;
  privacy: Maybe<Scalars['String']['output']>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  subsites: Scalars['Int']['output'];
  teamsChannels: Maybe<Scalars['Int']['output']>;
  teamsChannelsPrivate: Maybe<Scalars['Int']['output']>;
  teamsChannelsShared: Maybe<Scalars['Int']['output']>;
  teamsChannelsStandard: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  usersWithAccess: Maybe<Scalars['Int']['output']>;
  webUrl: Maybe<Scalars['String']['output']>;
};

export type SiteConfiguration = {
  anonymousLinkExpirationInDays: Maybe<Scalars['Int']['output']>;
  defaultLinkPermission: Maybe<DefaultLinkPermission>;
  defaultSharingLinkType: Maybe<DefaultSharingLinkType>;
  externalUserExpirationInDays: Maybe<Scalars['Int']['output']>;
  sharingAllowedDomainList: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sharingBlockedDomainList: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sharingCapability: Maybe<SharingCapability>;
};

export type SiteEdgesGraph = {
  group1Id: Scalars['String']['output'];
  group2Id: Scalars['String']['output'];
};

export type SiteFiles = {
  createdAt: Maybe<Scalars['String']['output']>;
  createdBy: Maybe<Scalars['String']['output']>;
  fileSensitivityLabels: Maybe<Scalars['String']['output']>;
  files: Maybe<Scalars['Int']['output']>;
  groupsWithAccess: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  modifiedAt: Maybe<Scalars['String']['output']>;
  modifiedBy: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sharedExternally: Scalars['Int']['output'];
  sharedWithAnyone: Scalars['Int']['output'];
  size: Maybe<Scalars['String']['output']>;
  sourceType: Maybe<Scalars['String']['output']>;
  usersWithAccess: Scalars['Int']['output'];
  usersWithEditAccess: Scalars['Int']['output'];
  webUrl: Maybe<Scalars['String']['output']>;
};

export type SiteFilesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SiteFiles>;
};

export type SiteFilterCounts = {
  accessAll: Scalars['Int']['output'];
  all: Scalars['Int']['output'];
  blockedSites: Scalars['Int']['output'];
  createdLast1Day: Scalars['Int']['output'];
  createdLast1Year: Scalars['Int']['output'];
  createdLast7Days: Scalars['Int']['output'];
  createdLast30Days: Scalars['Int']['output'];
  createdLast90Days: Scalars['Int']['output'];
  externalUsers: Scalars['Int']['output'];
  fullyScannedSites: Scalars['Int']['output'];
  hubsite: Scalars['Int']['output'];
  internalUsers: Scalars['Int']['output'];
  modifiedLast1Day: Scalars['Int']['output'];
  modifiedLast1Year: Scalars['Int']['output'];
  modifiedLast7Days: Scalars['Int']['output'];
  modifiedLast30Days: Scalars['Int']['output'];
  modifiedLast90Days: Scalars['Int']['output'];
  noActivityLastYear: Scalars['Int']['output'];
  noBlockedSites: Scalars['Int']['output'];
  noDirectUsers: Scalars['Int']['output'];
  noFullyScannedSites: Scalars['Int']['output'];
  noOwners: Scalars['Int']['output'];
  noUsers: Scalars['Int']['output'];
  showPersonalSites: Scalars['Int']['output'];
  site: Scalars['Int']['output'];
  subsite: Scalars['Int']['output'];
};

export type SiteGraph = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pathIds: Array<Scalars['ID']['output']>;
  users: Scalars['Int']['output'];
};

export type SiteGroupGraph = {
  edges: Array<GraphEdge>;
  legend: Array<GraphLegend>;
  mainNode: GraphNode;
  nestedNodes: Array<GraphNode>;
  parentNodes: Array<GraphNode>;
};

export type SiteGroupSiteGraph = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SiteGroups = {
  access: Array<Maybe<SiteGroupsAccess>>;
  externalUsers: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type SiteGroupsAccess = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SiteGroupsGraph = {
  edges: Array<SiteEdgesGraph>;
  groups: Array<SiteGroupsGraphGroups>;
  site: SiteGroupSiteGraph;
};

export type SiteGroupsGraphGroups = {
  azureId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type SiteGroupsPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SiteGroups>;
};

export type SitePagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<Site>;
};

export type SiteUser = {
  access: Array<SiteUserAccess>;
  avatar: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isExternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type SiteUserAccess = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SiteUserPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SiteUser>;
};

export type SiteUserPermission = {
  accessThrough: Array<AccessThrough>;
  level: Scalars['String']['output'];
  levelName: Scalars['String']['output'];
  score: Scalars['String']['output'];
};

export type SitesGraph = {
  links: Array<ChartLink>;
  nodes: Array<ChartNode>;
};

export type SitesSites = {
  activity: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['String']['output']>;
  drives: Scalars['Int']['output'];
  externalUsersWithAccess: Scalars['Int']['output'];
  files: Scalars['Int']['output'];
  groupsWithAccess: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inheritsPermissions: Maybe<Scalars['Boolean']['output']>;
  isHubSite: Scalars['Boolean']['output'];
  lastActivity: Maybe<Scalars['String']['output']>;
  lists: Scalars['Int']['output'];
  modifiedAt: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notebooks: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  privacy: Maybe<Scalars['String']['output']>;
  subsiteOf: Maybe<Scalars['String']['output']>;
  subsites: Scalars['Int']['output'];
  usersWithAccess: Scalars['Int']['output'];
};

export type SitesSitesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<SitesSites>;
};

export type Subscription = {
  _: Maybe<Scalars['Boolean']['output']>;
};

export type SubsiteGraph = {
  nodes: Array<SubsiteNode>;
};

export type SubsiteNode = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId: Maybe<Scalars['ID']['output']>;
};

export type TaskAssignmentFilterInput = {
  assignedBy: InputMaybe<Scalars['String']['input']>;
  assignedTo: InputMaybe<Scalars['String']['input']>;
};

export type Tenant = {
  accessToTenantGranted: Maybe<Scalars['Boolean']['output']>;
  appCount: Maybe<Scalars['Int']['output']>;
  domain: Maybe<Scalars['String']['output']>;
  emailDomain: Maybe<Scalars['String']['output']>;
  fileCount: Maybe<Scalars['Int']['output']>;
  filesStatus: Maybe<ResourceStatus>;
  groupCount: Maybe<Scalars['Int']['output']>;
  groupsStatus: Maybe<ResourceStatus>;
  hasValidLicense: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDemo: Maybe<Scalars['Boolean']['output']>;
  lastScannedAt: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  scanStatus: Maybe<ScanStatus>;
  siteCount: Maybe<Scalars['Int']['output']>;
  sitesStatus: Maybe<ResourceStatus>;
  userCount: Maybe<Scalars['Int']['output']>;
  usersStatus: Maybe<ResourceStatus>;
};

export type TenantConfigChecks = {
  hasMSLicense: Maybe<Scalars['Boolean']['output']>;
  hasPermissions: Maybe<Scalars['Boolean']['output']>;
  hasTreeReady: Maybe<Scalars['Boolean']['output']>;
};

export type TenantPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Maybe<Array<Maybe<Tenant>>>;
};

export type TenantResourceScanStatusChecks = {
  apps: Maybe<ResourceStatus>;
  files: Maybe<ResourceStatus>;
  groups: Maybe<ResourceStatus>;
  sites: Maybe<ResourceStatus>;
  users: Maybe<ResourceStatus>;
};

export enum TenantSortEnum {
  AccessToTenantGrantedAsc = 'accessToTenantGrantedAsc',
  AccessToTenantGrantedDesc = 'accessToTenantGrantedDesc',
  AppCountAsc = 'appCountAsc',
  AppCountDesc = 'appCountDesc',
  EmailDomainAsc = 'emailDomainAsc',
  EmailDomainDesc = 'emailDomainDesc',
  FileCountAsc = 'fileCountAsc',
  FileCountDesc = 'fileCountDesc',
  FilesStatusAsc = 'filesStatusAsc',
  FilesStatusDesc = 'filesStatusDesc',
  GroupCountAsc = 'groupCountAsc',
  GroupCountDesc = 'groupCountDesc',
  GroupsStatusAsc = 'groupsStatusAsc',
  GroupsStatusDesc = 'groupsStatusDesc',
  HasValidLicenseAsc = 'hasValidLicenseAsc',
  HasValidLicenseDesc = 'hasValidLicenseDesc',
  LastScannedAtAsc = 'lastScannedAtAsc',
  LastScannedAtDesc = 'lastScannedAtDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  ScanStatusAsc = 'scanStatusAsc',
  ScanStatusDesc = 'scanStatusDesc',
  SiteCountAsc = 'siteCountAsc',
  SiteCountDesc = 'siteCountDesc',
  SitesStatusAsc = 'sitesStatusAsc',
  SitesStatusDesc = 'sitesStatusDesc',
  UserCountAsc = 'userCountAsc',
  UserCountDesc = 'userCountDesc',
  UsersStatusAsc = 'usersStatusAsc',
  UsersStatusDesc = 'usersStatusDesc'
}

export type TenantUser = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum TimeFilter {
  AnyTime = 'anyTime',
  Last1Day = 'last1Day',
  Last1Year = 'last1Year',
  Last7Days = 'last7Days',
  Last30Days = 'last30Days',
  Last90Days = 'last90Days'
}

export type Tokens = {
  access_token: Maybe<Scalars['String']['output']>;
  refresh_token: Maybe<Scalars['String']['output']>;
};

export type User = {
  accessibleFiles: Maybe<Scalars['Int']['output']>;
  avatar: Maybe<Scalars['String']['output']>;
  azureId: Scalars['ID']['output'];
  azureRegisteredAt: Maybe<Scalars['String']['output']>;
  canAdminConsent: Maybe<Scalars['Boolean']['output']>;
  connectedApps: Maybe<Scalars['Int']['output']>;
  description: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailDomain: Maybe<Scalars['String']['output']>;
  filesWithSensitiveData: Maybe<Scalars['Int']['output']>;
  filesWithSensitivityLabels: Maybe<Scalars['Int']['output']>;
  groups: Maybe<Array<Maybe<Group>>>;
  hasMfa: Maybe<Scalars['Boolean']['output']>;
  hasSignedIn: Maybe<Scalars['Boolean']['output']>;
  help: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin: Maybe<Scalars['Boolean']['output']>;
  isExternal: Scalars['Boolean']['output'];
  lastSignIn: Maybe<Scalars['String']['output']>;
  licenses: Array<Maybe<Scalars['String']['output']>>;
  link: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  permissions: Array<Maybe<Scalars['String']['output']>>;
  roles: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sensitiveInfo: Maybe<Scalars['Int']['output']>;
  sensitivityLabels: Maybe<Scalars['Int']['output']>;
  signInDisabledAt: Maybe<Scalars['String']['output']>;
  sites: Maybe<Scalars['Int']['output']>;
  totalGroupMemberships: Maybe<Scalars['Int']['output']>;
  totalSensitivityScore: Maybe<Scalars['Float']['output']>;
  userName: Scalars['String']['output'];
};

export type UserApp = {
  accessibleFiles: Maybe<Scalars['Int']['output']>;
  avatar: Maybe<Scalars['String']['output']>;
  azureRegisteredAt: Maybe<Scalars['String']['output']>;
  canAdminConsent: Maybe<Scalars['Boolean']['output']>;
  connectedApps: Maybe<Scalars['Int']['output']>;
  emailDomain: Maybe<Scalars['String']['output']>;
  hasMfa: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isExternal: Maybe<Scalars['Boolean']['output']>;
  lastSignIn: Maybe<Scalars['String']['output']>;
  licenses: Array<Maybe<Scalars['String']['output']>>;
  signInDisabledAt: Maybe<Scalars['String']['output']>;
  totalGroupMemberships: Maybe<Scalars['Int']['output']>;
  userName: Scalars['String']['output'];
};

export enum UserAppsSortEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc'
}

export type UserAzure = {
  displayName: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  name: Maybe<Scalars['String']['output']>;
  originId: Maybe<Scalars['String']['output']>;
};

export type UserAzureObject = {
  siteUser: Maybe<UserAzure>;
  user: Maybe<UserAzure>;
};

export type UserDateRangeFilterInput = {
  createdAt: InputMaybe<DateRange>;
  lastSignIn: InputMaybe<DateRange>;
};

export type UserDateTimeFilterInput = {
  createdAt: InputMaybe<TimeFilter>;
  lastSignIn: InputMaybe<TimeFilter>;
};

export type UserFiles = {
  files: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  sharedExternally: Scalars['Boolean']['output'];
  sharedWithAnyone: Scalars['Boolean']['output'];
  size: Maybe<Scalars['Int']['output']>;
  sourceType: Maybe<Scalars['String']['output']>;
  usersWithAccess: Scalars['Int']['output'];
  webUrl: Maybe<Scalars['String']['output']>;
};

export type UserFilesPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  nodes: Array<UserFiles>;
};

export type UserFilterCounts = {
  all: Scalars['Int']['output'];
  createdLast1Day: Scalars['Int']['output'];
  createdLast1Year: Scalars['Int']['output'];
  createdLast7Days: Scalars['Int']['output'];
  createdLast30Days: Scalars['Int']['output'];
  createdLast90Days: Scalars['Int']['output'];
  externalUsers: Scalars['Int']['output'];
  internalUsers: Scalars['Int']['output'];
  lastSignIn1Day: Scalars['Int']['output'];
  lastSignIn1Year: Scalars['Int']['output'];
  lastSignIn7Days: Scalars['Int']['output'];
  lastSignIn30Days: Scalars['Int']['output'];
  lastSignIn90Days: Scalars['Int']['output'];
  noLicense: Scalars['Int']['output'];
  withLicense: Scalars['Int']['output'];
};

export type UserPagination = {
  hasNextPage: Maybe<Scalars['Boolean']['output']>;
  itemsFound: Maybe<Scalars['Int']['output']>;
  nodes: Array<User>;
  numOfCompanyUsers: Scalars['Int']['output'];
  numOfExternalUsers: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  User = 'USER'
}

export type UserSite = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<PermissionObject>;
};

export type UserType = {
  createdBy: InputMaybe<Scalars['String']['input']>;
  filesAccessibleToUser: InputMaybe<Scalars['String']['input']>;
  lastModifiedBy: InputMaybe<Scalars['String']['input']>;
};

export type VerifyResponse = {
  email: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum GetAppGroupsSortEnum {
  ExternalUsersAsc = 'externalUsersAsc',
  ExternalUsersDesc = 'externalUsersDesc',
  MembersAsc = 'membersAsc',
  MembersDesc = 'membersDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  TotalUsersAsc = 'totalUsersAsc',
  TotalUsersDesc = 'totalUsersDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc'
}

export enum GetFileGroupsSortEnum {
  AccessThroughAsc = 'accessThroughAsc',
  AccessThroughDesc = 'accessThroughDesc',
  DirectExternalUsersAsc = 'directExternalUsersAsc',
  DirectExternalUsersDesc = 'directExternalUsersDesc',
  DirectInternalUsersAsc = 'directInternalUsersAsc',
  DirectInternalUsersDesc = 'directInternalUsersDesc',
  HighestSitePermissionAsc = 'highestSitePermissionAsc',
  HighestSitePermissionDesc = 'highestSitePermissionDesc',
  IndirectExternalUsersAsc = 'indirectExternalUsersAsc',
  IndirectExternalUsersDesc = 'indirectExternalUsersDesc',
  IndirectInternalUsersAsc = 'indirectInternalUsersAsc',
  IndirectInternalUsersDesc = 'indirectInternalUsersDesc',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  SensitivityAsc = 'sensitivityAsc',
  SensitivityDesc = 'sensitivityDesc',
  SensitivityLabelsAsc = 'sensitivityLabelsAsc',
  SensitivityLabelsDesc = 'sensitivityLabelsDesc',
  TotalDirectUsersAsc = 'totalDirectUsersAsc',
  TotalDirectUsersDesc = 'totalDirectUsersDesc',
  TotalIndirectUsersAsc = 'totalIndirectUsersAsc',
  TotalIndirectUsersDesc = 'totalIndirectUsersDesc',
  TotalUsersWithAccessAsc = 'totalUsersWithAccessAsc',
  TotalUsersWithAccessDesc = 'totalUsersWithAccessDesc',
  TypeAsc = 'typeAsc',
  TypeDesc = 'typeDesc'
}

export enum GetFileSensitivityLabelsSortEnum {
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc'
}

export type ActivateSensitiveInfoMutationVariables = Exact<{
  sensitiveInfoIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type ActivateSensitiveInfoMutation = { activateSensitiveInfo: boolean };

export type AssignMsOfficeLicenseMutationVariables = Exact<{ [key: string]: never; }>;


export type AssignMsOfficeLicenseMutation = { assignMSOfficeLicense: boolean | null };

export type CheckTenantConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckTenantConfigQuery = { checkTenantConfig: { hasMSLicense: boolean | null, hasPermissions: boolean | null, hasTreeReady: boolean | null } | null };

export type ChooseConnectedTenantQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  clientCallback: InputMaybe<Scalars['String']['input']>;
}>;


export type ChooseConnectedTenantQuery = { chooseConnectedTenant: string | null };

export type ConnectTenantQueryVariables = Exact<{
  clientCallback: InputMaybe<Scalars['String']['input']>;
}>;


export type ConnectTenantQuery = { connectTenant: string | null };

export type CreatePolicyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  conditions: InputMaybe<Scalars['String']['input']>;
  automations: InputMaybe<Scalars['String']['input']>;
  selectedResources: InputMaybe<Scalars['String']['input']>;
  severity: Scalars['String']['input'];
  type: Scalars['String']['input'];
  assignment: InputMaybe<Scalars['String']['input']>;
  defaultUser: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePolicyMutation = { createPolicy: boolean };

export type DeactivateSensitiveInfoMutationVariables = Exact<{
  sensitiveInfoIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeactivateSensitiveInfoMutation = { deactivateSensitiveInfo: boolean };

export type DownloadAlertsDataQueryVariables = Exact<{
  resourceTypes: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  conditionFilters: InputMaybe<Array<ConditionFilterInput> | ConditionFilterInput>;
  timeFrom: InputMaybe<Scalars['String']['input']>;
  timeTo: InputMaybe<Scalars['String']['input']>;
  riskLevel: InputMaybe<Scalars['String']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<AlertFiltersInput>;
}>;


export type DownloadAlertsDataQuery = { downloadAlertsData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadAppFilesDataQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  usersSearch: InputMaybe<Scalars['String']['input']>;
  appName: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadAppFilesDataQuery = { downloadAppFilesData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadAppPermissionsDataQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  usersSearch: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadAppPermissionsDataQuery = { downloadAppPermissionsData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadAppUsersDataQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  usersSearch: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadAppUsersDataQuery = { downloadAppUsersData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadAppsDataQueryVariables = Exact<{
  sort: InputMaybe<GetAppsSortEnum>;
  search: InputMaybe<Scalars['String']['input']>;
  textUser: InputMaybe<Scalars['String']['input']>;
  approvalStatus: InputMaybe<Array<InputMaybe<GetAppsApprovalStatusEnum>> | InputMaybe<GetAppsApprovalStatusEnum>>;
  publisherStatus: InputMaybe<Array<InputMaybe<GetAppsPublisherStatusEnum>> | InputMaybe<GetAppsPublisherStatusEnum>>;
  userActivity: InputMaybe<Array<InputMaybe<GetAppsActivityEnum>> | InputMaybe<GetAppsActivityEnum>>;
  permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  external: InputMaybe<Array<InputMaybe<GetAppsExternalEnum>> | InputMaybe<GetAppsExternalEnum>>;
  applicationType: InputMaybe<Array<InputMaybe<GetAppsApplicationEnum>> | InputMaybe<GetAppsApplicationEnum>>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadAppsDataQuery = { downloadAppsData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadFilesDataQueryVariables = Exact<{
  folderId: InputMaybe<Scalars['ID']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  additionalResults: InputMaybe<Scalars['Boolean']['input']>;
  sort: InputMaybe<GetFilesSortType>;
  access: InputMaybe<Array<InputMaybe<AccessType>> | InputMaybe<AccessType>>;
  fileTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  fileContainers: InputMaybe<Array<InputMaybe<FileContainerType>> | InputMaybe<FileContainerType>>;
  createdBy: InputMaybe<Scalars['String']['input']>;
  lastModifiedBy: InputMaybe<Scalars['String']['input']>;
  filesAccessibleToUser: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  listType: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadFilesDataQuery = { downloadFilesData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadGroupAppsDataQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  groupAppsSearch: InputMaybe<Scalars['String']['input']>;
  groupAppsSort: InputMaybe<GetGroupAppsEnum>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadGroupAppsDataQuery = { downloadGroupAppsData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadGroupFilesDataQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  groupFilesCompactSearch: InputMaybe<Scalars['String']['input']>;
  groupFilesCompactSort: InputMaybe<GetGroupFilesSortEnum>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadGroupFilesDataQuery = { downloadGroupFilesData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadGroupsSitesDataQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  groupSitesCompactSearch: InputMaybe<Scalars['String']['input']>;
  groupSitesCompactSort: InputMaybe<GetGroupSitesSortEnum>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadGroupsSitesDataQuery = { downloadGroupsSitesData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadGroupUsersDataQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  groupMembersSearch: InputMaybe<Scalars['String']['input']>;
  groupMembersSort: InputMaybe<GetGroupMembersSortEnum>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadGroupUsersDataQuery = { downloadGroupUsersData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadGroupsDataQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupsSortType>;
  access: InputMaybe<Array<GroupAccessType> | GroupAccessType>;
  type: InputMaybe<Array<GroupType> | GroupType>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadGroupsDataQuery = { downloadGroupsData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadSiteUsersDataQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  siteAccessSearch: InputMaybe<Scalars['String']['input']>;
  siteAccessSort: InputMaybe<GetSiteUsersSortEnum>;
  drawerFilterTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadSiteUsersDataQuery = { downloadSiteUsersData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadSitesDataQueryVariables = Exact<{
  sort: InputMaybe<GetSitesSortEnum>;
  type: InputMaybe<Array<InputMaybe<GetSitesTypeEnum>> | InputMaybe<GetSitesTypeEnum>>;
  search: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadSitesDataQuery = { downloadSitesData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type DownloadUsersDataQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetUsersSortEnum>;
  type: InputMaybe<Array<InputMaybe<GetUsersTypeEnum>> | InputMaybe<GetUsersTypeEnum>>;
  isAppUser: InputMaybe<Scalars['Boolean']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadUsersDataQuery = { downloadUsersData: { base64: string | null, fileName: string | null, success: boolean | null } };

export type EditAlertMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  severity: InputMaybe<Scalars['String']['input']>;
  status: InputMaybe<Scalars['String']['input']>;
  assignedUser: InputMaybe<Scalars['String']['input']>;
  isResolved: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditAlertMutation = { editAlert: boolean };

export type EditPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  conditions: InputMaybe<Scalars['String']['input']>;
  automations: InputMaybe<Scalars['String']['input']>;
  selectedResources: InputMaybe<Scalars['String']['input']>;
  severity: Scalars['String']['input'];
  type: Scalars['String']['input'];
  assignment: InputMaybe<Scalars['String']['input']>;
  defaultUser: InputMaybe<Scalars['String']['input']>;
}>;


export type EditPolicyMutation = { editPolicy: boolean };

export type GetAccessedGroupsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  groupAccessedGroupsCompactSearch: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetAccessingGroupsSortEnum>;
}>;


export type GetAccessedGroupsQuery = { getAccessedGroups: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, type: string, usersWithAccess: number, isExternal: boolean }> } };

export type GetAccessingGroupsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  groupAccessingGroupsCompactSearch: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetAccessingGroupsSortEnum>;
}>;


export type GetAccessingGroupsQuery = { getAccessingGroups: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, type: string, usersWithAccess: number, isExternal: boolean }> } };

export type GetAccountOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountOrganizationsQuery = { getAccountOrganizations: Array<{ id: string | null, name: string | null } | null> | null };

export type GetAccountUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountUsersQuery = { getAccountUsers: Array<{ id: string, name: string, email: string, tenantId: string, tenantEmailDomain: string } | null> | null };

export type GetAccountsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetAccountsSortEnum>;
}>;


export type GetAccountsQuery = { getAccounts: { itemsFound: number | null, hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, email: string, isInvite: boolean }> } };

export type GetActiveSensitiveDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveSensitiveDataQuery = { getActiveSensitiveData: Array<string | null> };

export type GetAlertQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetAlertQuery = { getAlert: { id: string, name: string, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null, isResolved: boolean | null, type: string | null, snoozedAt: string | null, resourceCount: number | null, assignedUser: string | null, createdFrom: string | null, description: string | null } };

export type GetAlertHistoryQueryVariables = Exact<{
  alertId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAlertHistoryQuery = { getAlertHistory: { hasNextPage: boolean, nodes: Array<{ id: string, description: string | null, action: string | null, previousState: string | null, newState: string | null, createdAt: string | null, userName: string | null, userEmail: string | null }> } };

export type GetAlertResourcesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  alertResourcesListSearch: InputMaybe<Scalars['String']['input']>;
  alertName: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetAlertResourcesSortEnum>;
}>;


export type GetAlertResourcesQuery = { getAlertResources: { hasNextPage: boolean, nodes: Array<{ id: string | null, name: string | null, type: string | null, isResolved: boolean | null, status: string | null, resolvedAt: string | null, snoozedAt: string | null, createdAt: string | null }> } };

export type GetAlertsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAlertsSortType>;
  search: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAlertsQuery = { getAlerts: { hasNextPage: boolean | null, itemsFound: number | null, nodes: Array<{ id: string, name: string, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null, isResolved: boolean | null, type: string | null, snoozedAt: string | null, resourceCount: number | null, assignedUser: string | null, createdFrom: string | null }> } };

export type GetAllConnectedTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllConnectedTenantsQuery = { getAllConnectedTenants: Array<{ id: string, name: string | null, emailDomain: string | null, isDemo: boolean | null } | null> | null };

export type GetAppQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetAppQuery = { getApp: { id: string | null, name: string | null, logoUrl: string | null, homepage: string | null, publisherName: string | null, description: string | null, registeredApplication: boolean | null, enterpriseApplication: boolean | null, files: number | null, usersWithAccess: number | null, sensitiveInfo: number | null, groups: number | null, permissions: number | null } };

export type GetAppAlertsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  appFilesListSearch: InputMaybe<Scalars['String']['input']>;
  appName: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetResourceAlertsSortEnum>;
}>;


export type GetAppAlertsQuery = { getAppAlerts: { hasNextPage: boolean, nodes: Array<{ id: string, name: string | null, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null }> } };

export type GetAppFilesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  appFilesListSearch: InputMaybe<Scalars['String']['input']>;
  appName: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetAppFilesSortEnum>;
}>;


export type GetAppFilesQuery = { getAppFiles: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, sensitivity: number | null, size: string | null, files: number | null, lastModified: string | null, createdDate: string | null, webUrl: string | null, createdBy: string | null, modifiedBy: string | null, type: string | null, fileSensitivityLabels: string | null }> } };

export type GetAppFilterCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppFilterCountsQuery = { getAppFilterCounts: { all: number | null, directory: number | null, email: number | null, sites: number | null, applications: number | null, auditLogs: number | null, chat: number | null, files: number | null, groups: number | null, connected1Day: number | null, connected7Days: number | null, connected30Days: number | null, connected90Days: number | null, connected1Year: number | null, lastUsed1Day: number | null, lastUsed7Days: number | null, lastUsed30Days: number | null, lastUsed90Days: number | null, lastUsed1Year: number | null, externalUsers: number | null, internalUsers: number | null, inactiveUsers: number | null, activeUsers: number | null, approved: number | null, waitingForReview: number | null, notPermitted: number | null, verified: number | null, unverified: number | null, enterprise: number | null, appRegistration: number | null, addIn: number | null } };

export type GetAppGroupsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  appGroupListSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetAppGroupsSortEnum>;
}>;


export type GetAppGroupsQuery = { getAppGroups: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, type: string | null, internalUsers: number | null, externalUsers: number | null, totalUsers: number | null, groupSensitivityLabels: string | null }> } };

export type GetAppPermissionsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  appPermissionsListSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetAppPermissionsEnum>;
}>;


export type GetAppPermissionsQuery = { getAppPermissions: { hasNextPage: boolean | null, nodes: Array<{ name: string | null, isConsentRequired: boolean | null, type: string | null, apiName: string | null, description: string | null }> } };

export type GetAppSensitiveInfoQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  appSensitiveInfoListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
}>;


export type GetAppSensitiveInfoQuery = { getAppSensitiveInfo: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetAppUsersQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  usersSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetAppUsersSortEnum>;
}>;


export type GetAppUsersQuery = { getAppUsers: { hasNextPage: boolean | null, nodes: Array<{ id: string, userName: string, avatar: string | null, emailDomain: string | null, isExternal: boolean | null, signInDisabledAt: string | null, azureRegisteredAt: string | null, canAdminConsent: boolean | null, connectedApps: number | null, accessibleFiles: number | null, totalGroupMemberships: number | null, licenses: Array<string | null>, lastSignIn: string | null, hasMfa: boolean | null }> } };

export type GetAppsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetAppsSortEnum>;
  search: InputMaybe<Scalars['String']['input']>;
  textUser: InputMaybe<Scalars['String']['input']>;
  approvalStatus: InputMaybe<Array<InputMaybe<GetAppsApprovalStatusEnum>> | InputMaybe<GetAppsApprovalStatusEnum>>;
  publisherStatus: InputMaybe<Array<InputMaybe<GetAppsPublisherStatusEnum>> | InputMaybe<GetAppsPublisherStatusEnum>>;
  userActivity: InputMaybe<Array<InputMaybe<GetAppsActivityEnum>> | InputMaybe<GetAppsActivityEnum>>;
  permissions: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  external: InputMaybe<Array<InputMaybe<GetAppsExternalEnum>> | InputMaybe<GetAppsExternalEnum>>;
  applicationType: InputMaybe<Array<InputMaybe<GetAppsApplicationEnum>> | InputMaybe<GetAppsApplicationEnum>>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAppsQuery = { getApps: { itemsFound: number | null, hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, logoUrl: string | null, connected: string | null, lastUsed: string | null, users: number | null, inactiveUsers: number | null, externalUsers: number | null, approvalStatus: string | null, firstAdminUser: string | null, registeredApplication: boolean | null, enterpriseApplication: boolean | null, addInApplication: boolean | null, filesAccess: Array<string | null> | null, usersAccess: Array<string | null> | null, emailsAccess: Array<string | null> | null, homepage: string | null, publisherName: string | null, description: string | null, files: number | null, sensitivityLabels: number | null, filesWithSensitivityLabels: number | null, sensitiveInfo: number | null }> } };

export type GetAppLabelsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  appLabelsListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerLabelsSortEnum>;
}>;


export type GetAppLabelsQuery = { getAppLabels: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, description: string | null, color: string | null, contentFormats: string | null, hasProtection: boolean, isActive: boolean, isAppliable: boolean, sensitivity: number | null, tooltip: string | null, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetCurrentOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentOrganizationQuery = { getCurrentOrganization: { id: string | null, name: string | null, accessType: string | null } | null };

export type GetCurrentTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentTenantQuery = { getCurrentTenant: { id: string, name: string | null, emailDomain: string | null, scanStatus: ScanStatus | null, isDemo: boolean | null, lastScannedAt: string | null } | null };

export type GetCurrentTenantAzureIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentTenantAzureIdQuery = { getCurrentTenantAzureId: string | null };

export type GetFileQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetFileQuery = { getFile: { id: string | null, name: string | null, size: number | null, type: string | null, description: string | null, help: string | null, level: number | null, parentId: string | null, shareLink: string | null, webUrl: string | null, sourceType: string | null, createdDate: string | null, lastModified: string | null, tenantId: string | null, sharedExternally: number | null, sharedWithAnyone: number | null, usersWithAccess: number | null, files: number | null, sensitivity: number | null, topFileSensitivity: number | null, groupsWithAccess: number | null, links: number | null, sensitivityLabels: number | null, sensitiveData: number | null, apps: number | null, createdBy: { user: { id: string | null, originId: string | null, name: string | null, displayName: string | null, email: string | null } | null } | null, lastModifiedBy: { user: { id: string | null, originId: string | null, displayName: string | null, email: string | null } | null } | null, path: Array<{ id: string | null, name: string | null }> } };

export type GetFileAlertsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  fileAppsSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetResourceAlertsSortEnum>;
}>;


export type GetFileAlertsQuery = { getFileAlerts: { hasNextPage: boolean, nodes: Array<{ id: string, name: string | null, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null }> } };

export type GetFileAppsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  fileAppsSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetAppsSortEnum>;
}>;


export type GetFileAppsQuery = { getFileApps: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, connected: string | null, users: number | null, externalUsers: number | null, firstAdminUser: string | null, filesAccess: Array<string | null> | null, usersAccess: Array<string | null> | null, emailsAccess: Array<string | null> | null, logoUrl: string | null, sensitivity: string | null, files: number | null }> } };

export type GetFileDirectAccessUsersQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  accessType: GetFileDirectAccessUsersAccessType;
}>;


export type GetFileDirectAccessUsersQuery = { getFileDirectAccessUsers: { hasNextPage: boolean | null, nodes: Array<{ id: string, userName: string, isExternal: boolean, email: string, emailDomain: string }> } };

export type GetFileFilterCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFileFilterCountsQuery = { getFileFilterCounts: { all: number | null, allFiles: number | null, externalUsers: number | null, sharedWithAnyone: number | null, sharedWithOrganization: number | null, internalUsers: number | null, allMicrosoft: number | null, allStandard: number | null, word: number | null, sheet: number | null, slides: number | null, onenote: number | null, list: number | null, whiteboard: number | null, pdf: number | null, image: number | null, videos: number | null, audio: number | null, archives: number | null, other: number | null, folders: number | null, allSites: number | null, personalOneDriveSites: number | null, sharePointSites: number | null, sharePointSubSites: number | null, sharePointHubSites: number | null, allDrives: number | null, allContainers: number | null, oneDriveDrives: number | null, sharePointDrives: number | null, sharePointSystemDocumentLibrary: number | null, sharePointSystemPageLibrary: number | null, oneDrive: number | null, sharePoint: number | null, createdLast1Day: number | null, createdLast7Days: number | null, createdLast30Days: number | null, createdLast90Days: number | null, createdLast1Year: number | null, modifiedLast1Day: number | null, modifiedLast7Days: number | null, modifiedLast30Days: number | null, modifiedLast90Days: number | null, modifiedLast1Year: number | null, appsWithAccess: number | null, withLabel: number | null, withoutLabel: number | null } };

export type GetFileGraphQueryVariables = Exact<{
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFileGraphQuery = { getFileGraph: { nodes: Array<{ id: string, name: string, type: string, page: string | null, resource: string | null, drawerDataId: string | null, icon: string, color: string | null, users: string | null, files: string | null, groups: string | null, filters: { permissions: Array<string | null> | null, type: Array<string | null> | null } | null }>, edges: Array<{ from: string, to: string }>, legend: Array<{ name: string | null, color: string, icon: string, type: string | null }> } };

export type GetFileGroupsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  fileGroupsListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetFileGroupsSortEnum>;
  drawerFilterTypes: InputMaybe<Array<GroupType> | GroupType>;
}>;


export type GetFileGroupsQuery = { getFileGroups: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, type: string | null, highestSitePermission: string | null, indirectInternalUsers: number | null, indirectExternalUsers: number | null, totalIndirectUsers: number | null, directInternalUsers: number | null, directExternalUsers: number | null, totalDirectUsers: number | null, totalUsers: number | null, accessThrough: Array<string | null> | null, groupSensitivityLabels: string | null }> } };

export type GetFileItemsCountQueryVariables = Exact<{
  folderId: InputMaybe<Scalars['ID']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  additionalResults: InputMaybe<Scalars['Boolean']['input']>;
  sort: InputMaybe<GetFilesSortType>;
  access: InputMaybe<Array<InputMaybe<AccessType>> | InputMaybe<AccessType>>;
  fileTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  fileContainers: InputMaybe<Array<InputMaybe<FileContainerType>> | InputMaybe<FileContainerType>>;
  createdBy: InputMaybe<Scalars['String']['input']>;
  lastModifiedBy: InputMaybe<Scalars['String']['input']>;
  filesAccessibleToUser: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  listType: InputMaybe<Scalars['String']['input']>;
  labels: InputMaybe<Array<InputMaybe<LabelType>> | InputMaybe<LabelType>>;
  createdAt: InputMaybe<DateRange>;
  modifiedAt: InputMaybe<DateRange>;
}>;


export type GetFileItemsCountQuery = { getFileItemsCount: number };

export type GetFileLinkUsersQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetFileLinkUsersQuery = { getFileLinkUsers: { hasNextPage: boolean | null, nodes: Array<{ id: string, userName: string, isExternal: boolean, email: string, emailDomain: string }> } };

export type GetFileLinksQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetFileLinksSortType>;
  drawerFilterTypes: InputMaybe<Array<LinkType> | LinkType>;
}>;


export type GetFileLinksQuery = { getFileLinks: { hasNextPage: boolean | null, nodes: Array<{ id: string, type: string, webUrl: string, usersWithAccess: number, externalUsersWithAccess: number, groupsWithAccess: number, sharedWithAnyone: boolean, sharedWithEveryoneExceptExternalUsers: boolean, passwordRequired: boolean | null, accessRevoked: string | null }> } };

export type GetFileSensitiveInfoQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  fileSensitiveInfoListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
}>;


export type GetFileSensitiveInfoQuery = { getFileSensitiveInfo: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetFileSensitivityLabelsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  fileLabelsListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerLabelsSortEnum>;
}>;


export type GetFileSensitivityLabelsQuery = { getFileSensitivityLabels: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, color: string | null, contentFormats: string | null, description: string | null, hasProtection: boolean | null, isActive: boolean | null, isAppliable: boolean | null, priority: number | null, tooltip: string | null, sites: number | null, groups: number | null, files: number | null, users: number | null, apps: number | null }> } };

export type GetFileUsersQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  fileUsersSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetFileUsersEnum>;
  drawerFilterTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetFileUsersQuery = { getFileUsers: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, avatar: string | null, emailDomain: string | null, isExternal: boolean | null, signInDisabledAt: string | null, azureRegisteredAt: string | null, canAdminConsent: boolean | null, connectedApps: number | null, accessibleFiles: number | null, totalGroupMemberships: number | null, licenses: Array<string | null>, lastSignIn: string | null, hasMfa: boolean | null, permissions: Array<{ permission: string, accessThrough: Array<{ id: string | null, type: string | null, name: string | null }> }> }> } };

export type GetFilesQueryVariables = Exact<{
  folderId: InputMaybe<Scalars['ID']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  additionalResults: InputMaybe<Scalars['Boolean']['input']>;
  sort: InputMaybe<GetFilesSortType>;
  access: InputMaybe<Array<InputMaybe<AccessType>> | InputMaybe<AccessType>>;
  fileTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  fileContainers: InputMaybe<Array<InputMaybe<FileContainerType>> | InputMaybe<FileContainerType>>;
  createdBy: InputMaybe<Scalars['String']['input']>;
  lastModifiedBy: InputMaybe<Scalars['String']['input']>;
  filesAccessibleToUser: InputMaybe<Scalars['String']['input']>;
  location: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  listType: InputMaybe<Scalars['String']['input']>;
  labels: InputMaybe<Array<InputMaybe<LabelType>> | InputMaybe<LabelType>>;
  createdAt: InputMaybe<DateRange>;
  modifiedAt: InputMaybe<DateRange>;
}>;


export type GetFilesQuery = { getFiles: { itemsFound: number | null, hasNextPage: boolean | null, path: Array<{ id: string | null, name: string | null }>, nodes: Array<{ id: string | null, name: string | null, size: string | null, type: string | null, path: string | null, level: number | null, parentId: string | null, shareLink: string | null, webUrl: string | null, sourceType: string | null, createdDate: string | null, lastModified: string | null, tenantId: string | null, externalUsersWithAccess: number | null, sharedExternally: number | null, sharedWithAnyone: number | null, usersWithAccess: number | null, usersWithEditAccess: number | null, groupsWithAccess: number | null, files: number | null, sensitivity: number | null, topFileSensitivity: number | null, appsWithAccess: number | null, sharedWithOrganization: boolean | null, filesWithSensitivityLabels: number | null, sensitivityLabels: number | null, sensitiveInfo: number | null, createdBy: { user: { id: string | null, originId: string | null, name: string | null, displayName: string | null, email: string | null } | null } | null, lastModifiedBy: { user: { id: string | null, originId: string | null, displayName: string | null, email: string | null } | null } | null, sensitivityContentFiles: Array<{ sensitivityLevel: string, count: number } | null> | null, sensitivityInformationDistribution: Array<{ sensitivityType: string, count: number } | null> | null }> } };

export type GetFindingQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetFindingQuery = { getFinding: { id: string | null, name: string | null, description: string | null, resourceType: string | null, tenantId: string | null, affectedItems: number | null, severity: number | null, tags: Array<string | null> | null, isHidden: boolean | null } };

export type GetFindingsFilterCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFindingsFilterCountQuery = { getFindingsFilterCount: { all: number | null, appResource: number | null, userResource: number | null, groupResource: number | null, fileResource: number | null, siteResource: number | null, driveResource: number | null, lowSeverity: number | null, mediumSeverity: number | null, highSeverity: number | null, criticalSeverity: number | null, informationSeverity: number | null, createdLast1Day: number, createdLast7Days: number, createdLast30Days: number, createdLast90Days: number, createdLast1Year: number, modifiedLast1Day: number, modifiedLast7Days: number, modifiedLast30Days: number, modifiedLast90Days: number, modifiedLast1Year: number, listHidden: number | null, skipHidden: number | null } };

export type GetFindingItemsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  itemsSearch: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFindingItemsQuery = { getFindingItems: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, status: string | null, detectedAt: string | null, assignedTo: string | null, assignedBy: string | null, taskId: string | null, itemType: string | null }> } };

export type GetFindingsQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  severity: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  showHidden: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sort: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFindingsQuery = { getFindings: { hasNextPage: boolean | null, itemsFound: number | null, nodes: Array<{ id: string | null, name: string | null, description: string | null, resourceType: string | null, resourceTypeEn: string | null, tenantId: string | null, affectedItems: number | null, severity: number | null }> } };

export type GetGroupQueryVariables = Exact<{
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetGroupQuery = { getGroup: { id: string, name: string, privacy: string | null, email: string | null, createdAt: string | null, type: string | null, isTeams: boolean | null, members: number | null, accessibleFiles: number | null, accessibleSites: number | null, sensitivityLabels: number | null, sensitiveInfo: number | null, containedGroups: number | null, isMemberOfGroups: number | null } };

export type GetGroupAlertsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  groupAppsSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetResourceAlertsSortEnum>;
}>;


export type GetGroupAlertsQuery = { getGroupAlerts: { hasNextPage: boolean, nodes: Array<{ id: string, name: string | null, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null }> } };

export type GetGroupAppsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  groupAppsSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetGroupAppsEnum>;
}>;


export type GetGroupAppsQuery = { getGroupApps: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, connected: string | null, users: number | null, externalUsers: number | null, firstAdminUser: string | null, filesAccess: Array<string | null> | null, usersAccess: Array<string | null> | null, emailsAccess: Array<string | null> | null, logoUrl: string | null, sensitivity: string | null }> } };

export type GetGroupFilesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  groupFilesCompactSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetGroupFilesSortEnum>;
}>;


export type GetGroupFilesQuery = { getGroupFiles: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, path: string | null, fileSensitivityLabels: string | null, permissions: Array<{ permission: string, accessThrough: Array<{ type: string | null }> }> }> } };

export type GetGroupFilterCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupFilterCountsQuery = { getGroupFilterCounts: { all: number, externalUsers: number, internalUsers: number, ms365: number, security: number, sharepoint: number, directory: number } };

export type GetGroupGraphQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetGroupGraphQuery = { getGroupGraph: { mainNode: { id: string, name: string, type: string, page: string | null, resource: string | null, drawerDataId: string | null, icon: string, color: string | null, users: string | null, files: string | null, groups: string | null, filters: { permissions: Array<string | null> | null, type: Array<string | null> | null } | null }, parentNodes: Array<{ id: string, name: string, type: string, page: string | null, resource: string | null, drawerDataId: string | null, icon: string, color: string | null, users: string | null, files: string | null, groups: string | null, filters: { permissions: Array<string | null> | null, type: Array<string | null> | null } | null }>, nestedNodes: Array<{ id: string, name: string, type: string, page: string | null, resource: string | null, drawerDataId: string | null, icon: string, color: string | null, users: string | null, files: string | null, groups: string | null, filters: { permissions: Array<string | null> | null, type: Array<string | null> | null } | null }>, edges: Array<{ from: string, to: string }>, legend: Array<{ name: string | null, color: string, icon: string, type: string | null }> } };

export type GetGroupLabelsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  groupLabelsListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerLabelsSortEnum>;
}>;


export type GetGroupLabelsQuery = { getGroupLabels: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, description: string | null, color: string | null, contentFormats: string | null, hasProtection: boolean, isActive: boolean, isAppliable: boolean, sensitivity: number | null, tooltip: string | null, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetGroupMembersQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  groupMembersSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetGroupMembersSortEnum>;
  drawerFilterTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetGroupMembersQuery = { getGroupMembers: { hasNextPage: boolean | null, nodes: Array<{ id: string, userName: string, avatar: string | null, isExternal: boolean, emailDomain: string, lastSignIn: string | null, accessThrough: Array<{ name: string }> }> } };

export type GetGroupSensitiveInfoQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  groupSensitiveInfoListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
}>;


export type GetGroupSensitiveInfoQuery = { getGroupSensitiveInfo: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetGroupSitesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  groupSitesCompactSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetGroupSitesSortEnum>;
}>;


export type GetGroupSitesQuery = { getGroupSites: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, permissions: Array<{ levelName: string, accessThrough: Array<{ type: string | null }> }> }> } };

export type GetGroupsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetGroupsSortType>;
  access: InputMaybe<Array<GroupAccessType> | GroupAccessType>;
  type: InputMaybe<Array<GroupType> | GroupType>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetGroupsQuery = { getGroups: { hasNextPage: boolean | null, itemsFound: number | null, nodes: Array<{ id: string, name: string, createdAt: string | null, type: string | null, members: number | null, nestedMembers: number | null, nestedExternalUsers: number | null, containedGroups: number | null, totalUsers: number | null, totalExternalUsers: number | null, isMemberOfGroups: number | null, accessibleFiles: number | null, accessibleSites: number | null, filesWithSensitivityLabels: number | null, sensitivityLabels: number | null, sensitiveInfo: number | null }> } };

export type GetLivePolicyPreviewQueryVariables = Exact<{
  conditions: Scalars['String']['input'];
  type: Scalars['String']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLivePolicyPreviewQuery = { getLivePolicyPreview: { hasNextPage: boolean | null, nodes: string | null, itemsFound: number | null } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { getMe: { name: string, email: string, roles: Array<string | null>, organizationName: string, isAdmin: boolean, isAdminMode: boolean | null, viewingAs: { id: string, name: string } | null } };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { getOrganizations: Array<{ id: string | null, name: string | null } | null> | null };

export type GetOnboardingDataQueryVariables = Exact<{
  appId: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOnboardingDataQuery = { getOnboardingData: { orgId: string | null, permissions: Array<{ name: string | null, isValid: boolean | null } | null> | null } };

export type GetPoliciesQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetPoliciesSortType>;
  filters: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPoliciesQuery = { getPolicies: { itemsFound: number | null, hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, type: string, violations: number | null, severity: string, assignedUsers: number | null, lastDetection: string | null, activeScan: boolean | null, isTemplate: boolean | null, automations: string | null, conditions: string | null }> } };

export type GetPolicyQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetPolicyQuery = { getPolicy: { id: string, name: string, type: string, violations: number | null, severity: string, assignedUsers: number | null, lastDetection: string | null, conditions: string | null, automations: string | null } };

export type GetPolicyActivityTimelineQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPolicyActivityTimelineQuery = { getPolicyActivityTimeline: { hasNextPage: boolean, nodes: Array<{ id: string, activityType: string, description: string | null, action: string | null, previousState: string | null, newState: string | null, createdAt: string | null, userName: string | null, userEmail: string | null, automationType: string | null, status: string | null, parameters: string | null, result: string | null, completedAt: string | null }> } };

export type GetPolicyHistoryQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPolicyHistoryQuery = { getPolicyHistory: { hasNextPage: boolean, nodes: Array<{ id: string, description: string | null, action: string | null, previousState: string | null, newState: string | null, createdAt: string | null, userName: string | null, userEmail: string | null }> } };

export type GetResourceActivityTimelineQueryVariables = Exact<{
  resourceType: Scalars['String']['input'];
  resourceId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetResourceActivityTimelineQuery = { getResourceActivityTimeline: { hasNextPage: boolean, nodes: Array<{ id: string, activityType: string, description: string | null, action: string | null, previousState: string | null, newState: string | null, createdAt: string | null, userName: string | null, userEmail: string | null, automationType: string | null, status: string | null, parameters: string | null, result: string | null, completedAt: string | null, sourcePolicyName: string | null }> } };

export type GetScanResourceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScanResourceStatusQuery = { getScanResourceStatus: { files: ResourceStatus | null, sites: ResourceStatus | null, groups: ResourceStatus | null, apps: ResourceStatus | null, users: ResourceStatus | null } | null };

export type GetSecurityTaskQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetSecurityTaskQuery = { getSecurityTask: { id: string | null, findingId: string | null, name: string | null, severity: number | null, affectedItemName: string | null, affectedItemId: string | null, resourceType: string | null, taskStatus: string | null, assignedToId: string | null, assignedById: string | null, assignedTo: string | null, assignedBy: string | null, createdAt: string | null, tags: Array<string | null> | null, description: string | null, hidden: boolean | null, graph: { nodes: Array<{ id: string, name: string, type: string, users: number | null, icon: string | null }>, edges: Array<{ from: string, to: string }>, description: Array<{ text: string, color: string | null, link: string | null }> } | null } };

export type GetSecurityTasksQueryVariables = Exact<{
  search: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  type: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  status: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  severity: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  time: InputMaybe<DateTimeFilterInput>;
  dateRange: InputMaybe<DateRangeFilterInput>;
  assignment: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  task: InputMaybe<TaskAssignmentFilterInput>;
  showHidden: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  sort: InputMaybe<Scalars['String']['input']>;
  hasAutoFix: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSecurityTasksQuery = { getSecurityTasks: { hasNextPage: boolean | null, itemsFound: number | null, nodes: Array<{ id: string | null, findingId: string | null, name: string | null, severity: number | null, affectedItemName: string | null, affectedItemId: string | null, resourceType: string | null, resourceTypeEn: string | null, taskStatus: string | null, assignedToId: string | null, assignedById: string | null, assignedTo: string | null, assignedBy: string | null, hidden: boolean | null }> } };

export type GetSecurityTasksFilterCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecurityTasksFilterCountQuery = { getSecurityTasksFilterCount: { all: number | null, appResource: number | null, userResource: number | null, groupResource: number | null, fileResource: number | null, siteResource: number | null, driveResource: number | null, open: number | null, waitingForReview: number | null, inReview: number | null, resolved: number | null, closed: number | null, falsePositive: number | null, lowSeverity: number | null, mediumSeverity: number | null, highSeverity: number | null, criticalSeverity: number | null, informationSeverity: number | null, createdLast1Day: number, createdLast7Days: number, createdLast30Days: number, createdLast90Days: number, createdLast1Year: number, modifiedLast1Day: number, modifiedLast7Days: number, modifiedLast30Days: number, modifiedLast90Days: number, modifiedLast1Year: number, autoAssigned: number | null, userAssigned: number | null, listHidden: number | null, skipHidden: number | null } };

export type GetSensitiveDataQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSensitiveInfoSortEnum>;
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSensitiveDataQuery = { getSensitiveData: { hasNextPage: boolean | null, itemsFound: number | null, nodes: Array<{ id: string | null, name: string | null, sites: number | null, groups: number | null, files: number | null, users: number | null, apps: number | null, isActive: boolean | null, confidenceLevel: string | null, detectionMechanism: string | null, publisher: string | null, filesDetectedBy1SecurityPercent: number | null, filesDetectedByPurviewPercent: number | null }> } };

export type GetSensitiveInfoQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetSensitiveInfoQuery = { getSensitiveInfo: { id: string | null, name: string | null, sites: number | null, groups: number | null, files: number | null, users: number | null, apps: number | null } };

export type GetSensitiveInfoAlertsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoAppListSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetResourceAlertsSortEnum>;
}>;


export type GetSensitiveInfoAlertsQuery = { getSensitiveInfoAlerts: { hasNextPage: boolean, nodes: Array<{ id: string, name: string | null, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null }> } };

export type GetSensitiveInfoAppsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoAppListSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetAppsSortEnum>;
}>;


export type GetSensitiveInfoAppsQuery = { getSensitiveInfoApps: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, connected: string | null, users: number | null, externalUsers: number | null, firstAdminUser: string | null, filesAccess: Array<string | null> | null, usersAccess: Array<string | null> | null, emailsAccess: Array<string | null> | null, logoUrl: string | null, sensitivity: string | null, files: number | null }> } };

export type GetSensitiveInfoFilesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  usersSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetSensitiveInfoDrawerSortEnum>;
}>;


export type GetSensitiveInfoFilesQuery = { getSensitiveInfoFiles: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, usersWithAccess: number, sharedExternally: number, sharedWithAnyone: number, sharedWithOrganization: boolean, path: string, detectedByPurview: boolean | null, detectedBy1Security: boolean | null, webUrl: string | null }> } | null };

export type GetSensitiveInfoGroupsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoGroupListSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetGroupsSortType>;
}>;


export type GetSensitiveInfoGroupsQuery = { getSensitiveInfoGroups: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, createdAt: string | null, type: string | null, members: number | null, nestedMembers: number | null, nestedExternalUsers: number | null, containedGroups: number | null, totalUsers: number | null, totalExternalUsers: number | null, isMemberOfGroups: number | null, accessibleFiles: number | null, accessibleSites: number | null, filesWithSensitivityLabels: number | null, sensitivityLabels: number | null }> } };

export type GetSensitiveInfoSitesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoSiteListSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetSitesSortEnum>;
}>;


export type GetSensitiveInfoSitesQuery = { getSensitiveInfoSites: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string | null, lastActivity: string | null, isHubSite: boolean | null, subsites: number, files: number, privacy: string | null, activity: string | null, groupsWithAccess: number | null, usersWithAccess: number | null, externalUsersWithAccess: number | null, pages: number | null, drives: number | null, lists: number | null, notebooks: number | null, modifiedAt: string | null, createdAt: string | null, type: string | null, filesSize: string | null, owners: number | null, directUsersWithAccess: number | null, indirectUsersWithAccess: number | null, filesWithSensitivityLabels: number | null, sensitivityLabels: number | null, sensitiveInfo: number | null }> } };

export type GetSensitiveInfoUsersQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveInfoUserListSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetAppUsersSortEnum>;
}>;


export type GetSensitiveInfoUsersQuery = { getSensitiveInfoUsers: { hasNextPage: boolean | null, nodes: Array<{ id: string, userName: string, avatar: string | null, emailDomain: string | null, isExternal: boolean | null, signInDisabledAt: string | null, azureRegisteredAt: string | null, canAdminConsent: boolean | null, connectedApps: number | null, accessibleFiles: number | null, totalGroupMemberships: number | null, licenses: Array<string | null>, lastSignIn: string | null, hasMfa: boolean | null }> } };

export type GetSensitivityLabelQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetSensitivityLabelQuery = { getSensitivityLabel: { id: string | null, name: string | null, color: string | null, contentFormats: string | null, description: string | null, hasProtection: boolean | null, isActive: boolean | null, isAppliable: boolean | null, priority: number | null, tooltip: string | null, sites: number | null, groups: number | null, files: number | null, users: number | null, apps: number | null } };

export type GetSensitivityLabelAlertsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveLabelGroupListSearch: InputMaybe<Scalars['String']['input']>;
  sensitivityLabelName: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetResourceAlertsSortEnum>;
}>;


export type GetSensitivityLabelAlertsQuery = { getSensitivityLabelAlerts: { hasNextPage: boolean, nodes: Array<{ id: string, name: string | null, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null }> } };

export type GetSensitivityLabelFilesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  usersSearch: InputMaybe<Scalars['String']['input']>;
  sensitivityLabelName: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetSensitivityLabelFilesSortEnum>;
}>;


export type GetSensitivityLabelFilesQuery = { getSensitivityLabelFiles: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, sensitivity: number | null, size: string | null, files: number | null, lastModified: string | null, createdDate: string | null, webUrl: string | null, createdBy: string | null, modifiedBy: string | null, type: string | null, usersWithAccess: number | null, sharedExternally: number | null, sharedWithAnyone: number | null, sharedWithOrganization: boolean | null, path: string | null }> } | null };

export type GetSensitivityLabelGroupsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sensitiveLabelGroupListSearch: InputMaybe<Scalars['String']['input']>;
  sensitivityLabelName: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetGroupsSortType>;
}>;


export type GetSensitivityLabelGroupsQuery = { getSensitivityLabelGroups: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, createdAt: string | null, type: string | null, members: number | null, nestedMembers: number | null, nestedExternalUsers: number | null, containedGroups: number | null, totalUsers: number | null, totalExternalUsers: number | null, isMemberOfGroups: number | null, accessibleFiles: number | null, accessibleSites: number | null, filesWithSensitivityLabels: number | null, sensitivityLabels: number | null }> } };

export type GetSensitivityLabelsQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetSensitivityLabelsSortEnum>;
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSensitivityLabelsQuery = { getSensitivityLabels: { hasNextPage: boolean | null, itemsFound: number | null, nodes: Array<{ id: string | null, name: string | null, color: string | null, contentFormats: string | null, description: string | null, hasProtection: boolean | null, isActive: boolean | null, isAppliable: boolean | null, priority: number | null, tooltip: string | null, sites: number | null, groups: number | null, files: number | null, users: number | null, apps: number | null }> } };

export type GetSiteQueryVariables = Exact<{
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSiteQuery = { getSite: { id: string, name: string | null, type: string | null, usersWithAccess: number | null, groupsWithAccess: number | null, files: number, sensitiveInfo: number | null, webUrl: string | null, teamsChannelsStandard: number | null, teamsChannelsPrivate: number | null, teamsChannelsShared: number | null, isTeamsSite: boolean | null, isChannelSite: boolean | null, channelType: string | null, help: string | null } };

export type GetSiteAlertsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteGroupsCompactSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetResourceAlertsSortEnum>;
}>;


export type GetSiteAlertsQuery = { getSiteAlerts: { hasNextPage: boolean, nodes: Array<{ id: string, name: string | null, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null }> } };

export type GetSiteFilesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteFilesCompactSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetSiteFilesSortEnum>;
}>;


export type GetSiteFilesQuery = { getSiteFiles: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, size: string | null, files: number | null, webUrl: string | null, sourceType: string | null, sharedExternally: number, sharedWithAnyone: number, usersWithAccess: number, usersWithEditAccess: number, groupsWithAccess: number, createdBy: string | null, createdAt: string | null, modifiedBy: string | null, modifiedAt: string | null, fileSensitivityLabels: string | null, sensitiveInfo: number | null }> } };

export type GetSiteFilterCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteFilterCountsQuery = { getSiteFilterCounts: { all: number, site: number, subsite: number, hubsite: number, accessAll: number, internalUsers: number, externalUsers: number, createdLast1Day: number, createdLast7Days: number, createdLast30Days: number, createdLast90Days: number, createdLast1Year: number, modifiedLast1Day: number, modifiedLast7Days: number, modifiedLast30Days: number, modifiedLast90Days: number, modifiedLast1Year: number, noActivityLastYear: number, noDirectUsers: number, noUsers: number, noOwners: number, blockedSites: number, noBlockedSites: number, fullyScannedSites: number, noFullyScannedSites: number, showPersonalSites: number } };

export type GetSiteGroupsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteGroupsCompactSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetSiteGroupsSortEnum>;
  drawerFilterTypes: InputMaybe<Array<GroupType> | GroupType>;
}>;


export type GetSiteGroupsQuery = { getSiteGroups: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, type: string | null, highestSitePermission: string | null, indirectInternalUsers: number | null, indirectExternalUsers: number | null, totalIndirectUsers: number | null, directInternalUsers: number | null, directExternalUsers: number | null, totalDirectUsers: number | null, totalUsers: number | null, accessThrough: Array<string | null> | null, groupSensitivityLabels: string | null }> } };

export type GetSiteGroupsGraphQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetSiteGroupsGraphQuery = { getSiteGroupsGraph: { nodes: Array<{ id: string, name: string, type: string, page: string | null, resource: string | null, drawerDataId: string | null, icon: string, color: string | null, users: string | null, files: string | null, groups: string | null, filters: { permissions: Array<string | null> | null, type: Array<string | null> | null } | null }>, edges: Array<{ from: string, to: string }>, legend: Array<{ name: string | null, color: string, icon: string, type: string | null }> } };

export type GetSiteLabelsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  groupLabelsListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerLabelsSortEnum>;
}>;


export type GetSiteLabelsQuery = { getSiteLabels: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, description: string | null, color: string | null, contentFormats: string | null, hasProtection: boolean, isActive: boolean, isAppliable: boolean, sensitivity: number | null, tooltip: string | null, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetSiteSensitiveInfoQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  siteSensitiveInfoListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
}>;


export type GetSiteSensitiveInfoQuery = { getSiteSensitiveInfo: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetSiteUsersQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  siteAccessSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetSiteUsersSortEnum>;
  drawerFilterTypes: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetSiteUsersQuery = { getSiteUsers: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, emailDomain: string | null, permissions: Array<{ level: string, levelName: string, score: string, accessThrough: Array<{ type: string | null, name: string | null, id: string | null }> }> }> } };

export type GetSitesQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  sort: InputMaybe<GetSitesSortEnum>;
  type: InputMaybe<Array<InputMaybe<GetSitesTypeEnum>> | InputMaybe<GetSitesTypeEnum>>;
  search: InputMaybe<Scalars['String']['input']>;
  user: InputMaybe<UserType>;
  orphanedIndicators: InputMaybe<Array<InputMaybe<OrphanedIndicatorsEnum>> | InputMaybe<OrphanedIndicatorsEnum>>;
  personalSites: InputMaybe<Array<InputMaybe<PersonalSitesEnum>> | InputMaybe<PersonalSitesEnum>>;
  fullyScannedSites: InputMaybe<Array<InputMaybe<FullyScannedSitesEnum>> | InputMaybe<FullyScannedSitesEnum>>;
  blockedSites: InputMaybe<Array<InputMaybe<BlockedSitesEnum>> | InputMaybe<BlockedSitesEnum>>;
  time: InputMaybe<DateTimeFilterInput>;
  createdAt: InputMaybe<DateRange>;
  modifiedAt: InputMaybe<DateRange>;
  lastActivityAt: InputMaybe<DateRange>;
  privacy: InputMaybe<Array<InputMaybe<GetSitesPrivacyEnum>> | InputMaybe<GetSitesPrivacyEnum>>;
  activity: InputMaybe<Array<InputMaybe<GetSitesActivityEnum>> | InputMaybe<GetSitesActivityEnum>>;
  access: InputMaybe<Array<InputMaybe<GetSitesAccessEnum>> | InputMaybe<GetSitesAccessEnum>>;
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSitesQuery = { getSites: { itemsFound: number | null, hasNextPage: boolean | null, nodes: Array<{ id: string, name: string | null, lastActivity: string | null, isHubSite: boolean | null, subsites: number, files: number, privacy: string | null, activity: string | null, groupsWithAccess: number | null, usersWithAccess: number | null, externalUsersWithAccess: number | null, pages: number | null, drives: number | null, lists: number | null, notebooks: number | null, modifiedAt: string | null, createdAt: string | null, type: string | null, filesSize: string | null, owners: number | null, directUsersWithAccess: number | null, indirectUsersWithAccess: number | null, filesWithSensitivityLabels: number | null, sensitivityLabels: number | null, sensitiveInfo: number | null, isFullyScanned: boolean | null, isBlocked: boolean | null, webUrl: string | null, teamsChannels: number | null }> } };

export type GetTenantListQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  text: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<TenantSortEnum>;
}>;


export type GetTenantListQuery = { getTenantList: { itemsFound: number | null, hasNextPage: boolean | null, nodes: Array<{ id: string, name: string | null, domain: string | null, emailDomain: string | null, scanStatus: ScanStatus | null, lastScannedAt: string | null, filesStatus: ResourceStatus | null, groupsStatus: ResourceStatus | null, sitesStatus: ResourceStatus | null, usersStatus: ResourceStatus | null, fileCount: number | null, siteCount: number | null, groupCount: number | null, appCount: number | null, userCount: number | null, accessToTenantGranted: boolean | null, hasValidLicense: boolean | null, isDemo: boolean | null } | null> | null } | null };

export type GetTenantSensitiveInfoRefreshStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantSensitiveInfoRefreshStatusQuery = { getTenantSensitiveInfoRefreshStatus: string };

export type GetUserQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetUserQuery = { getUser: { id: string, userName: string, email: string, isExternal: boolean, avatar: string | null, emailDomain: string | null, licenses: Array<string | null>, hasMfa: boolean | null, lastSignIn: string | null, signInDisabledAt: string | null, accessibleFiles: number | null, totalGroupMemberships: number | null, connectedApps: number | null, sites: number | null, sensitiveInfo: number | null } };

export type GetUserAlertsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  userAppsSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetResourceAlertsSortEnum>;
}>;


export type GetUserAlertsQuery = { getUserAlerts: { hasNextPage: boolean, nodes: Array<{ id: string, name: string | null, status: string | null, severity: string | null, detectedAt: string | null, resolvedAt: string | null }> } };

export type GetUserAppsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  userAppsSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<UserAppsSortEnum>;
}>;


export type GetUserAppsQuery = { getUserApps: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, connected: string | null, users: number | null, externalUsers: number | null, firstAdminUser: string | null, filesAccess: Array<string | null> | null, usersAccess: Array<string | null> | null, emailsAccess: Array<string | null> | null, logoUrl: string | null, sensitivity: string | null, accessFrom: string | null, files: number | null }> } };

export type GetUserFilesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  userFilesCompactSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetUserFilesSortEnum>;
}>;


export type GetUserFilesQuery = { getUserFiles: { hasNextPage: boolean | null, nodes: Array<{ id: string | null, name: string | null, fileSensitivityLabels: string | null, permissions: Array<{ permission: string, accessThrough: Array<{ type: string | null }> }> }> } };

export type GetUserFilterCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserFilterCountsQuery = { getUserFilterCounts: { all: number, externalUsers: number, internalUsers: number, noLicense: number, withLicense: number, createdLast1Day: number, createdLast7Days: number, createdLast30Days: number, createdLast90Days: number, createdLast1Year: number, lastSignIn1Day: number, lastSignIn7Days: number, lastSignIn30Days: number, lastSignIn90Days: number, lastSignIn1Year: number } };

export type GetUserGroupsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  userGroupsCompactSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetUserGroupsSortEnum>;
  drawerFilterTypes: InputMaybe<Array<GroupType> | GroupType>;
}>;


export type GetUserGroupsQuery = { getUserGroups: { hasNextPage: boolean | null, nodes: Array<{ type: string | null, id: string | null, name: string | null, indirectInternalUsers: number | null, indirectExternalUsers: number | null, totalIndirectUsers: number | null, directExternalUsers: number | null, totalDirectUsers: number | null, totalUsers: number | null, accessThrough: Array<string | null> | null, directInternalUsers: number | null, groupSensitivityLabels: string | null }> } };

export type GetUserGroupsGraphQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
}>;


export type GetUserGroupsGraphQuery = { getUserGroupsGraph: { nodes: Array<{ id: string, name: string, type: string, page: string | null, resource: string | null, drawerDataId: string | null, icon: string, color: string | null, users: string | null, files: string | null, groups: string | null, filters: { permissions: Array<string | null> | null, type: Array<string | null> | null } | null }>, edges: Array<{ from: string, to: string }>, legend: Array<{ name: string | null, color: string, icon: string, type: string | null }> } };

export type GetUserLabelsQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  userLabelsListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerLabelsSortEnum>;
}>;


export type GetUserLabelsQuery = { getUserLabels: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, description: string | null, color: string | null, contentFormats: string | null, hasProtection: boolean, isActive: boolean, isAppliable: boolean, sensitivity: number | null, tooltip: string | null, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetUserSensitiveInfoQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  userSensitiveInfoListSearch: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  drawerSort: InputMaybe<GetDrawerSensitiveInfoSortEnum>;
}>;


export type GetUserSensitiveInfoQuery = { getUserSensitiveInfo: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, sites: number, groups: number, files: number, users: number, apps: number }> } };

export type GetUserSitesQueryVariables = Exact<{
  drawerDataId: Scalars['ID']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  groupSitesCompactSearch: InputMaybe<Scalars['String']['input']>;
  drawerSort: InputMaybe<GetUserSitesSortEnum>;
}>;


export type GetUserSitesQuery = { getUserSites: { hasNextPage: boolean | null, nodes: Array<{ id: string, name: string, permissions: Array<{ levelName: string, accessThrough: Array<{ type: string | null }> }> }> } };

export type GetUsersQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  search: InputMaybe<Scalars['String']['input']>;
  sort: InputMaybe<GetUsersSortEnum>;
  type: InputMaybe<Array<InputMaybe<GetUsersTypeEnum>> | InputMaybe<GetUsersTypeEnum>>;
  isAppUser: InputMaybe<Scalars['Boolean']['input']>;
  licenses: InputMaybe<Array<InputMaybe<GetUsersLicensesEnum>> | InputMaybe<GetUsersLicensesEnum>>;
  drawerDataId: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetUsersQuery = { getUsers: { itemsFound: number | null, hasNextPage: boolean | null, nodes: Array<{ id: string, userName: string, avatar: string | null, emailDomain: string | null, isExternal: boolean, signInDisabledAt: string | null, azureRegisteredAt: string | null, canAdminConsent: boolean | null, connectedApps: number | null, accessibleFiles: number | null, totalGroupMemberships: number | null, licenses: Array<string | null>, lastSignIn: string | null, hasMfa: boolean | null, hasSignedIn: boolean | null, email: string, isAdmin: boolean | null, totalSensitivityScore: number | null, filesWithSensitivityLabels: number | null, sensitivityLabels: number | null, sensitiveInfo: number | null, filesWithSensitiveData: number | null }> } };

export type InviteTo1SecurityMutationVariables = Exact<{
  email: Scalars['String']['input'];
  role: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteTo1SecurityMutation = { inviteTo1Security: { success: boolean, inviteCode: string | null, message: string | null } };

export type LogoutMutationVariables = Exact<{
  allDevices: Scalars['Boolean']['input'];
}>;


export type LogoutMutation = { logout: boolean };

export type LogoutTenantMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type LogoutTenantMutation = { logoutTenant: string | null };

export type RemoveAccountOrInvitationFromOrganizationMutationVariables = Exact<{
  accountId: InputMaybe<Scalars['String']['input']>;
  invitationId: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveAccountOrInvitationFromOrganizationMutation = { removeAccountOrInvitationFromOrganization: boolean | null };

export type RemoveTenantFrom1SecurityMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type RemoveTenantFrom1SecurityMutation = { removeTenantFrom1Security: boolean | null };

export type RemoveTenantFromOrganizationMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type RemoveTenantFromOrganizationMutation = { removeTenantFromOrganization: boolean | null };

export type RemoveUserFromGroupMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
}>;


export type RemoveUserFromGroupMutation = { removeUserFromGroup: boolean | null };

export type RequestRefreshTenantMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type RequestRefreshTenantMutation = { requestRefreshTenant: boolean | null };

export type SearchOrganizationsQueryVariables = Exact<{
  searchQuery: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchOrganizationsQuery = { searchOrganizations: Array<{ id: string | null, label: string | null } | null> | null };

export type SearchResourcesQueryVariables = Exact<{
  resourceType: Scalars['String']['input'];
  query: Scalars['String']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchResourcesQuery = { searchResources: { hasNextPage: boolean, nodes: Array<{ id: string, name: string, type: string, displayName: string | null }> } };

export type SendEmailMessageTo1SecurityMutationVariables = Exact<{
  email: InputMaybe<Scalars['String']['input']>;
  message: InputMaybe<Scalars['String']['input']>;
  recaptchaToken: Scalars['String']['input'];
}>;


export type SendEmailMessageTo1SecurityMutation = { sendEmailMessageTo1Security: boolean };

export type SendWaitlistEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type SendWaitlistEmailMutation = { sendWaitlistEmail: boolean };

export type SendUpgradeRequestEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendUpgradeRequestEmailMutation = { sendUpgradeRequestEmail: boolean };

export type SetCurrentTenantMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type SetCurrentTenantMutation = { setCurrentTenant: boolean | null };

export type SetDisplayFindingMutationVariables = Exact<{
  findingId: InputMaybe<Scalars['ID']['input']>;
  hide: Scalars['Boolean']['input'];
  taskId: InputMaybe<Scalars['ID']['input']>;
}>;


export type SetDisplayFindingMutation = { setDisplayFinding: boolean };

export type SetViewAsMutationVariables = Exact<{
  viewingAs: InputMaybe<Scalars['String']['input']>;
  isAdminMode: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetViewAsMutation = { setViewAs: boolean | null };

export type SignInMutationVariables = Exact<{
  token: InputMaybe<Scalars['String']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  referralCode: InputMaybe<Scalars['String']['input']>;
  inviteCode: InputMaybe<Scalars['String']['input']>;
}>;


export type SignInMutation = { signIn: { access_token: string | null, refresh_token: string | null } | null };

export type SwitchOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type SwitchOrganizationMutation = { switchOrganization: boolean | null };

export type UnassignLicensesMutationVariables = Exact<{ [key: string]: never; }>;


export type UnassignLicensesMutation = { unassignLicenses: boolean | null };

export type UpdateTaskMutationVariables = Exact<{
  taskId: Scalars['ID']['input'];
  taskStatus: InputMaybe<Scalars['String']['input']>;
  assignedTo: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTaskMutation = { updateTask: { id: string | null, findingId: string | null, name: string | null, severity: number | null, affectedItemName: string | null, affectedItemId: string | null, resourceType: string | null, taskStatus: string | null, assignedToId: string | null, assignedById: string | null, assignedTo: string | null, assignedBy: string | null, createdAt: string | null, tags: Array<string | null> | null, description: string | null } };

export type VerifyEmailMutationVariables = Exact<{
  token: InputMaybe<Scalars['String']['input']>;
  provider: InputMaybe<Scalars['String']['input']>;
  email: InputMaybe<Scalars['String']['input']>;
  emailVerificationCode: InputMaybe<Scalars['String']['input']>;
}>;


export type VerifyEmailMutation = { verifyEmail: { access_token: string | null, refresh_token: string | null } | null };



export const ActivateSensitiveInfoDocument = `
    mutation ActivateSensitiveInfo($sensitiveInfoIds: [ID]!) {
  activateSensitiveInfo(sensitiveInfoIds: $sensitiveInfoIds)
}
    `;

export const useActivateSensitiveInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ActivateSensitiveInfoMutation, TError, ActivateSensitiveInfoMutationVariables, TContext>) => {
    
    return useMutation<ActivateSensitiveInfoMutation, TError, ActivateSensitiveInfoMutationVariables, TContext>(
      {
    mutationKey: ['ActivateSensitiveInfo'],
    mutationFn: useMyQuery<ActivateSensitiveInfoMutation, ActivateSensitiveInfoMutationVariables>(ActivateSensitiveInfoDocument),
    ...options
  }
    )};

export const AssignMsOfficeLicenseDocument = `
    mutation assignMSOfficeLicense {
  assignMSOfficeLicense
}
    `;

export const useAssignMsOfficeLicenseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AssignMsOfficeLicenseMutation, TError, AssignMsOfficeLicenseMutationVariables, TContext>) => {
    
    return useMutation<AssignMsOfficeLicenseMutation, TError, AssignMsOfficeLicenseMutationVariables, TContext>(
      {
    mutationKey: ['assignMSOfficeLicense'],
    mutationFn: useMyQuery<AssignMsOfficeLicenseMutation, AssignMsOfficeLicenseMutationVariables>(AssignMsOfficeLicenseDocument),
    ...options
  }
    )};

export const CheckTenantConfigDocument = `
    query checkTenantConfig {
  checkTenantConfig {
    hasMSLicense
    hasPermissions
    hasTreeReady
  }
}
    `;

export const useCheckTenantConfigQuery = <
      TData = CheckTenantConfigQuery,
      TError = unknown
    >(
      variables?: CheckTenantConfigQueryVariables,
      options?: Omit<UseQueryOptions<CheckTenantConfigQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CheckTenantConfigQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CheckTenantConfigQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['checkTenantConfig'] : ['checkTenantConfig', variables],
    queryFn: useMyQuery<CheckTenantConfigQuery, CheckTenantConfigQueryVariables>(CheckTenantConfigDocument).bind(null, variables),
    ...options
  }
    )};

useCheckTenantConfigQuery.getKey = (variables?: CheckTenantConfigQueryVariables) => variables === undefined ? ['checkTenantConfig'] : ['checkTenantConfig', variables];

export const useInfiniteCheckTenantConfigQuery = <
      TData = InfiniteData<CheckTenantConfigQuery>,
      TError = unknown
    >(
      variables: CheckTenantConfigQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CheckTenantConfigQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CheckTenantConfigQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<CheckTenantConfigQuery, CheckTenantConfigQueryVariables>(CheckTenantConfigDocument)
    return useInfiniteQuery<CheckTenantConfigQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['checkTenantConfig.infinite'] : ['checkTenantConfig.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteCheckTenantConfigQuery.getKey = (variables?: CheckTenantConfigQueryVariables) => variables === undefined ? ['checkTenantConfig.infinite'] : ['checkTenantConfig.infinite', variables];

export const ChooseConnectedTenantDocument = `
    query ChooseConnectedTenant($tenantId: String!, $clientCallback: String) {
  chooseConnectedTenant(tenantId: $tenantId, clientCallback: $clientCallback)
}
    `;

export const useChooseConnectedTenantQuery = <
      TData = ChooseConnectedTenantQuery,
      TError = unknown
    >(
      variables: ChooseConnectedTenantQueryVariables,
      options?: Omit<UseQueryOptions<ChooseConnectedTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ChooseConnectedTenantQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ChooseConnectedTenantQuery, TError, TData>(
      {
    queryKey: ['ChooseConnectedTenant', variables],
    queryFn: useMyQuery<ChooseConnectedTenantQuery, ChooseConnectedTenantQueryVariables>(ChooseConnectedTenantDocument).bind(null, variables),
    ...options
  }
    )};

useChooseConnectedTenantQuery.getKey = (variables: ChooseConnectedTenantQueryVariables) => ['ChooseConnectedTenant', variables];

export const useInfiniteChooseConnectedTenantQuery = <
      TData = InfiniteData<ChooseConnectedTenantQuery>,
      TError = unknown
    >(
      variables: ChooseConnectedTenantQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ChooseConnectedTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ChooseConnectedTenantQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<ChooseConnectedTenantQuery, ChooseConnectedTenantQueryVariables>(ChooseConnectedTenantDocument)
    return useInfiniteQuery<ChooseConnectedTenantQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ChooseConnectedTenant.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteChooseConnectedTenantQuery.getKey = (variables: ChooseConnectedTenantQueryVariables) => ['ChooseConnectedTenant.infinite', variables];

export const ConnectTenantDocument = `
    query ConnectTenant($clientCallback: String) {
  connectTenant(clientCallback: $clientCallback)
}
    `;

export const useConnectTenantQuery = <
      TData = ConnectTenantQuery,
      TError = unknown
    >(
      variables?: ConnectTenantQueryVariables,
      options?: Omit<UseQueryOptions<ConnectTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ConnectTenantQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ConnectTenantQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ConnectTenant'] : ['ConnectTenant', variables],
    queryFn: useMyQuery<ConnectTenantQuery, ConnectTenantQueryVariables>(ConnectTenantDocument).bind(null, variables),
    ...options
  }
    )};

useConnectTenantQuery.getKey = (variables?: ConnectTenantQueryVariables) => variables === undefined ? ['ConnectTenant'] : ['ConnectTenant', variables];

export const useInfiniteConnectTenantQuery = <
      TData = InfiniteData<ConnectTenantQuery>,
      TError = unknown
    >(
      variables: ConnectTenantQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ConnectTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ConnectTenantQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<ConnectTenantQuery, ConnectTenantQueryVariables>(ConnectTenantDocument)
    return useInfiniteQuery<ConnectTenantQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ConnectTenant.infinite'] : ['ConnectTenant.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteConnectTenantQuery.getKey = (variables?: ConnectTenantQueryVariables) => variables === undefined ? ['ConnectTenant.infinite'] : ['ConnectTenant.infinite', variables];

export const CreatePolicyDocument = `
    mutation CreatePolicy($name: String!, $description: String, $conditions: String, $automations: String, $selectedResources: String, $severity: String!, $type: String!, $assignment: String, $defaultUser: String) {
  createPolicy(
    name: $name
    description: $description
    conditions: $conditions
    automations: $automations
    selectedResources: $selectedResources
    severity: $severity
    type: $type
    assignment: $assignment
    defaultUser: $defaultUser
  )
}
    `;

export const useCreatePolicyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreatePolicyMutation, TError, CreatePolicyMutationVariables, TContext>) => {
    
    return useMutation<CreatePolicyMutation, TError, CreatePolicyMutationVariables, TContext>(
      {
    mutationKey: ['CreatePolicy'],
    mutationFn: useMyQuery<CreatePolicyMutation, CreatePolicyMutationVariables>(CreatePolicyDocument),
    ...options
  }
    )};

export const DeactivateSensitiveInfoDocument = `
    mutation DeactivateSensitiveInfo($sensitiveInfoIds: [ID]!) {
  deactivateSensitiveInfo(sensitiveInfoIds: $sensitiveInfoIds)
}
    `;

export const useDeactivateSensitiveInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeactivateSensitiveInfoMutation, TError, DeactivateSensitiveInfoMutationVariables, TContext>) => {
    
    return useMutation<DeactivateSensitiveInfoMutation, TError, DeactivateSensitiveInfoMutationVariables, TContext>(
      {
    mutationKey: ['DeactivateSensitiveInfo'],
    mutationFn: useMyQuery<DeactivateSensitiveInfoMutation, DeactivateSensitiveInfoMutationVariables>(DeactivateSensitiveInfoDocument),
    ...options
  }
    )};

export const DownloadAlertsDataDocument = `
    query downloadAlertsData($resourceTypes: [String!], $conditionFilters: [ConditionFilterInput!], $timeFrom: String, $timeTo: String, $riskLevel: String, $search: String, $filters: AlertFiltersInput) {
  downloadAlertsData(
    resourceTypes: $resourceTypes
    conditionFilters: $conditionFilters
    timeFrom: $timeFrom
    timeTo: $timeTo
    riskLevel: $riskLevel
    text: $search
    filters: $filters
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadAlertsDataQuery = <
      TData = DownloadAlertsDataQuery,
      TError = unknown
    >(
      variables?: DownloadAlertsDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadAlertsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadAlertsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadAlertsDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['downloadAlertsData'] : ['downloadAlertsData', variables],
    queryFn: useMyQuery<DownloadAlertsDataQuery, DownloadAlertsDataQueryVariables>(DownloadAlertsDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadAlertsDataQuery.getKey = (variables?: DownloadAlertsDataQueryVariables) => variables === undefined ? ['downloadAlertsData'] : ['downloadAlertsData', variables];

export const useInfiniteDownloadAlertsDataQuery = <
      TData = InfiniteData<DownloadAlertsDataQuery>,
      TError = unknown
    >(
      variables: DownloadAlertsDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadAlertsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadAlertsDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadAlertsDataQuery, DownloadAlertsDataQueryVariables>(DownloadAlertsDataDocument)
    return useInfiniteQuery<DownloadAlertsDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['downloadAlertsData.infinite'] : ['downloadAlertsData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadAlertsDataQuery.getKey = (variables?: DownloadAlertsDataQueryVariables) => variables === undefined ? ['downloadAlertsData.infinite'] : ['downloadAlertsData.infinite', variables];

export const DownloadAppFilesDataDocument = `
    query downloadAppFilesData($drawerDataId: ID!, $usersSearch: String, $appName: String, $email: String) {
  downloadAppFilesData(
    drawerDataId: $drawerDataId
    text: $usersSearch
    appName: $appName
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadAppFilesDataQuery = <
      TData = DownloadAppFilesDataQuery,
      TError = unknown
    >(
      variables: DownloadAppFilesDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadAppFilesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadAppFilesDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadAppFilesDataQuery, TError, TData>(
      {
    queryKey: ['downloadAppFilesData', variables],
    queryFn: useMyQuery<DownloadAppFilesDataQuery, DownloadAppFilesDataQueryVariables>(DownloadAppFilesDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadAppFilesDataQuery.getKey = (variables: DownloadAppFilesDataQueryVariables) => ['downloadAppFilesData', variables];

export const useInfiniteDownloadAppFilesDataQuery = <
      TData = InfiniteData<DownloadAppFilesDataQuery>,
      TError = unknown
    >(
      variables: DownloadAppFilesDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadAppFilesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadAppFilesDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadAppFilesDataQuery, DownloadAppFilesDataQueryVariables>(DownloadAppFilesDataDocument)
    return useInfiniteQuery<DownloadAppFilesDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['downloadAppFilesData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadAppFilesDataQuery.getKey = (variables: DownloadAppFilesDataQueryVariables) => ['downloadAppFilesData.infinite', variables];

export const DownloadAppPermissionsDataDocument = `
    query downloadAppPermissionsData($drawerDataId: ID!, $usersSearch: String, $email: String) {
  downloadAppPermissionsData(
    drawerDataId: $drawerDataId
    text: $usersSearch
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadAppPermissionsDataQuery = <
      TData = DownloadAppPermissionsDataQuery,
      TError = unknown
    >(
      variables: DownloadAppPermissionsDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadAppPermissionsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadAppPermissionsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadAppPermissionsDataQuery, TError, TData>(
      {
    queryKey: ['downloadAppPermissionsData', variables],
    queryFn: useMyQuery<DownloadAppPermissionsDataQuery, DownloadAppPermissionsDataQueryVariables>(DownloadAppPermissionsDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadAppPermissionsDataQuery.getKey = (variables: DownloadAppPermissionsDataQueryVariables) => ['downloadAppPermissionsData', variables];

export const useInfiniteDownloadAppPermissionsDataQuery = <
      TData = InfiniteData<DownloadAppPermissionsDataQuery>,
      TError = unknown
    >(
      variables: DownloadAppPermissionsDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadAppPermissionsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadAppPermissionsDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadAppPermissionsDataQuery, DownloadAppPermissionsDataQueryVariables>(DownloadAppPermissionsDataDocument)
    return useInfiniteQuery<DownloadAppPermissionsDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['downloadAppPermissionsData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadAppPermissionsDataQuery.getKey = (variables: DownloadAppPermissionsDataQueryVariables) => ['downloadAppPermissionsData.infinite', variables];

export const DownloadAppUsersDataDocument = `
    query downloadAppUsersData($drawerDataId: ID!, $usersSearch: String, $email: String) {
  downloadAppUsersData(
    drawerDataId: $drawerDataId
    text: $usersSearch
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadAppUsersDataQuery = <
      TData = DownloadAppUsersDataQuery,
      TError = unknown
    >(
      variables: DownloadAppUsersDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadAppUsersDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadAppUsersDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadAppUsersDataQuery, TError, TData>(
      {
    queryKey: ['downloadAppUsersData', variables],
    queryFn: useMyQuery<DownloadAppUsersDataQuery, DownloadAppUsersDataQueryVariables>(DownloadAppUsersDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadAppUsersDataQuery.getKey = (variables: DownloadAppUsersDataQueryVariables) => ['downloadAppUsersData', variables];

export const useInfiniteDownloadAppUsersDataQuery = <
      TData = InfiniteData<DownloadAppUsersDataQuery>,
      TError = unknown
    >(
      variables: DownloadAppUsersDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadAppUsersDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadAppUsersDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadAppUsersDataQuery, DownloadAppUsersDataQueryVariables>(DownloadAppUsersDataDocument)
    return useInfiniteQuery<DownloadAppUsersDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['downloadAppUsersData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadAppUsersDataQuery.getKey = (variables: DownloadAppUsersDataQueryVariables) => ['downloadAppUsersData.infinite', variables];

export const DownloadAppsDataDocument = `
    query downloadAppsData($sort: GetAppsSortEnum, $search: String, $textUser: String, $approvalStatus: [GetAppsApprovalStatusEnum], $publisherStatus: [GetAppsPublisherStatusEnum], $userActivity: [GetAppsActivityEnum], $permissions: [String], $external: [GetAppsExternalEnum], $applicationType: [GetAppsApplicationEnum], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $email: String) {
  downloadAppsData(
    sort: $sort
    text: $search
    textUser: $textUser
    approvalStatus: $approvalStatus
    publisherStatus: $publisherStatus
    userActivity: $userActivity
    permissions: $permissions
    external: $external
    time: $time
    dateRange: $dateRange
    applicationType: $applicationType
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadAppsDataQuery = <
      TData = DownloadAppsDataQuery,
      TError = unknown
    >(
      variables?: DownloadAppsDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadAppsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadAppsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadAppsDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['downloadAppsData'] : ['downloadAppsData', variables],
    queryFn: useMyQuery<DownloadAppsDataQuery, DownloadAppsDataQueryVariables>(DownloadAppsDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadAppsDataQuery.getKey = (variables?: DownloadAppsDataQueryVariables) => variables === undefined ? ['downloadAppsData'] : ['downloadAppsData', variables];

export const useInfiniteDownloadAppsDataQuery = <
      TData = InfiniteData<DownloadAppsDataQuery>,
      TError = unknown
    >(
      variables: DownloadAppsDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadAppsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadAppsDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadAppsDataQuery, DownloadAppsDataQueryVariables>(DownloadAppsDataDocument)
    return useInfiniteQuery<DownloadAppsDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['downloadAppsData.infinite'] : ['downloadAppsData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadAppsDataQuery.getKey = (variables?: DownloadAppsDataQueryVariables) => variables === undefined ? ['downloadAppsData.infinite'] : ['downloadAppsData.infinite', variables];

export const DownloadFilesDataDocument = `
    query downloadFilesData($folderId: ID, $search: String, $additionalResults: Boolean, $sort: GetFilesSortType, $access: [AccessType], $fileTypes: [String], $fileContainers: [FileContainerType], $createdBy: String, $lastModifiedBy: String, $filesAccessibleToUser: String, $location: [String], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $listType: String, $email: String) {
  downloadFilesData(
    folderId: $folderId
    text: $search
    fileTypes: $fileTypes
    sort: $sort
    dateRange: $dateRange
    access: $access
    fileContainers: $fileContainers
    location: $location
    createdBy: $createdBy
    lastModifiedBy: $lastModifiedBy
    filesAccessibleToUser: $filesAccessibleToUser
    time: $time
    additionalResults: $additionalResults
    listType: $listType
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadFilesDataQuery = <
      TData = DownloadFilesDataQuery,
      TError = unknown
    >(
      variables?: DownloadFilesDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadFilesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadFilesDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadFilesDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['downloadFilesData'] : ['downloadFilesData', variables],
    queryFn: useMyQuery<DownloadFilesDataQuery, DownloadFilesDataQueryVariables>(DownloadFilesDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadFilesDataQuery.getKey = (variables?: DownloadFilesDataQueryVariables) => variables === undefined ? ['downloadFilesData'] : ['downloadFilesData', variables];

export const useInfiniteDownloadFilesDataQuery = <
      TData = InfiniteData<DownloadFilesDataQuery>,
      TError = unknown
    >(
      variables: DownloadFilesDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadFilesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadFilesDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadFilesDataQuery, DownloadFilesDataQueryVariables>(DownloadFilesDataDocument)
    return useInfiniteQuery<DownloadFilesDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['downloadFilesData.infinite'] : ['downloadFilesData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadFilesDataQuery.getKey = (variables?: DownloadFilesDataQueryVariables) => variables === undefined ? ['downloadFilesData.infinite'] : ['downloadFilesData.infinite', variables];

export const DownloadGroupAppsDataDocument = `
    query downloadGroupAppsData($drawerDataId: ID!, $groupAppsSearch: String, $groupAppsSort: GetGroupAppsEnum, $email: String) {
  downloadGroupAppsData(
    drawerDataId: $drawerDataId
    text: $groupAppsSearch
    sort: $groupAppsSort
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadGroupAppsDataQuery = <
      TData = DownloadGroupAppsDataQuery,
      TError = unknown
    >(
      variables: DownloadGroupAppsDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadGroupAppsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadGroupAppsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadGroupAppsDataQuery, TError, TData>(
      {
    queryKey: ['downloadGroupAppsData', variables],
    queryFn: useMyQuery<DownloadGroupAppsDataQuery, DownloadGroupAppsDataQueryVariables>(DownloadGroupAppsDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadGroupAppsDataQuery.getKey = (variables: DownloadGroupAppsDataQueryVariables) => ['downloadGroupAppsData', variables];

export const useInfiniteDownloadGroupAppsDataQuery = <
      TData = InfiniteData<DownloadGroupAppsDataQuery>,
      TError = unknown
    >(
      variables: DownloadGroupAppsDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadGroupAppsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadGroupAppsDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadGroupAppsDataQuery, DownloadGroupAppsDataQueryVariables>(DownloadGroupAppsDataDocument)
    return useInfiniteQuery<DownloadGroupAppsDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['downloadGroupAppsData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadGroupAppsDataQuery.getKey = (variables: DownloadGroupAppsDataQueryVariables) => ['downloadGroupAppsData.infinite', variables];

export const DownloadGroupFilesDataDocument = `
    query downloadGroupFilesData($drawerDataId: ID!, $groupFilesCompactSearch: String, $groupFilesCompactSort: GetGroupFilesSortEnum, $email: String) {
  downloadGroupFilesData(
    drawerDataId: $drawerDataId
    text: $groupFilesCompactSearch
    sort: $groupFilesCompactSort
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadGroupFilesDataQuery = <
      TData = DownloadGroupFilesDataQuery,
      TError = unknown
    >(
      variables: DownloadGroupFilesDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadGroupFilesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadGroupFilesDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadGroupFilesDataQuery, TError, TData>(
      {
    queryKey: ['downloadGroupFilesData', variables],
    queryFn: useMyQuery<DownloadGroupFilesDataQuery, DownloadGroupFilesDataQueryVariables>(DownloadGroupFilesDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadGroupFilesDataQuery.getKey = (variables: DownloadGroupFilesDataQueryVariables) => ['downloadGroupFilesData', variables];

export const useInfiniteDownloadGroupFilesDataQuery = <
      TData = InfiniteData<DownloadGroupFilesDataQuery>,
      TError = unknown
    >(
      variables: DownloadGroupFilesDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadGroupFilesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadGroupFilesDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadGroupFilesDataQuery, DownloadGroupFilesDataQueryVariables>(DownloadGroupFilesDataDocument)
    return useInfiniteQuery<DownloadGroupFilesDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['downloadGroupFilesData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadGroupFilesDataQuery.getKey = (variables: DownloadGroupFilesDataQueryVariables) => ['downloadGroupFilesData.infinite', variables];

export const DownloadGroupsSitesDataDocument = `
    query downloadGroupsSitesData($drawerDataId: ID!, $groupSitesCompactSearch: String, $groupSitesCompactSort: GetGroupSitesSortEnum, $email: String) {
  downloadGroupsSitesData(
    drawerDataId: $drawerDataId
    text: $groupSitesCompactSearch
    sort: $groupSitesCompactSort
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadGroupsSitesDataQuery = <
      TData = DownloadGroupsSitesDataQuery,
      TError = unknown
    >(
      variables: DownloadGroupsSitesDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadGroupsSitesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadGroupsSitesDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadGroupsSitesDataQuery, TError, TData>(
      {
    queryKey: ['downloadGroupsSitesData', variables],
    queryFn: useMyQuery<DownloadGroupsSitesDataQuery, DownloadGroupsSitesDataQueryVariables>(DownloadGroupsSitesDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadGroupsSitesDataQuery.getKey = (variables: DownloadGroupsSitesDataQueryVariables) => ['downloadGroupsSitesData', variables];

export const useInfiniteDownloadGroupsSitesDataQuery = <
      TData = InfiniteData<DownloadGroupsSitesDataQuery>,
      TError = unknown
    >(
      variables: DownloadGroupsSitesDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadGroupsSitesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadGroupsSitesDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadGroupsSitesDataQuery, DownloadGroupsSitesDataQueryVariables>(DownloadGroupsSitesDataDocument)
    return useInfiniteQuery<DownloadGroupsSitesDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['downloadGroupsSitesData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadGroupsSitesDataQuery.getKey = (variables: DownloadGroupsSitesDataQueryVariables) => ['downloadGroupsSitesData.infinite', variables];

export const DownloadGroupUsersDataDocument = `
    query downloadGroupUsersData($drawerDataId: ID!, $groupMembersSearch: String, $groupMembersSort: GetGroupMembersSortEnum, $email: String) {
  downloadGroupUsersData(
    drawerDataId: $drawerDataId
    text: $groupMembersSearch
    sort: $groupMembersSort
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadGroupUsersDataQuery = <
      TData = DownloadGroupUsersDataQuery,
      TError = unknown
    >(
      variables: DownloadGroupUsersDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadGroupUsersDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadGroupUsersDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadGroupUsersDataQuery, TError, TData>(
      {
    queryKey: ['downloadGroupUsersData', variables],
    queryFn: useMyQuery<DownloadGroupUsersDataQuery, DownloadGroupUsersDataQueryVariables>(DownloadGroupUsersDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadGroupUsersDataQuery.getKey = (variables: DownloadGroupUsersDataQueryVariables) => ['downloadGroupUsersData', variables];

export const useInfiniteDownloadGroupUsersDataQuery = <
      TData = InfiniteData<DownloadGroupUsersDataQuery>,
      TError = unknown
    >(
      variables: DownloadGroupUsersDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadGroupUsersDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadGroupUsersDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadGroupUsersDataQuery, DownloadGroupUsersDataQueryVariables>(DownloadGroupUsersDataDocument)
    return useInfiniteQuery<DownloadGroupUsersDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['downloadGroupUsersData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadGroupUsersDataQuery.getKey = (variables: DownloadGroupUsersDataQueryVariables) => ['downloadGroupUsersData.infinite', variables];

export const DownloadGroupsDataDocument = `
    query downloadGroupsData($search: String, $sort: GetGroupsSortType, $access: [GroupAccessType!], $type: [GroupType!], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $email: String) {
  downloadGroupsData(
    text: $search
    sort: $sort
    access: $access
    type: $type
    time: $time
    dateRange: $dateRange
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadGroupsDataQuery = <
      TData = DownloadGroupsDataQuery,
      TError = unknown
    >(
      variables?: DownloadGroupsDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadGroupsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadGroupsDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadGroupsDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['downloadGroupsData'] : ['downloadGroupsData', variables],
    queryFn: useMyQuery<DownloadGroupsDataQuery, DownloadGroupsDataQueryVariables>(DownloadGroupsDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadGroupsDataQuery.getKey = (variables?: DownloadGroupsDataQueryVariables) => variables === undefined ? ['downloadGroupsData'] : ['downloadGroupsData', variables];

export const useInfiniteDownloadGroupsDataQuery = <
      TData = InfiniteData<DownloadGroupsDataQuery>,
      TError = unknown
    >(
      variables: DownloadGroupsDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadGroupsDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadGroupsDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadGroupsDataQuery, DownloadGroupsDataQueryVariables>(DownloadGroupsDataDocument)
    return useInfiniteQuery<DownloadGroupsDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['downloadGroupsData.infinite'] : ['downloadGroupsData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadGroupsDataQuery.getKey = (variables?: DownloadGroupsDataQueryVariables) => variables === undefined ? ['downloadGroupsData.infinite'] : ['downloadGroupsData.infinite', variables];

export const DownloadSiteUsersDataDocument = `
    query downloadSiteUsersData($drawerDataId: ID!, $siteAccessSearch: String, $siteAccessSort: GetSiteUsersSortEnum, $drawerFilterTypes: [String], $email: String) {
  downloadSiteUsersData(
    drawerDataId: $drawerDataId
    text: $siteAccessSearch
    sort: $siteAccessSort
    permissions: $drawerFilterTypes
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadSiteUsersDataQuery = <
      TData = DownloadSiteUsersDataQuery,
      TError = unknown
    >(
      variables: DownloadSiteUsersDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadSiteUsersDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadSiteUsersDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadSiteUsersDataQuery, TError, TData>(
      {
    queryKey: ['downloadSiteUsersData', variables],
    queryFn: useMyQuery<DownloadSiteUsersDataQuery, DownloadSiteUsersDataQueryVariables>(DownloadSiteUsersDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadSiteUsersDataQuery.getKey = (variables: DownloadSiteUsersDataQueryVariables) => ['downloadSiteUsersData', variables];

export const useInfiniteDownloadSiteUsersDataQuery = <
      TData = InfiniteData<DownloadSiteUsersDataQuery>,
      TError = unknown
    >(
      variables: DownloadSiteUsersDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadSiteUsersDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadSiteUsersDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadSiteUsersDataQuery, DownloadSiteUsersDataQueryVariables>(DownloadSiteUsersDataDocument)
    return useInfiniteQuery<DownloadSiteUsersDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['downloadSiteUsersData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadSiteUsersDataQuery.getKey = (variables: DownloadSiteUsersDataQueryVariables) => ['downloadSiteUsersData.infinite', variables];

export const DownloadSitesDataDocument = `
    query downloadSitesData($sort: GetSitesSortEnum, $type: [GetSitesTypeEnum], $search: String, $email: String) {
  downloadSitesData(sort: $sort, type: $type, text: $search, email: $email) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadSitesDataQuery = <
      TData = DownloadSitesDataQuery,
      TError = unknown
    >(
      variables?: DownloadSitesDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadSitesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadSitesDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadSitesDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['downloadSitesData'] : ['downloadSitesData', variables],
    queryFn: useMyQuery<DownloadSitesDataQuery, DownloadSitesDataQueryVariables>(DownloadSitesDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadSitesDataQuery.getKey = (variables?: DownloadSitesDataQueryVariables) => variables === undefined ? ['downloadSitesData'] : ['downloadSitesData', variables];

export const useInfiniteDownloadSitesDataQuery = <
      TData = InfiniteData<DownloadSitesDataQuery>,
      TError = unknown
    >(
      variables: DownloadSitesDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadSitesDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadSitesDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadSitesDataQuery, DownloadSitesDataQueryVariables>(DownloadSitesDataDocument)
    return useInfiniteQuery<DownloadSitesDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['downloadSitesData.infinite'] : ['downloadSitesData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadSitesDataQuery.getKey = (variables?: DownloadSitesDataQueryVariables) => variables === undefined ? ['downloadSitesData.infinite'] : ['downloadSitesData.infinite', variables];

export const DownloadUsersDataDocument = `
    query downloadUsersData($search: String, $sort: GetUsersSortEnum, $type: [GetUsersTypeEnum], $isAppUser: Boolean, $email: String) {
  downloadUsersData(
    sort: $sort
    text: $search
    type: $type
    isAppUser: $isAppUser
    email: $email
  ) {
    base64
    fileName
    success
  }
}
    `;

export const useDownloadUsersDataQuery = <
      TData = DownloadUsersDataQuery,
      TError = unknown
    >(
      variables?: DownloadUsersDataQueryVariables,
      options?: Omit<UseQueryOptions<DownloadUsersDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<DownloadUsersDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<DownloadUsersDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['downloadUsersData'] : ['downloadUsersData', variables],
    queryFn: useMyQuery<DownloadUsersDataQuery, DownloadUsersDataQueryVariables>(DownloadUsersDataDocument).bind(null, variables),
    ...options
  }
    )};

useDownloadUsersDataQuery.getKey = (variables?: DownloadUsersDataQueryVariables) => variables === undefined ? ['downloadUsersData'] : ['downloadUsersData', variables];

export const useInfiniteDownloadUsersDataQuery = <
      TData = InfiniteData<DownloadUsersDataQuery>,
      TError = unknown
    >(
      variables: DownloadUsersDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<DownloadUsersDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<DownloadUsersDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<DownloadUsersDataQuery, DownloadUsersDataQueryVariables>(DownloadUsersDataDocument)
    return useInfiniteQuery<DownloadUsersDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['downloadUsersData.infinite'] : ['downloadUsersData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteDownloadUsersDataQuery.getKey = (variables?: DownloadUsersDataQueryVariables) => variables === undefined ? ['downloadUsersData.infinite'] : ['downloadUsersData.infinite', variables];

export const EditAlertDocument = `
    mutation EditAlert($id: ID!, $name: String, $description: String, $severity: String, $status: String, $assignedUser: String, $isResolved: Boolean) {
  editAlert(
    id: $id
    name: $name
    description: $description
    severity: $severity
    status: $status
    assignedUser: $assignedUser
    isResolved: $isResolved
  )
}
    `;

export const useEditAlertMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditAlertMutation, TError, EditAlertMutationVariables, TContext>) => {
    
    return useMutation<EditAlertMutation, TError, EditAlertMutationVariables, TContext>(
      {
    mutationKey: ['EditAlert'],
    mutationFn: useMyQuery<EditAlertMutation, EditAlertMutationVariables>(EditAlertDocument),
    ...options
  }
    )};

export const EditPolicyDocument = `
    mutation EditPolicy($id: ID!, $name: String!, $description: String, $conditions: String, $automations: String, $selectedResources: String, $severity: String!, $type: String!, $assignment: String, $defaultUser: String) {
  editPolicy(
    id: $id
    name: $name
    description: $description
    conditions: $conditions
    automations: $automations
    selectedResources: $selectedResources
    severity: $severity
    type: $type
    assignment: $assignment
    defaultUser: $defaultUser
  )
}
    `;

export const useEditPolicyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditPolicyMutation, TError, EditPolicyMutationVariables, TContext>) => {
    
    return useMutation<EditPolicyMutation, TError, EditPolicyMutationVariables, TContext>(
      {
    mutationKey: ['EditPolicy'],
    mutationFn: useMyQuery<EditPolicyMutation, EditPolicyMutationVariables>(EditPolicyDocument),
    ...options
  }
    )};

export const GetAccessedGroupsDocument = `
    query getAccessedGroups($drawerDataId: ID!, $limit: Int, $offset: Int, $groupAccessedGroupsCompactSearch: String, $sort: GetAccessingGroupsSortEnum) {
  getAccessedGroups(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $groupAccessedGroupsCompactSearch
    sort: $sort
  ) {
    hasNextPage
    nodes {
      id
      name
      type
      usersWithAccess
      isExternal
    }
  }
}
    `;

export const useGetAccessedGroupsQuery = <
      TData = GetAccessedGroupsQuery,
      TError = unknown
    >(
      variables: GetAccessedGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetAccessedGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAccessedGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAccessedGroupsQuery, TError, TData>(
      {
    queryKey: ['getAccessedGroups', variables],
    queryFn: useMyQuery<GetAccessedGroupsQuery, GetAccessedGroupsQueryVariables>(GetAccessedGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAccessedGroupsQuery.getKey = (variables: GetAccessedGroupsQueryVariables) => ['getAccessedGroups', variables];

export const useInfiniteGetAccessedGroupsQuery = <
      TData = InfiniteData<GetAccessedGroupsQuery>,
      TError = unknown
    >(
      variables: GetAccessedGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAccessedGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAccessedGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAccessedGroupsQuery, GetAccessedGroupsQueryVariables>(GetAccessedGroupsDocument)
    return useInfiniteQuery<GetAccessedGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAccessedGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAccessedGroupsQuery.getKey = (variables: GetAccessedGroupsQueryVariables) => ['getAccessedGroups.infinite', variables];

export const GetAccessingGroupsDocument = `
    query getAccessingGroups($drawerDataId: ID!, $limit: Int, $offset: Int, $groupAccessingGroupsCompactSearch: String, $sort: GetAccessingGroupsSortEnum) {
  getAccessingGroups(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $groupAccessingGroupsCompactSearch
    sort: $sort
  ) {
    hasNextPage
    nodes {
      id
      name
      type
      usersWithAccess
      isExternal
    }
  }
}
    `;

export const useGetAccessingGroupsQuery = <
      TData = GetAccessingGroupsQuery,
      TError = unknown
    >(
      variables: GetAccessingGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetAccessingGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAccessingGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAccessingGroupsQuery, TError, TData>(
      {
    queryKey: ['getAccessingGroups', variables],
    queryFn: useMyQuery<GetAccessingGroupsQuery, GetAccessingGroupsQueryVariables>(GetAccessingGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAccessingGroupsQuery.getKey = (variables: GetAccessingGroupsQueryVariables) => ['getAccessingGroups', variables];

export const useInfiniteGetAccessingGroupsQuery = <
      TData = InfiniteData<GetAccessingGroupsQuery>,
      TError = unknown
    >(
      variables: GetAccessingGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAccessingGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAccessingGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAccessingGroupsQuery, GetAccessingGroupsQueryVariables>(GetAccessingGroupsDocument)
    return useInfiniteQuery<GetAccessingGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAccessingGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAccessingGroupsQuery.getKey = (variables: GetAccessingGroupsQueryVariables) => ['getAccessingGroups.infinite', variables];

export const GetAccountOrganizationsDocument = `
    query getAccountOrganizations {
  getAccountOrganizations {
    id
    name
  }
}
    `;

export const useGetAccountOrganizationsQuery = <
      TData = GetAccountOrganizationsQuery,
      TError = unknown
    >(
      variables?: GetAccountOrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<GetAccountOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAccountOrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAccountOrganizationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getAccountOrganizations'] : ['getAccountOrganizations', variables],
    queryFn: useMyQuery<GetAccountOrganizationsQuery, GetAccountOrganizationsQueryVariables>(GetAccountOrganizationsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAccountOrganizationsQuery.getKey = (variables?: GetAccountOrganizationsQueryVariables) => variables === undefined ? ['getAccountOrganizations'] : ['getAccountOrganizations', variables];

export const useInfiniteGetAccountOrganizationsQuery = <
      TData = InfiniteData<GetAccountOrganizationsQuery>,
      TError = unknown
    >(
      variables: GetAccountOrganizationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAccountOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAccountOrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAccountOrganizationsQuery, GetAccountOrganizationsQueryVariables>(GetAccountOrganizationsDocument)
    return useInfiniteQuery<GetAccountOrganizationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getAccountOrganizations.infinite'] : ['getAccountOrganizations.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAccountOrganizationsQuery.getKey = (variables?: GetAccountOrganizationsQueryVariables) => variables === undefined ? ['getAccountOrganizations.infinite'] : ['getAccountOrganizations.infinite', variables];

export const GetAccountUsersDocument = `
    query getAccountUsers {
  getAccountUsers {
    id
    name
    email
    tenantId
    tenantEmailDomain
  }
}
    `;

export const useGetAccountUsersQuery = <
      TData = GetAccountUsersQuery,
      TError = unknown
    >(
      variables?: GetAccountUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetAccountUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAccountUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAccountUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getAccountUsers'] : ['getAccountUsers', variables],
    queryFn: useMyQuery<GetAccountUsersQuery, GetAccountUsersQueryVariables>(GetAccountUsersDocument).bind(null, variables),
    ...options
  }
    )};

useGetAccountUsersQuery.getKey = (variables?: GetAccountUsersQueryVariables) => variables === undefined ? ['getAccountUsers'] : ['getAccountUsers', variables];

export const useInfiniteGetAccountUsersQuery = <
      TData = InfiniteData<GetAccountUsersQuery>,
      TError = unknown
    >(
      variables: GetAccountUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAccountUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAccountUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAccountUsersQuery, GetAccountUsersQueryVariables>(GetAccountUsersDocument)
    return useInfiniteQuery<GetAccountUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getAccountUsers.infinite'] : ['getAccountUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAccountUsersQuery.getKey = (variables?: GetAccountUsersQueryVariables) => variables === undefined ? ['getAccountUsers.infinite'] : ['getAccountUsers.infinite', variables];

export const GetAccountsDocument = `
    query getAccounts($limit: Int, $offset: Int, $search: String, $sort: GetAccountsSortEnum) {
  getAccounts(limit: $limit, offset: $offset, text: $search, sort: $sort) {
    itemsFound
    hasNextPage
    nodes {
      id
      name
      email
      isInvite
    }
  }
}
    `;

export const useGetAccountsQuery = <
      TData = GetAccountsQuery,
      TError = unknown
    >(
      variables?: GetAccountsQueryVariables,
      options?: Omit<UseQueryOptions<GetAccountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAccountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAccountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getAccounts'] : ['getAccounts', variables],
    queryFn: useMyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAccountsQuery.getKey = (variables?: GetAccountsQueryVariables) => variables === undefined ? ['getAccounts'] : ['getAccounts', variables];

export const useInfiniteGetAccountsQuery = <
      TData = InfiniteData<GetAccountsQuery>,
      TError = unknown
    >(
      variables: GetAccountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAccountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAccountsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument)
    return useInfiniteQuery<GetAccountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getAccounts.infinite'] : ['getAccounts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAccountsQuery.getKey = (variables?: GetAccountsQueryVariables) => variables === undefined ? ['getAccounts.infinite'] : ['getAccounts.infinite', variables];

export const GetActiveSensitiveDataDocument = `
    query getActiveSensitiveData {
  getActiveSensitiveData
}
    `;

export const useGetActiveSensitiveDataQuery = <
      TData = GetActiveSensitiveDataQuery,
      TError = unknown
    >(
      variables?: GetActiveSensitiveDataQueryVariables,
      options?: Omit<UseQueryOptions<GetActiveSensitiveDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetActiveSensitiveDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetActiveSensitiveDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getActiveSensitiveData'] : ['getActiveSensitiveData', variables],
    queryFn: useMyQuery<GetActiveSensitiveDataQuery, GetActiveSensitiveDataQueryVariables>(GetActiveSensitiveDataDocument).bind(null, variables),
    ...options
  }
    )};

useGetActiveSensitiveDataQuery.getKey = (variables?: GetActiveSensitiveDataQueryVariables) => variables === undefined ? ['getActiveSensitiveData'] : ['getActiveSensitiveData', variables];

export const useInfiniteGetActiveSensitiveDataQuery = <
      TData = InfiniteData<GetActiveSensitiveDataQuery>,
      TError = unknown
    >(
      variables: GetActiveSensitiveDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetActiveSensitiveDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetActiveSensitiveDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetActiveSensitiveDataQuery, GetActiveSensitiveDataQueryVariables>(GetActiveSensitiveDataDocument)
    return useInfiniteQuery<GetActiveSensitiveDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getActiveSensitiveData.infinite'] : ['getActiveSensitiveData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetActiveSensitiveDataQuery.getKey = (variables?: GetActiveSensitiveDataQueryVariables) => variables === undefined ? ['getActiveSensitiveData.infinite'] : ['getActiveSensitiveData.infinite', variables];

export const GetAlertDocument = `
    query getAlert($drawerDataId: ID!) {
  getAlert(drawerDataId: $drawerDataId) {
    id
    name
    status
    severity
    detectedAt
    resolvedAt
    isResolved
    type
    snoozedAt
    resourceCount
    assignedUser
    createdFrom
    description
  }
}
    `;

export const useGetAlertQuery = <
      TData = GetAlertQuery,
      TError = unknown
    >(
      variables: GetAlertQueryVariables,
      options?: Omit<UseQueryOptions<GetAlertQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAlertQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAlertQuery, TError, TData>(
      {
    queryKey: ['getAlert', variables],
    queryFn: useMyQuery<GetAlertQuery, GetAlertQueryVariables>(GetAlertDocument).bind(null, variables),
    ...options
  }
    )};

useGetAlertQuery.getKey = (variables: GetAlertQueryVariables) => ['getAlert', variables];

export const useInfiniteGetAlertQuery = <
      TData = InfiniteData<GetAlertQuery>,
      TError = unknown
    >(
      variables: GetAlertQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAlertQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAlertQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAlertQuery, GetAlertQueryVariables>(GetAlertDocument)
    return useInfiniteQuery<GetAlertQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAlert.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAlertQuery.getKey = (variables: GetAlertQueryVariables) => ['getAlert.infinite', variables];

export const GetAlertHistoryDocument = `
    query getAlertHistory($alertId: ID!, $limit: Int, $offset: Int) {
  getAlertHistory(alertId: $alertId, limit: $limit, offset: $offset) {
    hasNextPage
    nodes {
      id
      description
      action
      previousState
      newState
      createdAt
      userName
      userEmail
    }
  }
}
    `;

export const useGetAlertHistoryQuery = <
      TData = GetAlertHistoryQuery,
      TError = unknown
    >(
      variables: GetAlertHistoryQueryVariables,
      options?: Omit<UseQueryOptions<GetAlertHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAlertHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAlertHistoryQuery, TError, TData>(
      {
    queryKey: ['getAlertHistory', variables],
    queryFn: useMyQuery<GetAlertHistoryQuery, GetAlertHistoryQueryVariables>(GetAlertHistoryDocument).bind(null, variables),
    ...options
  }
    )};

useGetAlertHistoryQuery.getKey = (variables: GetAlertHistoryQueryVariables) => ['getAlertHistory', variables];

export const useInfiniteGetAlertHistoryQuery = <
      TData = InfiniteData<GetAlertHistoryQuery>,
      TError = unknown
    >(
      variables: GetAlertHistoryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAlertHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAlertHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAlertHistoryQuery, GetAlertHistoryQueryVariables>(GetAlertHistoryDocument)
    return useInfiniteQuery<GetAlertHistoryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAlertHistory.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAlertHistoryQuery.getKey = (variables: GetAlertHistoryQueryVariables) => ['getAlertHistory.infinite', variables];

export const GetAlertResourcesDocument = `
    query getAlertResources($drawerDataId: ID!, $limit: Int, $offset: Int, $alertResourcesListSearch: String, $alertName: String, $drawerSort: GetAlertResourcesSortEnum) {
  getAlertResources(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $alertResourcesListSearch
    alertName: $alertName
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      type
      isResolved
      status
      resolvedAt
      snoozedAt
      createdAt
    }
  }
}
    `;

export const useGetAlertResourcesQuery = <
      TData = GetAlertResourcesQuery,
      TError = unknown
    >(
      variables: GetAlertResourcesQueryVariables,
      options?: Omit<UseQueryOptions<GetAlertResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAlertResourcesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAlertResourcesQuery, TError, TData>(
      {
    queryKey: ['getAlertResources', variables],
    queryFn: useMyQuery<GetAlertResourcesQuery, GetAlertResourcesQueryVariables>(GetAlertResourcesDocument).bind(null, variables),
    ...options
  }
    )};

useGetAlertResourcesQuery.getKey = (variables: GetAlertResourcesQueryVariables) => ['getAlertResources', variables];

export const useInfiniteGetAlertResourcesQuery = <
      TData = InfiniteData<GetAlertResourcesQuery>,
      TError = unknown
    >(
      variables: GetAlertResourcesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAlertResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAlertResourcesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAlertResourcesQuery, GetAlertResourcesQueryVariables>(GetAlertResourcesDocument)
    return useInfiniteQuery<GetAlertResourcesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAlertResources.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAlertResourcesQuery.getKey = (variables: GetAlertResourcesQueryVariables) => ['getAlertResources.infinite', variables];

export const GetAlertsDocument = `
    query GetAlerts($limit: Int, $offset: Int, $sort: GetAlertsSortType, $search: String) {
  getAlerts(limit: $limit, offset: $offset, sort: $sort, text: $search) {
    hasNextPage
    itemsFound
    nodes {
      id
      name
      status
      severity
      detectedAt
      resolvedAt
      isResolved
      type
      snoozedAt
      resourceCount
      assignedUser
      createdFrom
    }
  }
}
    `;

export const useGetAlertsQuery = <
      TData = GetAlertsQuery,
      TError = unknown
    >(
      variables?: GetAlertsQueryVariables,
      options?: Omit<UseQueryOptions<GetAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAlertsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetAlerts'] : ['GetAlerts', variables],
    queryFn: useMyQuery<GetAlertsQuery, GetAlertsQueryVariables>(GetAlertsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAlertsQuery.getKey = (variables?: GetAlertsQueryVariables) => variables === undefined ? ['GetAlerts'] : ['GetAlerts', variables];

export const useInfiniteGetAlertsQuery = <
      TData = InfiniteData<GetAlertsQuery>,
      TError = unknown
    >(
      variables: GetAlertsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAlertsQuery, GetAlertsQueryVariables>(GetAlertsDocument)
    return useInfiniteQuery<GetAlertsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetAlerts.infinite'] : ['GetAlerts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAlertsQuery.getKey = (variables?: GetAlertsQueryVariables) => variables === undefined ? ['GetAlerts.infinite'] : ['GetAlerts.infinite', variables];

export const GetAllConnectedTenantsDocument = `
    query getAllConnectedTenants {
  getAllConnectedTenants {
    id
    name
    emailDomain
    isDemo
  }
}
    `;

export const useGetAllConnectedTenantsQuery = <
      TData = GetAllConnectedTenantsQuery,
      TError = unknown
    >(
      variables?: GetAllConnectedTenantsQueryVariables,
      options?: Omit<UseQueryOptions<GetAllConnectedTenantsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAllConnectedTenantsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAllConnectedTenantsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getAllConnectedTenants'] : ['getAllConnectedTenants', variables],
    queryFn: useMyQuery<GetAllConnectedTenantsQuery, GetAllConnectedTenantsQueryVariables>(GetAllConnectedTenantsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAllConnectedTenantsQuery.getKey = (variables?: GetAllConnectedTenantsQueryVariables) => variables === undefined ? ['getAllConnectedTenants'] : ['getAllConnectedTenants', variables];

export const useInfiniteGetAllConnectedTenantsQuery = <
      TData = InfiniteData<GetAllConnectedTenantsQuery>,
      TError = unknown
    >(
      variables: GetAllConnectedTenantsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAllConnectedTenantsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAllConnectedTenantsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAllConnectedTenantsQuery, GetAllConnectedTenantsQueryVariables>(GetAllConnectedTenantsDocument)
    return useInfiniteQuery<GetAllConnectedTenantsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getAllConnectedTenants.infinite'] : ['getAllConnectedTenants.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAllConnectedTenantsQuery.getKey = (variables?: GetAllConnectedTenantsQueryVariables) => variables === undefined ? ['getAllConnectedTenants.infinite'] : ['getAllConnectedTenants.infinite', variables];

export const GetAppDocument = `
    query getApp($drawerDataId: ID!) {
  getApp(drawerDataId: $drawerDataId) {
    id
    name
    logoUrl
    homepage
    publisherName
    logoUrl
    description
    registeredApplication
    enterpriseApplication
    files
    usersWithAccess
    sensitiveInfo
    groups
    permissions
  }
}
    `;

export const useGetAppQuery = <
      TData = GetAppQuery,
      TError = unknown
    >(
      variables: GetAppQueryVariables,
      options?: Omit<UseQueryOptions<GetAppQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppQuery, TError, TData>(
      {
    queryKey: ['getApp', variables],
    queryFn: useMyQuery<GetAppQuery, GetAppQueryVariables>(GetAppDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppQuery.getKey = (variables: GetAppQueryVariables) => ['getApp', variables];

export const useInfiniteGetAppQuery = <
      TData = InfiniteData<GetAppQuery>,
      TError = unknown
    >(
      variables: GetAppQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppQuery, GetAppQueryVariables>(GetAppDocument)
    return useInfiniteQuery<GetAppQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getApp.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppQuery.getKey = (variables: GetAppQueryVariables) => ['getApp.infinite', variables];

export const GetAppAlertsDocument = `
    query getAppAlerts($drawerDataId: ID!, $limit: Int, $offset: Int, $appFilesListSearch: String, $appName: String, $drawerSort: GetResourceAlertsSortEnum) {
  getAppAlerts(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $appFilesListSearch
    appName: $appName
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      status
      severity
      detectedAt
      resolvedAt
    }
  }
}
    `;

export const useGetAppAlertsQuery = <
      TData = GetAppAlertsQuery,
      TError = unknown
    >(
      variables: GetAppAlertsQueryVariables,
      options?: Omit<UseQueryOptions<GetAppAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppAlertsQuery, TError, TData>(
      {
    queryKey: ['getAppAlerts', variables],
    queryFn: useMyQuery<GetAppAlertsQuery, GetAppAlertsQueryVariables>(GetAppAlertsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppAlertsQuery.getKey = (variables: GetAppAlertsQueryVariables) => ['getAppAlerts', variables];

export const useInfiniteGetAppAlertsQuery = <
      TData = InfiniteData<GetAppAlertsQuery>,
      TError = unknown
    >(
      variables: GetAppAlertsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppAlertsQuery, GetAppAlertsQueryVariables>(GetAppAlertsDocument)
    return useInfiniteQuery<GetAppAlertsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAppAlerts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppAlertsQuery.getKey = (variables: GetAppAlertsQueryVariables) => ['getAppAlerts.infinite', variables];

export const GetAppFilesDocument = `
    query getAppFiles($drawerDataId: ID!, $limit: Int, $offset: Int, $appFilesListSearch: String, $appName: String, $drawerSort: GetAppFilesSortEnum) {
  getAppFiles(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $appFilesListSearch
    appName: $appName
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      sensitivity
      size
      files
      lastModified
      createdDate
      webUrl
      createdBy
      modifiedBy
      type
      fileSensitivityLabels
    }
  }
}
    `;

export const useGetAppFilesQuery = <
      TData = GetAppFilesQuery,
      TError = unknown
    >(
      variables: GetAppFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetAppFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppFilesQuery, TError, TData>(
      {
    queryKey: ['getAppFiles', variables],
    queryFn: useMyQuery<GetAppFilesQuery, GetAppFilesQueryVariables>(GetAppFilesDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppFilesQuery.getKey = (variables: GetAppFilesQueryVariables) => ['getAppFiles', variables];

export const useInfiniteGetAppFilesQuery = <
      TData = InfiniteData<GetAppFilesQuery>,
      TError = unknown
    >(
      variables: GetAppFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppFilesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppFilesQuery, GetAppFilesQueryVariables>(GetAppFilesDocument)
    return useInfiniteQuery<GetAppFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAppFiles.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppFilesQuery.getKey = (variables: GetAppFilesQueryVariables) => ['getAppFiles.infinite', variables];

export const GetAppFilterCountsDocument = `
    query getAppFilterCounts {
  getAppFilterCounts {
    all
    directory
    email
    sites
    applications
    auditLogs
    chat
    files
    groups
    connected1Day
    connected7Days
    connected30Days
    connected90Days
    connected1Year
    lastUsed1Day
    lastUsed7Days
    lastUsed30Days
    lastUsed90Days
    lastUsed1Year
    externalUsers
    internalUsers
    inactiveUsers
    activeUsers
    approved
    waitingForReview
    notPermitted
    verified
    unverified
    enterprise
    appRegistration
    addIn
  }
}
    `;

export const useGetAppFilterCountsQuery = <
      TData = GetAppFilterCountsQuery,
      TError = unknown
    >(
      variables?: GetAppFilterCountsQueryVariables,
      options?: Omit<UseQueryOptions<GetAppFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppFilterCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getAppFilterCounts'] : ['getAppFilterCounts', variables],
    queryFn: useMyQuery<GetAppFilterCountsQuery, GetAppFilterCountsQueryVariables>(GetAppFilterCountsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppFilterCountsQuery.getKey = (variables?: GetAppFilterCountsQueryVariables) => variables === undefined ? ['getAppFilterCounts'] : ['getAppFilterCounts', variables];

export const useInfiniteGetAppFilterCountsQuery = <
      TData = InfiniteData<GetAppFilterCountsQuery>,
      TError = unknown
    >(
      variables: GetAppFilterCountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppFilterCountsQuery, GetAppFilterCountsQueryVariables>(GetAppFilterCountsDocument)
    return useInfiniteQuery<GetAppFilterCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getAppFilterCounts.infinite'] : ['getAppFilterCounts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppFilterCountsQuery.getKey = (variables?: GetAppFilterCountsQueryVariables) => variables === undefined ? ['getAppFilterCounts.infinite'] : ['getAppFilterCounts.infinite', variables];

export const GetAppGroupsDocument = `
    query getAppGroups($drawerDataId: ID!, $limit: Int, $offset: Int, $appGroupListSearch: String, $drawerSort: getAppGroupsSortEnum) {
  getAppGroups(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $appGroupListSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      type
      internalUsers
      externalUsers
      totalUsers
      groupSensitivityLabels
    }
  }
}
    `;

export const useGetAppGroupsQuery = <
      TData = GetAppGroupsQuery,
      TError = unknown
    >(
      variables: GetAppGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetAppGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppGroupsQuery, TError, TData>(
      {
    queryKey: ['getAppGroups', variables],
    queryFn: useMyQuery<GetAppGroupsQuery, GetAppGroupsQueryVariables>(GetAppGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppGroupsQuery.getKey = (variables: GetAppGroupsQueryVariables) => ['getAppGroups', variables];

export const useInfiniteGetAppGroupsQuery = <
      TData = InfiniteData<GetAppGroupsQuery>,
      TError = unknown
    >(
      variables: GetAppGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppGroupsQuery, GetAppGroupsQueryVariables>(GetAppGroupsDocument)
    return useInfiniteQuery<GetAppGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAppGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppGroupsQuery.getKey = (variables: GetAppGroupsQueryVariables) => ['getAppGroups.infinite', variables];

export const GetAppPermissionsDocument = `
    query getAppPermissions($drawerDataId: ID!, $limit: Int, $offset: Int, $appPermissionsListSearch: String, $drawerSort: GetAppPermissionsEnum) {
  getAppPermissions(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $appPermissionsListSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      name
      isConsentRequired
      type
      apiName
      description
    }
  }
}
    `;

export const useGetAppPermissionsQuery = <
      TData = GetAppPermissionsQuery,
      TError = unknown
    >(
      variables: GetAppPermissionsQueryVariables,
      options?: Omit<UseQueryOptions<GetAppPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppPermissionsQuery, TError, TData>(
      {
    queryKey: ['getAppPermissions', variables],
    queryFn: useMyQuery<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>(GetAppPermissionsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppPermissionsQuery.getKey = (variables: GetAppPermissionsQueryVariables) => ['getAppPermissions', variables];

export const useInfiniteGetAppPermissionsQuery = <
      TData = InfiniteData<GetAppPermissionsQuery>,
      TError = unknown
    >(
      variables: GetAppPermissionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppPermissionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppPermissionsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppPermissionsQuery, GetAppPermissionsQueryVariables>(GetAppPermissionsDocument)
    return useInfiniteQuery<GetAppPermissionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAppPermissions.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppPermissionsQuery.getKey = (variables: GetAppPermissionsQueryVariables) => ['getAppPermissions.infinite', variables];

export const GetAppSensitiveInfoDocument = `
    query getAppSensitiveInfo($drawerDataId: ID!, $appSensitiveInfoListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerSensitiveInfoSortEnum) {
  getAppSensitiveInfo(
    drawerDataId: $drawerDataId
    text: $appSensitiveInfoListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetAppSensitiveInfoQuery = <
      TData = GetAppSensitiveInfoQuery,
      TError = unknown
    >(
      variables: GetAppSensitiveInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetAppSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppSensitiveInfoQuery, TError, TData>(
      {
    queryKey: ['getAppSensitiveInfo', variables],
    queryFn: useMyQuery<GetAppSensitiveInfoQuery, GetAppSensitiveInfoQueryVariables>(GetAppSensitiveInfoDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppSensitiveInfoQuery.getKey = (variables: GetAppSensitiveInfoQueryVariables) => ['getAppSensitiveInfo', variables];

export const useInfiniteGetAppSensitiveInfoQuery = <
      TData = InfiniteData<GetAppSensitiveInfoQuery>,
      TError = unknown
    >(
      variables: GetAppSensitiveInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppSensitiveInfoQuery, GetAppSensitiveInfoQueryVariables>(GetAppSensitiveInfoDocument)
    return useInfiniteQuery<GetAppSensitiveInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAppSensitiveInfo.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppSensitiveInfoQuery.getKey = (variables: GetAppSensitiveInfoQueryVariables) => ['getAppSensitiveInfo.infinite', variables];

export const GetAppUsersDocument = `
    query getAppUsers($drawerDataId: ID!, $limit: Int, $offset: Int, $usersSearch: String, $drawerSort: GetAppUsersSortEnum) {
  getAppUsers(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $usersSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      userName
      avatar
      emailDomain
      isExternal
      signInDisabledAt
      azureRegisteredAt
      canAdminConsent
      connectedApps
      accessibleFiles
      totalGroupMemberships
      licenses
      lastSignIn
      hasMfa
    }
  }
}
    `;

export const useGetAppUsersQuery = <
      TData = GetAppUsersQuery,
      TError = unknown
    >(
      variables: GetAppUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetAppUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppUsersQuery, TError, TData>(
      {
    queryKey: ['getAppUsers', variables],
    queryFn: useMyQuery<GetAppUsersQuery, GetAppUsersQueryVariables>(GetAppUsersDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppUsersQuery.getKey = (variables: GetAppUsersQueryVariables) => ['getAppUsers', variables];

export const useInfiniteGetAppUsersQuery = <
      TData = InfiniteData<GetAppUsersQuery>,
      TError = unknown
    >(
      variables: GetAppUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppUsersQuery, GetAppUsersQueryVariables>(GetAppUsersDocument)
    return useInfiniteQuery<GetAppUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAppUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppUsersQuery.getKey = (variables: GetAppUsersQueryVariables) => ['getAppUsers.infinite', variables];

export const GetAppsDocument = `
    query getApps($limit: Int, $offset: Int, $sort: GetAppsSortEnum, $search: String, $textUser: String, $approvalStatus: [GetAppsApprovalStatusEnum], $publisherStatus: [GetAppsPublisherStatusEnum], $userActivity: [GetAppsActivityEnum], $permissions: [String], $external: [GetAppsExternalEnum], $applicationType: [GetAppsApplicationEnum], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $drawerDataId: ID) {
  getApps(
    limit: $limit
    offset: $offset
    sort: $sort
    text: $search
    textUser: $textUser
    approvalStatus: $approvalStatus
    publisherStatus: $publisherStatus
    userActivity: $userActivity
    permissions: $permissions
    external: $external
    time: $time
    dateRange: $dateRange
    applicationType: $applicationType
    policyId: $drawerDataId
  ) {
    itemsFound
    hasNextPage
    nodes {
      id
      name
      logoUrl
      connected
      lastUsed
      users
      inactiveUsers
      externalUsers
      approvalStatus
      firstAdminUser
      registeredApplication
      enterpriseApplication
      addInApplication
      filesAccess
      usersAccess
      emailsAccess
      homepage
      publisherName
      description
      files
      sensitivityLabels
      filesWithSensitivityLabels
      sensitiveInfo
    }
  }
}
    `;

export const useGetAppsQuery = <
      TData = GetAppsQuery,
      TError = unknown
    >(
      variables?: GetAppsQueryVariables,
      options?: Omit<UseQueryOptions<GetAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getApps'] : ['getApps', variables],
    queryFn: useMyQuery<GetAppsQuery, GetAppsQueryVariables>(GetAppsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppsQuery.getKey = (variables?: GetAppsQueryVariables) => variables === undefined ? ['getApps'] : ['getApps', variables];

export const useInfiniteGetAppsQuery = <
      TData = InfiniteData<GetAppsQuery>,
      TError = unknown
    >(
      variables: GetAppsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppsQuery, GetAppsQueryVariables>(GetAppsDocument)
    return useInfiniteQuery<GetAppsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getApps.infinite'] : ['getApps.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppsQuery.getKey = (variables?: GetAppsQueryVariables) => variables === undefined ? ['getApps.infinite'] : ['getApps.infinite', variables];

export const GetAppLabelsDocument = `
    query getAppLabels($drawerDataId: ID!, $appLabelsListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerLabelsSortEnum) {
  getAppLabels(
    drawerDataId: $drawerDataId
    text: $appLabelsListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      description
      color
      contentFormats
      hasProtection
      isActive
      isAppliable
      sensitivity
      tooltip
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetAppLabelsQuery = <
      TData = GetAppLabelsQuery,
      TError = unknown
    >(
      variables: GetAppLabelsQueryVariables,
      options?: Omit<UseQueryOptions<GetAppLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetAppLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetAppLabelsQuery, TError, TData>(
      {
    queryKey: ['getAppLabels', variables],
    queryFn: useMyQuery<GetAppLabelsQuery, GetAppLabelsQueryVariables>(GetAppLabelsDocument).bind(null, variables),
    ...options
  }
    )};

useGetAppLabelsQuery.getKey = (variables: GetAppLabelsQueryVariables) => ['getAppLabels', variables];

export const useInfiniteGetAppLabelsQuery = <
      TData = InfiniteData<GetAppLabelsQuery>,
      TError = unknown
    >(
      variables: GetAppLabelsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetAppLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetAppLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetAppLabelsQuery, GetAppLabelsQueryVariables>(GetAppLabelsDocument)
    return useInfiniteQuery<GetAppLabelsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getAppLabels.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetAppLabelsQuery.getKey = (variables: GetAppLabelsQueryVariables) => ['getAppLabels.infinite', variables];

export const GetCurrentOrganizationDocument = `
    query getCurrentOrganization {
  getCurrentOrganization {
    id
    name
    accessType
  }
}
    `;

export const useGetCurrentOrganizationQuery = <
      TData = GetCurrentOrganizationQuery,
      TError = unknown
    >(
      variables?: GetCurrentOrganizationQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentOrganizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentOrganizationQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentOrganizationQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getCurrentOrganization'] : ['getCurrentOrganization', variables],
    queryFn: useMyQuery<GetCurrentOrganizationQuery, GetCurrentOrganizationQueryVariables>(GetCurrentOrganizationDocument).bind(null, variables),
    ...options
  }
    )};

useGetCurrentOrganizationQuery.getKey = (variables?: GetCurrentOrganizationQueryVariables) => variables === undefined ? ['getCurrentOrganization'] : ['getCurrentOrganization', variables];

export const useInfiniteGetCurrentOrganizationQuery = <
      TData = InfiniteData<GetCurrentOrganizationQuery>,
      TError = unknown
    >(
      variables: GetCurrentOrganizationQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentOrganizationQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentOrganizationQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetCurrentOrganizationQuery, GetCurrentOrganizationQueryVariables>(GetCurrentOrganizationDocument)
    return useInfiniteQuery<GetCurrentOrganizationQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getCurrentOrganization.infinite'] : ['getCurrentOrganization.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentOrganizationQuery.getKey = (variables?: GetCurrentOrganizationQueryVariables) => variables === undefined ? ['getCurrentOrganization.infinite'] : ['getCurrentOrganization.infinite', variables];

export const GetCurrentTenantDocument = `
    query getCurrentTenant {
  getCurrentTenant {
    id
    name
    emailDomain
    scanStatus
    isDemo
    lastScannedAt
  }
}
    `;

export const useGetCurrentTenantQuery = <
      TData = GetCurrentTenantQuery,
      TError = unknown
    >(
      variables?: GetCurrentTenantQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentTenantQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentTenantQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getCurrentTenant'] : ['getCurrentTenant', variables],
    queryFn: useMyQuery<GetCurrentTenantQuery, GetCurrentTenantQueryVariables>(GetCurrentTenantDocument).bind(null, variables),
    ...options
  }
    )};

useGetCurrentTenantQuery.getKey = (variables?: GetCurrentTenantQueryVariables) => variables === undefined ? ['getCurrentTenant'] : ['getCurrentTenant', variables];

export const useInfiniteGetCurrentTenantQuery = <
      TData = InfiniteData<GetCurrentTenantQuery>,
      TError = unknown
    >(
      variables: GetCurrentTenantQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentTenantQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentTenantQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetCurrentTenantQuery, GetCurrentTenantQueryVariables>(GetCurrentTenantDocument)
    return useInfiniteQuery<GetCurrentTenantQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getCurrentTenant.infinite'] : ['getCurrentTenant.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentTenantQuery.getKey = (variables?: GetCurrentTenantQueryVariables) => variables === undefined ? ['getCurrentTenant.infinite'] : ['getCurrentTenant.infinite', variables];

export const GetCurrentTenantAzureIdDocument = `
    query getCurrentTenantAzureId {
  getCurrentTenantAzureId
}
    `;

export const useGetCurrentTenantAzureIdQuery = <
      TData = GetCurrentTenantAzureIdQuery,
      TError = unknown
    >(
      variables?: GetCurrentTenantAzureIdQueryVariables,
      options?: Omit<UseQueryOptions<GetCurrentTenantAzureIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetCurrentTenantAzureIdQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetCurrentTenantAzureIdQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getCurrentTenantAzureId'] : ['getCurrentTenantAzureId', variables],
    queryFn: useMyQuery<GetCurrentTenantAzureIdQuery, GetCurrentTenantAzureIdQueryVariables>(GetCurrentTenantAzureIdDocument).bind(null, variables),
    ...options
  }
    )};

useGetCurrentTenantAzureIdQuery.getKey = (variables?: GetCurrentTenantAzureIdQueryVariables) => variables === undefined ? ['getCurrentTenantAzureId'] : ['getCurrentTenantAzureId', variables];

export const useInfiniteGetCurrentTenantAzureIdQuery = <
      TData = InfiniteData<GetCurrentTenantAzureIdQuery>,
      TError = unknown
    >(
      variables: GetCurrentTenantAzureIdQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetCurrentTenantAzureIdQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetCurrentTenantAzureIdQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetCurrentTenantAzureIdQuery, GetCurrentTenantAzureIdQueryVariables>(GetCurrentTenantAzureIdDocument)
    return useInfiniteQuery<GetCurrentTenantAzureIdQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getCurrentTenantAzureId.infinite'] : ['getCurrentTenantAzureId.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetCurrentTenantAzureIdQuery.getKey = (variables?: GetCurrentTenantAzureIdQueryVariables) => variables === undefined ? ['getCurrentTenantAzureId.infinite'] : ['getCurrentTenantAzureId.infinite', variables];

export const GetFileDocument = `
    query getFile($drawerDataId: ID!) {
  getFile(folderId: $drawerDataId) {
    id
    name
    size
    type
    description
    help
    createdBy {
      user {
        id
        originId
        name
        displayName
        email
      }
    }
    lastModifiedBy {
      user {
        id
        originId
        displayName
        email
      }
    }
    level
    path {
      id
      name
    }
    parentId
    shareLink
    webUrl
    sourceType
    createdDate
    lastModified
    tenantId
    sharedExternally
    sharedWithAnyone
    usersWithAccess
    files
    sourceType
    sensitivity
    topFileSensitivity
    groupsWithAccess
    links
    sensitivityLabels
    sensitiveData
    apps
  }
}
    `;

export const useGetFileQuery = <
      TData = GetFileQuery,
      TError = unknown
    >(
      variables: GetFileQueryVariables,
      options?: Omit<UseQueryOptions<GetFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileQuery, TError, TData>(
      {
    queryKey: ['getFile', variables],
    queryFn: useMyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileQuery.getKey = (variables: GetFileQueryVariables) => ['getFile', variables];

export const useInfiniteGetFileQuery = <
      TData = InfiniteData<GetFileQuery>,
      TError = unknown
    >(
      variables: GetFileQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument)
    return useInfiniteQuery<GetFileQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFile.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileQuery.getKey = (variables: GetFileQueryVariables) => ['getFile.infinite', variables];

export const GetFileAlertsDocument = `
    query getFileAlerts($drawerDataId: ID!, $fileAppsSearch: String, $limit: Int, $offset: Int, $drawerSort: GetResourceAlertsSortEnum) {
  getFileAlerts(
    drawerDataId: $drawerDataId
    text: $fileAppsSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      status
      severity
      detectedAt
      resolvedAt
    }
  }
}
    `;

export const useGetFileAlertsQuery = <
      TData = GetFileAlertsQuery,
      TError = unknown
    >(
      variables: GetFileAlertsQueryVariables,
      options?: Omit<UseQueryOptions<GetFileAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileAlertsQuery, TError, TData>(
      {
    queryKey: ['getFileAlerts', variables],
    queryFn: useMyQuery<GetFileAlertsQuery, GetFileAlertsQueryVariables>(GetFileAlertsDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileAlertsQuery.getKey = (variables: GetFileAlertsQueryVariables) => ['getFileAlerts', variables];

export const useInfiniteGetFileAlertsQuery = <
      TData = InfiniteData<GetFileAlertsQuery>,
      TError = unknown
    >(
      variables: GetFileAlertsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileAlertsQuery, GetFileAlertsQueryVariables>(GetFileAlertsDocument)
    return useInfiniteQuery<GetFileAlertsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileAlerts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileAlertsQuery.getKey = (variables: GetFileAlertsQueryVariables) => ['getFileAlerts.infinite', variables];

export const GetFileAppsDocument = `
    query getFileApps($drawerDataId: ID!, $fileAppsSearch: String, $limit: Int, $offset: Int, $drawerSort: GetAppsSortEnum) {
  getFileApps(
    drawerDataId: $drawerDataId
    text: $fileAppsSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      connected
      users
      externalUsers
      firstAdminUser
      filesAccess
      usersAccess
      emailsAccess
      logoUrl
      sensitivity
      files
    }
  }
}
    `;

export const useGetFileAppsQuery = <
      TData = GetFileAppsQuery,
      TError = unknown
    >(
      variables: GetFileAppsQueryVariables,
      options?: Omit<UseQueryOptions<GetFileAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileAppsQuery, TError, TData>(
      {
    queryKey: ['getFileApps', variables],
    queryFn: useMyQuery<GetFileAppsQuery, GetFileAppsQueryVariables>(GetFileAppsDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileAppsQuery.getKey = (variables: GetFileAppsQueryVariables) => ['getFileApps', variables];

export const useInfiniteGetFileAppsQuery = <
      TData = InfiniteData<GetFileAppsQuery>,
      TError = unknown
    >(
      variables: GetFileAppsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileAppsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileAppsQuery, GetFileAppsQueryVariables>(GetFileAppsDocument)
    return useInfiniteQuery<GetFileAppsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileApps.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileAppsQuery.getKey = (variables: GetFileAppsQueryVariables) => ['getFileApps.infinite', variables];

export const GetFileDirectAccessUsersDocument = `
    query getFileDirectAccessUsers($drawerDataId: ID!, $accessType: GetFileDirectAccessUsersAccessType!) {
  getFileDirectAccessUsers(drawerDataId: $drawerDataId, accessType: $accessType) {
    hasNextPage
    nodes {
      id
      userName
      isExternal
      email
      emailDomain
    }
  }
}
    `;

export const useGetFileDirectAccessUsersQuery = <
      TData = GetFileDirectAccessUsersQuery,
      TError = unknown
    >(
      variables: GetFileDirectAccessUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetFileDirectAccessUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileDirectAccessUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileDirectAccessUsersQuery, TError, TData>(
      {
    queryKey: ['getFileDirectAccessUsers', variables],
    queryFn: useMyQuery<GetFileDirectAccessUsersQuery, GetFileDirectAccessUsersQueryVariables>(GetFileDirectAccessUsersDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileDirectAccessUsersQuery.getKey = (variables: GetFileDirectAccessUsersQueryVariables) => ['getFileDirectAccessUsers', variables];

export const useInfiniteGetFileDirectAccessUsersQuery = <
      TData = InfiniteData<GetFileDirectAccessUsersQuery>,
      TError = unknown
    >(
      variables: GetFileDirectAccessUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileDirectAccessUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileDirectAccessUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileDirectAccessUsersQuery, GetFileDirectAccessUsersQueryVariables>(GetFileDirectAccessUsersDocument)
    return useInfiniteQuery<GetFileDirectAccessUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileDirectAccessUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileDirectAccessUsersQuery.getKey = (variables: GetFileDirectAccessUsersQueryVariables) => ['getFileDirectAccessUsers.infinite', variables];

export const GetFileFilterCountsDocument = `
    query getFileFilterCounts {
  getFileFilterCounts {
    all
    allFiles
    externalUsers
    sharedWithAnyone
    sharedWithOrganization
    internalUsers
    allMicrosoft
    allStandard
    word
    sheet
    slides
    onenote
    list
    whiteboard
    pdf
    image
    videos
    audio
    archives
    other
    folders
    allSites
    personalOneDriveSites
    sharePointSites
    sharePointSubSites
    sharePointHubSites
    allDrives
    allContainers
    oneDriveDrives
    sharePointDrives
    sharePointSystemDocumentLibrary
    sharePointSystemPageLibrary
    oneDrive
    sharePoint
    createdLast1Day
    createdLast7Days
    createdLast30Days
    createdLast90Days
    createdLast1Year
    modifiedLast1Day
    modifiedLast7Days
    modifiedLast30Days
    modifiedLast90Days
    modifiedLast1Year
    appsWithAccess
    withLabel
    withoutLabel
  }
}
    `;

export const useGetFileFilterCountsQuery = <
      TData = GetFileFilterCountsQuery,
      TError = unknown
    >(
      variables?: GetFileFilterCountsQueryVariables,
      options?: Omit<UseQueryOptions<GetFileFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileFilterCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getFileFilterCounts'] : ['getFileFilterCounts', variables],
    queryFn: useMyQuery<GetFileFilterCountsQuery, GetFileFilterCountsQueryVariables>(GetFileFilterCountsDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileFilterCountsQuery.getKey = (variables?: GetFileFilterCountsQueryVariables) => variables === undefined ? ['getFileFilterCounts'] : ['getFileFilterCounts', variables];

export const useInfiniteGetFileFilterCountsQuery = <
      TData = InfiniteData<GetFileFilterCountsQuery>,
      TError = unknown
    >(
      variables: GetFileFilterCountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileFilterCountsQuery, GetFileFilterCountsQueryVariables>(GetFileFilterCountsDocument)
    return useInfiniteQuery<GetFileFilterCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getFileFilterCounts.infinite'] : ['getFileFilterCounts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileFilterCountsQuery.getKey = (variables?: GetFileFilterCountsQueryVariables) => variables === undefined ? ['getFileFilterCounts.infinite'] : ['getFileFilterCounts.infinite', variables];

export const GetFileGraphDocument = `
    query getFileGraph($drawerDataId: ID, $text: String) {
  getFileGraph(fileId: $drawerDataId, text: $text) {
    nodes {
      id
      name
      type
      page
      resource
      drawerDataId
      icon
      color
      users
      files
      groups
      filters {
        permissions
        type
      }
    }
    edges {
      from
      to
    }
    legend {
      name
      color
      icon
      type
    }
  }
}
    `;

export const useGetFileGraphQuery = <
      TData = GetFileGraphQuery,
      TError = unknown
    >(
      variables?: GetFileGraphQueryVariables,
      options?: Omit<UseQueryOptions<GetFileGraphQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileGraphQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileGraphQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getFileGraph'] : ['getFileGraph', variables],
    queryFn: useMyQuery<GetFileGraphQuery, GetFileGraphQueryVariables>(GetFileGraphDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileGraphQuery.getKey = (variables?: GetFileGraphQueryVariables) => variables === undefined ? ['getFileGraph'] : ['getFileGraph', variables];

export const useInfiniteGetFileGraphQuery = <
      TData = InfiniteData<GetFileGraphQuery>,
      TError = unknown
    >(
      variables: GetFileGraphQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileGraphQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileGraphQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileGraphQuery, GetFileGraphQueryVariables>(GetFileGraphDocument)
    return useInfiniteQuery<GetFileGraphQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getFileGraph.infinite'] : ['getFileGraph.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileGraphQuery.getKey = (variables?: GetFileGraphQueryVariables) => variables === undefined ? ['getFileGraph.infinite'] : ['getFileGraph.infinite', variables];

export const GetFileGroupsDocument = `
    query getFileGroups($drawerDataId: ID!, $fileGroupsListSearch: String, $limit: Int, $offset: Int, $drawerSort: getFileGroupsSortEnum, $drawerFilterTypes: [GroupType!]) {
  getFileGroups(
    drawerDataId: $drawerDataId
    text: $fileGroupsListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
    type: $drawerFilterTypes
  ) {
    hasNextPage
    nodes {
      id
      name
      type
      highestSitePermission
      indirectInternalUsers
      indirectExternalUsers
      totalIndirectUsers
      directInternalUsers
      directExternalUsers
      totalDirectUsers
      totalUsers
      accessThrough
      groupSensitivityLabels
    }
  }
}
    `;

export const useGetFileGroupsQuery = <
      TData = GetFileGroupsQuery,
      TError = unknown
    >(
      variables: GetFileGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetFileGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileGroupsQuery, TError, TData>(
      {
    queryKey: ['getFileGroups', variables],
    queryFn: useMyQuery<GetFileGroupsQuery, GetFileGroupsQueryVariables>(GetFileGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileGroupsQuery.getKey = (variables: GetFileGroupsQueryVariables) => ['getFileGroups', variables];

export const useInfiniteGetFileGroupsQuery = <
      TData = InfiniteData<GetFileGroupsQuery>,
      TError = unknown
    >(
      variables: GetFileGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileGroupsQuery, GetFileGroupsQueryVariables>(GetFileGroupsDocument)
    return useInfiniteQuery<GetFileGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileGroupsQuery.getKey = (variables: GetFileGroupsQueryVariables) => ['getFileGroups.infinite', variables];

export const GetFileItemsCountDocument = `
    query getFileItemsCount($folderId: ID, $search: String, $additionalResults: Boolean, $sort: GetFilesSortType, $access: [AccessType], $fileTypes: [String], $fileContainers: [FileContainerType], $createdBy: String, $lastModifiedBy: String, $filesAccessibleToUser: String, $location: [String], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $listType: String, $labels: [LabelType], $createdAt: DateRange, $modifiedAt: DateRange) {
  getFileItemsCount(
    folderId: $folderId
    text: $search
    fileTypes: $fileTypes
    sort: $sort
    dateRange: $dateRange
    access: $access
    fileContainers: $fileContainers
    location: $location
    createdBy: $createdBy
    lastModifiedBy: $lastModifiedBy
    filesAccessibleToUser: $filesAccessibleToUser
    time: $time
    additionalResults: $additionalResults
    listType: $listType
    labels: $labels
    createdAt: $createdAt
    modifiedAt: $modifiedAt
  )
}
    `;

export const useGetFileItemsCountQuery = <
      TData = GetFileItemsCountQuery,
      TError = unknown
    >(
      variables?: GetFileItemsCountQueryVariables,
      options?: Omit<UseQueryOptions<GetFileItemsCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileItemsCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileItemsCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getFileItemsCount'] : ['getFileItemsCount', variables],
    queryFn: useMyQuery<GetFileItemsCountQuery, GetFileItemsCountQueryVariables>(GetFileItemsCountDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileItemsCountQuery.getKey = (variables?: GetFileItemsCountQueryVariables) => variables === undefined ? ['getFileItemsCount'] : ['getFileItemsCount', variables];

export const useInfiniteGetFileItemsCountQuery = <
      TData = InfiniteData<GetFileItemsCountQuery>,
      TError = unknown
    >(
      variables: GetFileItemsCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileItemsCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileItemsCountQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileItemsCountQuery, GetFileItemsCountQueryVariables>(GetFileItemsCountDocument)
    return useInfiniteQuery<GetFileItemsCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getFileItemsCount.infinite'] : ['getFileItemsCount.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileItemsCountQuery.getKey = (variables?: GetFileItemsCountQueryVariables) => variables === undefined ? ['getFileItemsCount.infinite'] : ['getFileItemsCount.infinite', variables];

export const GetFileLinkUsersDocument = `
    query getFileLinkUsers($drawerDataId: ID!) {
  getFileLinkUsers(drawerDataId: $drawerDataId) {
    hasNextPage
    nodes {
      id
      userName
      isExternal
      email
      emailDomain
    }
  }
}
    `;

export const useGetFileLinkUsersQuery = <
      TData = GetFileLinkUsersQuery,
      TError = unknown
    >(
      variables: GetFileLinkUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetFileLinkUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileLinkUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileLinkUsersQuery, TError, TData>(
      {
    queryKey: ['getFileLinkUsers', variables],
    queryFn: useMyQuery<GetFileLinkUsersQuery, GetFileLinkUsersQueryVariables>(GetFileLinkUsersDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileLinkUsersQuery.getKey = (variables: GetFileLinkUsersQueryVariables) => ['getFileLinkUsers', variables];

export const useInfiniteGetFileLinkUsersQuery = <
      TData = InfiniteData<GetFileLinkUsersQuery>,
      TError = unknown
    >(
      variables: GetFileLinkUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileLinkUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileLinkUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileLinkUsersQuery, GetFileLinkUsersQueryVariables>(GetFileLinkUsersDocument)
    return useInfiniteQuery<GetFileLinkUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileLinkUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileLinkUsersQuery.getKey = (variables: GetFileLinkUsersQueryVariables) => ['getFileLinkUsers.infinite', variables];

export const GetFileLinksDocument = `
    query getFileLinks($drawerDataId: ID!, $limit: Int, $offset: Int, $drawerSort: GetFileLinksSortType, $drawerFilterTypes: [LinkType!]) {
  getFileLinks(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    sort: $drawerSort
    type: $drawerFilterTypes
  ) {
    hasNextPage
    nodes {
      id
      type
      webUrl
      usersWithAccess
      externalUsersWithAccess
      groupsWithAccess
      sharedWithAnyone
      sharedWithEveryoneExceptExternalUsers
      passwordRequired
      accessRevoked
    }
  }
}
    `;

export const useGetFileLinksQuery = <
      TData = GetFileLinksQuery,
      TError = unknown
    >(
      variables: GetFileLinksQueryVariables,
      options?: Omit<UseQueryOptions<GetFileLinksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileLinksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileLinksQuery, TError, TData>(
      {
    queryKey: ['getFileLinks', variables],
    queryFn: useMyQuery<GetFileLinksQuery, GetFileLinksQueryVariables>(GetFileLinksDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileLinksQuery.getKey = (variables: GetFileLinksQueryVariables) => ['getFileLinks', variables];

export const useInfiniteGetFileLinksQuery = <
      TData = InfiniteData<GetFileLinksQuery>,
      TError = unknown
    >(
      variables: GetFileLinksQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileLinksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileLinksQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileLinksQuery, GetFileLinksQueryVariables>(GetFileLinksDocument)
    return useInfiniteQuery<GetFileLinksQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileLinks.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileLinksQuery.getKey = (variables: GetFileLinksQueryVariables) => ['getFileLinks.infinite', variables];

export const GetFileSensitiveInfoDocument = `
    query getFileSensitiveInfo($drawerDataId: ID!, $fileSensitiveInfoListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerSensitiveInfoSortEnum) {
  getFileSensitiveInfo(
    drawerDataId: $drawerDataId
    text: $fileSensitiveInfoListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetFileSensitiveInfoQuery = <
      TData = GetFileSensitiveInfoQuery,
      TError = unknown
    >(
      variables: GetFileSensitiveInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetFileSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileSensitiveInfoQuery, TError, TData>(
      {
    queryKey: ['getFileSensitiveInfo', variables],
    queryFn: useMyQuery<GetFileSensitiveInfoQuery, GetFileSensitiveInfoQueryVariables>(GetFileSensitiveInfoDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileSensitiveInfoQuery.getKey = (variables: GetFileSensitiveInfoQueryVariables) => ['getFileSensitiveInfo', variables];

export const useInfiniteGetFileSensitiveInfoQuery = <
      TData = InfiniteData<GetFileSensitiveInfoQuery>,
      TError = unknown
    >(
      variables: GetFileSensitiveInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileSensitiveInfoQuery, GetFileSensitiveInfoQueryVariables>(GetFileSensitiveInfoDocument)
    return useInfiniteQuery<GetFileSensitiveInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileSensitiveInfo.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileSensitiveInfoQuery.getKey = (variables: GetFileSensitiveInfoQueryVariables) => ['getFileSensitiveInfo.infinite', variables];

export const GetFileSensitivityLabelsDocument = `
    query getFileSensitivityLabels($drawerDataId: ID!, $fileLabelsListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerLabelsSortEnum) {
  getFileSensitivityLabels(
    drawerDataId: $drawerDataId
    text: $fileLabelsListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      color
      contentFormats
      description
      hasProtection
      isActive
      isAppliable
      priority
      tooltip
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetFileSensitivityLabelsQuery = <
      TData = GetFileSensitivityLabelsQuery,
      TError = unknown
    >(
      variables: GetFileSensitivityLabelsQueryVariables,
      options?: Omit<UseQueryOptions<GetFileSensitivityLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileSensitivityLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileSensitivityLabelsQuery, TError, TData>(
      {
    queryKey: ['getFileSensitivityLabels', variables],
    queryFn: useMyQuery<GetFileSensitivityLabelsQuery, GetFileSensitivityLabelsQueryVariables>(GetFileSensitivityLabelsDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileSensitivityLabelsQuery.getKey = (variables: GetFileSensitivityLabelsQueryVariables) => ['getFileSensitivityLabels', variables];

export const useInfiniteGetFileSensitivityLabelsQuery = <
      TData = InfiniteData<GetFileSensitivityLabelsQuery>,
      TError = unknown
    >(
      variables: GetFileSensitivityLabelsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileSensitivityLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileSensitivityLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileSensitivityLabelsQuery, GetFileSensitivityLabelsQueryVariables>(GetFileSensitivityLabelsDocument)
    return useInfiniteQuery<GetFileSensitivityLabelsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileSensitivityLabels.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileSensitivityLabelsQuery.getKey = (variables: GetFileSensitivityLabelsQueryVariables) => ['getFileSensitivityLabels.infinite', variables];

export const GetFileUsersDocument = `
    query getFileUsers($drawerDataId: ID!, $fileUsersSearch: String, $limit: Int, $offset: Int, $drawerSort: GetFileUsersEnum, $drawerFilterTypes: [String]) {
  getFileUsers(
    drawerDataId: $drawerDataId
    text: $fileUsersSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
    permissions: $drawerFilterTypes
  ) {
    hasNextPage
    nodes {
      id
      name
      permissions {
        permission
        accessThrough {
          id
          type
          name
        }
      }
      avatar
      emailDomain
      isExternal
      signInDisabledAt
      azureRegisteredAt
      canAdminConsent
      connectedApps
      accessibleFiles
      totalGroupMemberships
      licenses
      lastSignIn
      hasMfa
    }
  }
}
    `;

export const useGetFileUsersQuery = <
      TData = GetFileUsersQuery,
      TError = unknown
    >(
      variables: GetFileUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetFileUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFileUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFileUsersQuery, TError, TData>(
      {
    queryKey: ['getFileUsers', variables],
    queryFn: useMyQuery<GetFileUsersQuery, GetFileUsersQueryVariables>(GetFileUsersDocument).bind(null, variables),
    ...options
  }
    )};

useGetFileUsersQuery.getKey = (variables: GetFileUsersQueryVariables) => ['getFileUsers', variables];

export const useInfiniteGetFileUsersQuery = <
      TData = InfiniteData<GetFileUsersQuery>,
      TError = unknown
    >(
      variables: GetFileUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFileUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFileUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFileUsersQuery, GetFileUsersQueryVariables>(GetFileUsersDocument)
    return useInfiniteQuery<GetFileUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFileUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFileUsersQuery.getKey = (variables: GetFileUsersQueryVariables) => ['getFileUsers.infinite', variables];

export const GetFilesDocument = `
    query getFiles($folderId: ID, $search: String, $limit: Int, $offset: Int, $additionalResults: Boolean, $sort: GetFilesSortType, $access: [AccessType], $fileTypes: [String], $fileContainers: [FileContainerType], $createdBy: String, $lastModifiedBy: String, $filesAccessibleToUser: String, $location: [String], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $listType: String, $labels: [LabelType], $createdAt: DateRange, $modifiedAt: DateRange) {
  getFiles(
    folderId: $folderId
    text: $search
    limit: $limit
    offset: $offset
    fileTypes: $fileTypes
    sort: $sort
    dateRange: $dateRange
    access: $access
    fileContainers: $fileContainers
    location: $location
    createdBy: $createdBy
    lastModifiedBy: $lastModifiedBy
    filesAccessibleToUser: $filesAccessibleToUser
    time: $time
    additionalResults: $additionalResults
    listType: $listType
    labels: $labels
    createdAt: $createdAt
    modifiedAt: $modifiedAt
  ) {
    itemsFound
    path {
      id
      name
    }
    hasNextPage
    nodes {
      id
      name
      size
      type
      path
      createdBy {
        user {
          id
          originId
          name
          displayName
          email
        }
      }
      lastModifiedBy {
        user {
          id
          originId
          displayName
          email
        }
      }
      level
      parentId
      shareLink
      webUrl
      sourceType
      createdDate
      lastModified
      tenantId
      externalUsersWithAccess
      sharedExternally
      sharedWithAnyone
      usersWithAccess
      usersWithEditAccess
      groupsWithAccess
      files
      sourceType
      sensitivity
      topFileSensitivity
      appsWithAccess
      sharedWithOrganization
      filesWithSensitivityLabels
      sensitivityLabels
      sensitivityContentFiles {
        sensitivityLevel
        count
      }
      sensitivityInformationDistribution {
        sensitivityType
        count
      }
      sensitiveInfo
    }
  }
}
    `;

export const useGetFilesQuery = <
      TData = GetFilesQuery,
      TError = unknown
    >(
      variables?: GetFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFilesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getFiles'] : ['getFiles', variables],
    queryFn: useMyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument).bind(null, variables),
    ...options
  }
    )};

useGetFilesQuery.getKey = (variables?: GetFilesQueryVariables) => variables === undefined ? ['getFiles'] : ['getFiles', variables];

export const useInfiniteGetFilesQuery = <
      TData = InfiniteData<GetFilesQuery>,
      TError = unknown
    >(
      variables: GetFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFilesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFilesQuery, GetFilesQueryVariables>(GetFilesDocument)
    return useInfiniteQuery<GetFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getFiles.infinite'] : ['getFiles.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFilesQuery.getKey = (variables?: GetFilesQueryVariables) => variables === undefined ? ['getFiles.infinite'] : ['getFiles.infinite', variables];

export const GetFindingDocument = `
    query GetFinding($drawerDataId: ID!) {
  getFinding(drawerDataId: $drawerDataId) {
    id
    name
    description
    resourceType
    tenantId
    affectedItems
    severity
    tags
    isHidden
  }
}
    `;

export const useGetFindingQuery = <
      TData = GetFindingQuery,
      TError = unknown
    >(
      variables: GetFindingQueryVariables,
      options?: Omit<UseQueryOptions<GetFindingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFindingQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFindingQuery, TError, TData>(
      {
    queryKey: ['GetFinding', variables],
    queryFn: useMyQuery<GetFindingQuery, GetFindingQueryVariables>(GetFindingDocument).bind(null, variables),
    ...options
  }
    )};

useGetFindingQuery.getKey = (variables: GetFindingQueryVariables) => ['GetFinding', variables];

export const useInfiniteGetFindingQuery = <
      TData = InfiniteData<GetFindingQuery>,
      TError = unknown
    >(
      variables: GetFindingQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFindingQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFindingQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFindingQuery, GetFindingQueryVariables>(GetFindingDocument)
    return useInfiniteQuery<GetFindingQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetFinding.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFindingQuery.getKey = (variables: GetFindingQueryVariables) => ['GetFinding.infinite', variables];

export const GetFindingsFilterCountDocument = `
    query getFindingsFilterCount {
  getFindingsFilterCount {
    all
    appResource
    userResource
    groupResource
    fileResource
    siteResource
    driveResource
    lowSeverity
    mediumSeverity
    highSeverity
    criticalSeverity
    informationSeverity
    createdLast1Day
    createdLast7Days
    createdLast30Days
    createdLast90Days
    createdLast1Year
    modifiedLast1Day
    modifiedLast7Days
    modifiedLast30Days
    modifiedLast90Days
    modifiedLast1Year
    listHidden
    skipHidden
  }
}
    `;

export const useGetFindingsFilterCountQuery = <
      TData = GetFindingsFilterCountQuery,
      TError = unknown
    >(
      variables?: GetFindingsFilterCountQueryVariables,
      options?: Omit<UseQueryOptions<GetFindingsFilterCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFindingsFilterCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFindingsFilterCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getFindingsFilterCount'] : ['getFindingsFilterCount', variables],
    queryFn: useMyQuery<GetFindingsFilterCountQuery, GetFindingsFilterCountQueryVariables>(GetFindingsFilterCountDocument).bind(null, variables),
    ...options
  }
    )};

useGetFindingsFilterCountQuery.getKey = (variables?: GetFindingsFilterCountQueryVariables) => variables === undefined ? ['getFindingsFilterCount'] : ['getFindingsFilterCount', variables];

export const useInfiniteGetFindingsFilterCountQuery = <
      TData = InfiniteData<GetFindingsFilterCountQuery>,
      TError = unknown
    >(
      variables: GetFindingsFilterCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFindingsFilterCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFindingsFilterCountQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFindingsFilterCountQuery, GetFindingsFilterCountQueryVariables>(GetFindingsFilterCountDocument)
    return useInfiniteQuery<GetFindingsFilterCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getFindingsFilterCount.infinite'] : ['getFindingsFilterCount.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFindingsFilterCountQuery.getKey = (variables?: GetFindingsFilterCountQueryVariables) => variables === undefined ? ['getFindingsFilterCount.infinite'] : ['getFindingsFilterCount.infinite', variables];

export const GetFindingItemsDocument = `
    query getFindingItems($drawerDataId: ID!, $limit: Int, $offset: Int, $itemsSearch: String) {
  getFindingItems(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $itemsSearch
  ) {
    hasNextPage
    nodes {
      id
      name
      status
      detectedAt
      assignedTo
      assignedBy
      taskId
      itemType
    }
  }
}
    `;

export const useGetFindingItemsQuery = <
      TData = GetFindingItemsQuery,
      TError = unknown
    >(
      variables: GetFindingItemsQueryVariables,
      options?: Omit<UseQueryOptions<GetFindingItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFindingItemsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFindingItemsQuery, TError, TData>(
      {
    queryKey: ['getFindingItems', variables],
    queryFn: useMyQuery<GetFindingItemsQuery, GetFindingItemsQueryVariables>(GetFindingItemsDocument).bind(null, variables),
    ...options
  }
    )};

useGetFindingItemsQuery.getKey = (variables: GetFindingItemsQueryVariables) => ['getFindingItems', variables];

export const useInfiniteGetFindingItemsQuery = <
      TData = InfiniteData<GetFindingItemsQuery>,
      TError = unknown
    >(
      variables: GetFindingItemsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFindingItemsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFindingItemsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFindingItemsQuery, GetFindingItemsQueryVariables>(GetFindingItemsDocument)
    return useInfiniteQuery<GetFindingItemsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getFindingItems.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFindingItemsQuery.getKey = (variables: GetFindingItemsQueryVariables) => ['getFindingItems.infinite', variables];

export const GetFindingsDocument = `
    query GetFindings($search: String, $limit: Int, $offset: Int, $type: [String], $severity: [String], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $showHidden: [String], $sort: String) {
  getFindings(
    limit: $limit
    offset: $offset
    text: $search
    type: $type
    severity: $severity
    time: $time
    dateRange: $dateRange
    showHidden: $showHidden
    sort: $sort
  ) {
    hasNextPage
    itemsFound
    nodes {
      id
      name
      description
      resourceType
      resourceTypeEn
      tenantId
      affectedItems
      severity
    }
  }
}
    `;

export const useGetFindingsQuery = <
      TData = GetFindingsQuery,
      TError = unknown
    >(
      variables?: GetFindingsQueryVariables,
      options?: Omit<UseQueryOptions<GetFindingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetFindingsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetFindingsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetFindings'] : ['GetFindings', variables],
    queryFn: useMyQuery<GetFindingsQuery, GetFindingsQueryVariables>(GetFindingsDocument).bind(null, variables),
    ...options
  }
    )};

useGetFindingsQuery.getKey = (variables?: GetFindingsQueryVariables) => variables === undefined ? ['GetFindings'] : ['GetFindings', variables];

export const useInfiniteGetFindingsQuery = <
      TData = InfiniteData<GetFindingsQuery>,
      TError = unknown
    >(
      variables: GetFindingsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetFindingsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetFindingsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetFindingsQuery, GetFindingsQueryVariables>(GetFindingsDocument)
    return useInfiniteQuery<GetFindingsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetFindings.infinite'] : ['GetFindings.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetFindingsQuery.getKey = (variables?: GetFindingsQueryVariables) => variables === undefined ? ['GetFindings.infinite'] : ['GetFindings.infinite', variables];

export const GetGroupDocument = `
    query getGroup($drawerDataId: ID) {
  getGroup(drawerDataId: $drawerDataId) {
    id
    name
    privacy
    email
    createdAt
    type
    isTeams
    members
    accessibleFiles
    accessibleSites
    members
    sensitivityLabels
    sensitiveInfo
    containedGroups
    isMemberOfGroups
  }
}
    `;

export const useGetGroupQuery = <
      TData = GetGroupQuery,
      TError = unknown
    >(
      variables?: GetGroupQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getGroup'] : ['getGroup', variables],
    queryFn: useMyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupQuery.getKey = (variables?: GetGroupQueryVariables) => variables === undefined ? ['getGroup'] : ['getGroup', variables];

export const useInfiniteGetGroupQuery = <
      TData = InfiniteData<GetGroupQuery>,
      TError = unknown
    >(
      variables: GetGroupQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument)
    return useInfiniteQuery<GetGroupQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getGroup.infinite'] : ['getGroup.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupQuery.getKey = (variables?: GetGroupQueryVariables) => variables === undefined ? ['getGroup.infinite'] : ['getGroup.infinite', variables];

export const GetGroupAlertsDocument = `
    query getGroupAlerts($drawerDataId: ID!, $limit: Int, $offset: Int, $groupAppsSearch: String, $drawerSort: GetResourceAlertsSortEnum) {
  getGroupAlerts(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $groupAppsSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      status
      severity
      detectedAt
      resolvedAt
    }
  }
}
    `;

export const useGetGroupAlertsQuery = <
      TData = GetGroupAlertsQuery,
      TError = unknown
    >(
      variables: GetGroupAlertsQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupAlertsQuery, TError, TData>(
      {
    queryKey: ['getGroupAlerts', variables],
    queryFn: useMyQuery<GetGroupAlertsQuery, GetGroupAlertsQueryVariables>(GetGroupAlertsDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupAlertsQuery.getKey = (variables: GetGroupAlertsQueryVariables) => ['getGroupAlerts', variables];

export const useInfiniteGetGroupAlertsQuery = <
      TData = InfiniteData<GetGroupAlertsQuery>,
      TError = unknown
    >(
      variables: GetGroupAlertsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupAlertsQuery, GetGroupAlertsQueryVariables>(GetGroupAlertsDocument)
    return useInfiniteQuery<GetGroupAlertsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getGroupAlerts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupAlertsQuery.getKey = (variables: GetGroupAlertsQueryVariables) => ['getGroupAlerts.infinite', variables];

export const GetGroupAppsDocument = `
    query getGroupApps($drawerDataId: ID!, $limit: Int, $offset: Int, $groupAppsSearch: String, $drawerSort: GetGroupAppsEnum) {
  getGroupApps(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $groupAppsSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      connected
      users
      externalUsers
      firstAdminUser
      filesAccess
      usersAccess
      emailsAccess
      logoUrl
      sensitivity
    }
  }
}
    `;

export const useGetGroupAppsQuery = <
      TData = GetGroupAppsQuery,
      TError = unknown
    >(
      variables: GetGroupAppsQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupAppsQuery, TError, TData>(
      {
    queryKey: ['getGroupApps', variables],
    queryFn: useMyQuery<GetGroupAppsQuery, GetGroupAppsQueryVariables>(GetGroupAppsDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupAppsQuery.getKey = (variables: GetGroupAppsQueryVariables) => ['getGroupApps', variables];

export const useInfiniteGetGroupAppsQuery = <
      TData = InfiniteData<GetGroupAppsQuery>,
      TError = unknown
    >(
      variables: GetGroupAppsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupAppsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupAppsQuery, GetGroupAppsQueryVariables>(GetGroupAppsDocument)
    return useInfiniteQuery<GetGroupAppsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getGroupApps.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupAppsQuery.getKey = (variables: GetGroupAppsQueryVariables) => ['getGroupApps.infinite', variables];

export const GetGroupFilesDocument = `
    query getGroupFiles($drawerDataId: ID!, $limit: Int, $offset: Int, $groupFilesCompactSearch: String, $drawerSort: GetGroupFilesSortEnum) {
  getGroupFiles(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $groupFilesCompactSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      path
      permissions {
        permission
        accessThrough {
          type
        }
      }
      fileSensitivityLabels
    }
  }
}
    `;

export const useGetGroupFilesQuery = <
      TData = GetGroupFilesQuery,
      TError = unknown
    >(
      variables: GetGroupFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupFilesQuery, TError, TData>(
      {
    queryKey: ['getGroupFiles', variables],
    queryFn: useMyQuery<GetGroupFilesQuery, GetGroupFilesQueryVariables>(GetGroupFilesDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupFilesQuery.getKey = (variables: GetGroupFilesQueryVariables) => ['getGroupFiles', variables];

export const useInfiniteGetGroupFilesQuery = <
      TData = InfiniteData<GetGroupFilesQuery>,
      TError = unknown
    >(
      variables: GetGroupFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupFilesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupFilesQuery, GetGroupFilesQueryVariables>(GetGroupFilesDocument)
    return useInfiniteQuery<GetGroupFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getGroupFiles.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupFilesQuery.getKey = (variables: GetGroupFilesQueryVariables) => ['getGroupFiles.infinite', variables];

export const GetGroupFilterCountsDocument = `
    query getGroupFilterCounts {
  getGroupFilterCounts {
    all
    externalUsers
    internalUsers
    ms365
    security
    sharepoint
    directory
  }
}
    `;

export const useGetGroupFilterCountsQuery = <
      TData = GetGroupFilterCountsQuery,
      TError = unknown
    >(
      variables?: GetGroupFilterCountsQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupFilterCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getGroupFilterCounts'] : ['getGroupFilterCounts', variables],
    queryFn: useMyQuery<GetGroupFilterCountsQuery, GetGroupFilterCountsQueryVariables>(GetGroupFilterCountsDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupFilterCountsQuery.getKey = (variables?: GetGroupFilterCountsQueryVariables) => variables === undefined ? ['getGroupFilterCounts'] : ['getGroupFilterCounts', variables];

export const useInfiniteGetGroupFilterCountsQuery = <
      TData = InfiniteData<GetGroupFilterCountsQuery>,
      TError = unknown
    >(
      variables: GetGroupFilterCountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupFilterCountsQuery, GetGroupFilterCountsQueryVariables>(GetGroupFilterCountsDocument)
    return useInfiniteQuery<GetGroupFilterCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getGroupFilterCounts.infinite'] : ['getGroupFilterCounts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupFilterCountsQuery.getKey = (variables?: GetGroupFilterCountsQueryVariables) => variables === undefined ? ['getGroupFilterCounts.infinite'] : ['getGroupFilterCounts.infinite', variables];

export const GetGroupGraphDocument = `
    query getGroupGraph($drawerDataId: ID!) {
  getGroupGraph(drawerDataId: $drawerDataId) {
    mainNode {
      id
      name
      type
      page
      resource
      drawerDataId
      icon
      color
      users
      files
      groups
      filters {
        permissions
        type
      }
    }
    parentNodes {
      id
      name
      type
      page
      resource
      drawerDataId
      icon
      color
      users
      files
      groups
      filters {
        permissions
        type
      }
    }
    nestedNodes {
      id
      name
      type
      page
      resource
      drawerDataId
      icon
      color
      users
      files
      groups
      filters {
        permissions
        type
      }
    }
    edges {
      from
      to
    }
    legend {
      name
      color
      icon
      type
    }
  }
}
    `;

export const useGetGroupGraphQuery = <
      TData = GetGroupGraphQuery,
      TError = unknown
    >(
      variables: GetGroupGraphQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupGraphQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupGraphQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupGraphQuery, TError, TData>(
      {
    queryKey: ['getGroupGraph', variables],
    queryFn: useMyQuery<GetGroupGraphQuery, GetGroupGraphQueryVariables>(GetGroupGraphDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupGraphQuery.getKey = (variables: GetGroupGraphQueryVariables) => ['getGroupGraph', variables];

export const useInfiniteGetGroupGraphQuery = <
      TData = InfiniteData<GetGroupGraphQuery>,
      TError = unknown
    >(
      variables: GetGroupGraphQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupGraphQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupGraphQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupGraphQuery, GetGroupGraphQueryVariables>(GetGroupGraphDocument)
    return useInfiniteQuery<GetGroupGraphQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getGroupGraph.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupGraphQuery.getKey = (variables: GetGroupGraphQueryVariables) => ['getGroupGraph.infinite', variables];

export const GetGroupLabelsDocument = `
    query getGroupLabels($drawerDataId: ID!, $groupLabelsListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerLabelsSortEnum) {
  getGroupLabels(
    drawerDataId: $drawerDataId
    text: $groupLabelsListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      description
      color
      contentFormats
      hasProtection
      isActive
      isAppliable
      sensitivity
      tooltip
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetGroupLabelsQuery = <
      TData = GetGroupLabelsQuery,
      TError = unknown
    >(
      variables: GetGroupLabelsQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupLabelsQuery, TError, TData>(
      {
    queryKey: ['getGroupLabels', variables],
    queryFn: useMyQuery<GetGroupLabelsQuery, GetGroupLabelsQueryVariables>(GetGroupLabelsDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupLabelsQuery.getKey = (variables: GetGroupLabelsQueryVariables) => ['getGroupLabels', variables];

export const useInfiniteGetGroupLabelsQuery = <
      TData = InfiniteData<GetGroupLabelsQuery>,
      TError = unknown
    >(
      variables: GetGroupLabelsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupLabelsQuery, GetGroupLabelsQueryVariables>(GetGroupLabelsDocument)
    return useInfiniteQuery<GetGroupLabelsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getGroupLabels.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupLabelsQuery.getKey = (variables: GetGroupLabelsQueryVariables) => ['getGroupLabels.infinite', variables];

export const GetGroupMembersDocument = `
    query getGroupMembers($drawerDataId: ID!, $limit: Int, $offset: Int, $groupMembersSearch: String, $drawerSort: GetGroupMembersSortEnum, $drawerFilterTypes: [String]) {
  getGroupMembers(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $groupMembersSearch
    sort: $drawerSort
    type: $drawerFilterTypes
  ) {
    hasNextPage
    nodes {
      id
      userName
      avatar
      isExternal
      emailDomain
      lastSignIn
      accessThrough {
        name
      }
    }
  }
}
    `;

export const useGetGroupMembersQuery = <
      TData = GetGroupMembersQuery,
      TError = unknown
    >(
      variables: GetGroupMembersQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupMembersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupMembersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupMembersQuery, TError, TData>(
      {
    queryKey: ['getGroupMembers', variables],
    queryFn: useMyQuery<GetGroupMembersQuery, GetGroupMembersQueryVariables>(GetGroupMembersDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupMembersQuery.getKey = (variables: GetGroupMembersQueryVariables) => ['getGroupMembers', variables];

export const useInfiniteGetGroupMembersQuery = <
      TData = InfiniteData<GetGroupMembersQuery>,
      TError = unknown
    >(
      variables: GetGroupMembersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupMembersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupMembersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupMembersQuery, GetGroupMembersQueryVariables>(GetGroupMembersDocument)
    return useInfiniteQuery<GetGroupMembersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getGroupMembers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupMembersQuery.getKey = (variables: GetGroupMembersQueryVariables) => ['getGroupMembers.infinite', variables];

export const GetGroupSensitiveInfoDocument = `
    query getGroupSensitiveInfo($drawerDataId: ID!, $groupSensitiveInfoListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerSensitiveInfoSortEnum) {
  getGroupSensitiveInfo(
    drawerDataId: $drawerDataId
    text: $groupSensitiveInfoListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetGroupSensitiveInfoQuery = <
      TData = GetGroupSensitiveInfoQuery,
      TError = unknown
    >(
      variables: GetGroupSensitiveInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupSensitiveInfoQuery, TError, TData>(
      {
    queryKey: ['getGroupSensitiveInfo', variables],
    queryFn: useMyQuery<GetGroupSensitiveInfoQuery, GetGroupSensitiveInfoQueryVariables>(GetGroupSensitiveInfoDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupSensitiveInfoQuery.getKey = (variables: GetGroupSensitiveInfoQueryVariables) => ['getGroupSensitiveInfo', variables];

export const useInfiniteGetGroupSensitiveInfoQuery = <
      TData = InfiniteData<GetGroupSensitiveInfoQuery>,
      TError = unknown
    >(
      variables: GetGroupSensitiveInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupSensitiveInfoQuery, GetGroupSensitiveInfoQueryVariables>(GetGroupSensitiveInfoDocument)
    return useInfiniteQuery<GetGroupSensitiveInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getGroupSensitiveInfo.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupSensitiveInfoQuery.getKey = (variables: GetGroupSensitiveInfoQueryVariables) => ['getGroupSensitiveInfo.infinite', variables];

export const GetGroupSitesDocument = `
    query getGroupSites($drawerDataId: ID!, $limit: Int, $offset: Int, $groupSitesCompactSearch: String, $drawerSort: GetGroupSitesSortEnum) {
  getGroupSites(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $groupSitesCompactSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      permissions {
        levelName
        accessThrough {
          type
        }
      }
    }
  }
}
    `;

export const useGetGroupSitesQuery = <
      TData = GetGroupSitesQuery,
      TError = unknown
    >(
      variables: GetGroupSitesQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupSitesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupSitesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupSitesQuery, TError, TData>(
      {
    queryKey: ['getGroupSites', variables],
    queryFn: useMyQuery<GetGroupSitesQuery, GetGroupSitesQueryVariables>(GetGroupSitesDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupSitesQuery.getKey = (variables: GetGroupSitesQueryVariables) => ['getGroupSites', variables];

export const useInfiniteGetGroupSitesQuery = <
      TData = InfiniteData<GetGroupSitesQuery>,
      TError = unknown
    >(
      variables: GetGroupSitesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupSitesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupSitesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupSitesQuery, GetGroupSitesQueryVariables>(GetGroupSitesDocument)
    return useInfiniteQuery<GetGroupSitesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getGroupSites.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupSitesQuery.getKey = (variables: GetGroupSitesQueryVariables) => ['getGroupSites.infinite', variables];

export const GetGroupsDocument = `
    query getGroups($limit: Int, $offset: Int, $search: String, $sort: GetGroupsSortType, $access: [GroupAccessType!], $type: [GroupType!], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $drawerDataId: ID) {
  getGroups(
    limit: $limit
    offset: $offset
    text: $search
    sort: $sort
    access: $access
    type: $type
    time: $time
    dateRange: $dateRange
    policyId: $drawerDataId
  ) {
    hasNextPage
    nodes {
      id
      name
      createdAt
      type
      members
      nestedMembers
      nestedExternalUsers
      containedGroups
      totalUsers
      totalExternalUsers
      isMemberOfGroups
      accessibleFiles
      accessibleSites
      filesWithSensitivityLabels
      sensitivityLabels
      sensitiveInfo
    }
    itemsFound
  }
}
    `;

export const useGetGroupsQuery = <
      TData = GetGroupsQuery,
      TError = unknown
    >(
      variables?: GetGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetGroupsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getGroups'] : ['getGroups', variables],
    queryFn: useMyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetGroupsQuery.getKey = (variables?: GetGroupsQueryVariables) => variables === undefined ? ['getGroups'] : ['getGroups', variables];

export const useInfiniteGetGroupsQuery = <
      TData = InfiniteData<GetGroupsQuery>,
      TError = unknown
    >(
      variables: GetGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument)
    return useInfiniteQuery<GetGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getGroups.infinite'] : ['getGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetGroupsQuery.getKey = (variables?: GetGroupsQueryVariables) => variables === undefined ? ['getGroups.infinite'] : ['getGroups.infinite', variables];

export const GetLivePolicyPreviewDocument = `
    query getLivePolicyPreview($conditions: String!, $type: String!, $limit: Int, $offset: Int) {
  getLivePolicyPreview(
    conditions: $conditions
    type: $type
    limit: $limit
    offset: $offset
  ) {
    hasNextPage
    nodes
    itemsFound
  }
}
    `;

export const useGetLivePolicyPreviewQuery = <
      TData = GetLivePolicyPreviewQuery,
      TError = unknown
    >(
      variables: GetLivePolicyPreviewQueryVariables,
      options?: Omit<UseQueryOptions<GetLivePolicyPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetLivePolicyPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetLivePolicyPreviewQuery, TError, TData>(
      {
    queryKey: ['getLivePolicyPreview', variables],
    queryFn: useMyQuery<GetLivePolicyPreviewQuery, GetLivePolicyPreviewQueryVariables>(GetLivePolicyPreviewDocument).bind(null, variables),
    ...options
  }
    )};

useGetLivePolicyPreviewQuery.getKey = (variables: GetLivePolicyPreviewQueryVariables) => ['getLivePolicyPreview', variables];

export const useInfiniteGetLivePolicyPreviewQuery = <
      TData = InfiniteData<GetLivePolicyPreviewQuery>,
      TError = unknown
    >(
      variables: GetLivePolicyPreviewQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetLivePolicyPreviewQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetLivePolicyPreviewQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetLivePolicyPreviewQuery, GetLivePolicyPreviewQueryVariables>(GetLivePolicyPreviewDocument)
    return useInfiniteQuery<GetLivePolicyPreviewQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getLivePolicyPreview.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetLivePolicyPreviewQuery.getKey = (variables: GetLivePolicyPreviewQueryVariables) => ['getLivePolicyPreview.infinite', variables];

export const GetMeDocument = `
    query getMe {
  getMe {
    name
    email
    roles
    organizationName
    isAdmin
    isAdminMode
    viewingAs {
      id
      name
    }
  }
}
    `;

export const useGetMeQuery = <
      TData = GetMeQuery,
      TError = unknown
    >(
      variables?: GetMeQueryVariables,
      options?: Omit<UseQueryOptions<GetMeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetMeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetMeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getMe'] : ['getMe', variables],
    queryFn: useMyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument).bind(null, variables),
    ...options
  }
    )};

useGetMeQuery.getKey = (variables?: GetMeQueryVariables) => variables === undefined ? ['getMe'] : ['getMe', variables];

export const useInfiniteGetMeQuery = <
      TData = InfiniteData<GetMeQuery>,
      TError = unknown
    >(
      variables: GetMeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetMeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetMeQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument)
    return useInfiniteQuery<GetMeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getMe.infinite'] : ['getMe.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetMeQuery.getKey = (variables?: GetMeQueryVariables) => variables === undefined ? ['getMe.infinite'] : ['getMe.infinite', variables];

export const GetOrganizationsDocument = `
    query getOrganizations {
  getOrganizations {
    id
    name
  }
}
    `;

export const useGetOrganizationsQuery = <
      TData = GetOrganizationsQuery,
      TError = unknown
    >(
      variables?: GetOrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<GetOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetOrganizationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getOrganizations'] : ['getOrganizations', variables],
    queryFn: useMyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument).bind(null, variables),
    ...options
  }
    )};

useGetOrganizationsQuery.getKey = (variables?: GetOrganizationsQueryVariables) => variables === undefined ? ['getOrganizations'] : ['getOrganizations', variables];

export const useInfiniteGetOrganizationsQuery = <
      TData = InfiniteData<GetOrganizationsQuery>,
      TError = unknown
    >(
      variables: GetOrganizationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetOrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument)
    return useInfiniteQuery<GetOrganizationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getOrganizations.infinite'] : ['getOrganizations.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetOrganizationsQuery.getKey = (variables?: GetOrganizationsQueryVariables) => variables === undefined ? ['getOrganizations.infinite'] : ['getOrganizations.infinite', variables];

export const GetOnboardingDataDocument = `
    query getOnboardingData($appId: String) {
  getOnboardingData(appId: $appId) {
    orgId
    permissions {
      name
      isValid
    }
  }
}
    `;

export const useGetOnboardingDataQuery = <
      TData = GetOnboardingDataQuery,
      TError = unknown
    >(
      variables?: GetOnboardingDataQueryVariables,
      options?: Omit<UseQueryOptions<GetOnboardingDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetOnboardingDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetOnboardingDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getOnboardingData'] : ['getOnboardingData', variables],
    queryFn: useMyQuery<GetOnboardingDataQuery, GetOnboardingDataQueryVariables>(GetOnboardingDataDocument).bind(null, variables),
    ...options
  }
    )};

useGetOnboardingDataQuery.getKey = (variables?: GetOnboardingDataQueryVariables) => variables === undefined ? ['getOnboardingData'] : ['getOnboardingData', variables];

export const useInfiniteGetOnboardingDataQuery = <
      TData = InfiniteData<GetOnboardingDataQuery>,
      TError = unknown
    >(
      variables: GetOnboardingDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetOnboardingDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetOnboardingDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetOnboardingDataQuery, GetOnboardingDataQueryVariables>(GetOnboardingDataDocument)
    return useInfiniteQuery<GetOnboardingDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getOnboardingData.infinite'] : ['getOnboardingData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetOnboardingDataQuery.getKey = (variables?: GetOnboardingDataQueryVariables) => variables === undefined ? ['getOnboardingData.infinite'] : ['getOnboardingData.infinite', variables];

export const GetPoliciesDocument = `
    query getPolicies($search: String, $limit: Int, $offset: Int, $sort: GetPoliciesSortType, $filters: String) {
  getPolicies(
    text: $search
    limit: $limit
    offset: $offset
    sort: $sort
    filters: $filters
  ) {
    itemsFound
    hasNextPage
    nodes {
      id
      name
      type
      violations
      severity
      assignedUsers
      lastDetection
      activeScan
      isTemplate
      automations
      conditions
    }
  }
}
    `;

export const useGetPoliciesQuery = <
      TData = GetPoliciesQuery,
      TError = unknown
    >(
      variables?: GetPoliciesQueryVariables,
      options?: Omit<UseQueryOptions<GetPoliciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPoliciesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPoliciesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getPolicies'] : ['getPolicies', variables],
    queryFn: useMyQuery<GetPoliciesQuery, GetPoliciesQueryVariables>(GetPoliciesDocument).bind(null, variables),
    ...options
  }
    )};

useGetPoliciesQuery.getKey = (variables?: GetPoliciesQueryVariables) => variables === undefined ? ['getPolicies'] : ['getPolicies', variables];

export const useInfiniteGetPoliciesQuery = <
      TData = InfiniteData<GetPoliciesQuery>,
      TError = unknown
    >(
      variables: GetPoliciesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetPoliciesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetPoliciesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetPoliciesQuery, GetPoliciesQueryVariables>(GetPoliciesDocument)
    return useInfiniteQuery<GetPoliciesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getPolicies.infinite'] : ['getPolicies.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetPoliciesQuery.getKey = (variables?: GetPoliciesQueryVariables) => variables === undefined ? ['getPolicies.infinite'] : ['getPolicies.infinite', variables];

export const GetPolicyDocument = `
    query getPolicy($drawerDataId: ID!) {
  getPolicy(drawerDataId: $drawerDataId) {
    id
    name
    type
    violations
    severity
    assignedUsers
    lastDetection
    conditions
    automations
  }
}
    `;

export const useGetPolicyQuery = <
      TData = GetPolicyQuery,
      TError = unknown
    >(
      variables: GetPolicyQueryVariables,
      options?: Omit<UseQueryOptions<GetPolicyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPolicyQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPolicyQuery, TError, TData>(
      {
    queryKey: ['getPolicy', variables],
    queryFn: useMyQuery<GetPolicyQuery, GetPolicyQueryVariables>(GetPolicyDocument).bind(null, variables),
    ...options
  }
    )};

useGetPolicyQuery.getKey = (variables: GetPolicyQueryVariables) => ['getPolicy', variables];

export const useInfiniteGetPolicyQuery = <
      TData = InfiniteData<GetPolicyQuery>,
      TError = unknown
    >(
      variables: GetPolicyQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetPolicyQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetPolicyQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetPolicyQuery, GetPolicyQueryVariables>(GetPolicyDocument)
    return useInfiniteQuery<GetPolicyQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getPolicy.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetPolicyQuery.getKey = (variables: GetPolicyQueryVariables) => ['getPolicy.infinite', variables];

export const GetPolicyActivityTimelineDocument = `
    query getPolicyActivityTimeline($policyId: ID!, $limit: Int, $offset: Int) {
  getPolicyActivityTimeline(policyId: $policyId, limit: $limit, offset: $offset) {
    hasNextPage
    nodes {
      id
      activityType
      description
      action
      previousState
      newState
      createdAt
      userName
      userEmail
      automationType
      status
      parameters
      result
      completedAt
    }
  }
}
    `;

export const useGetPolicyActivityTimelineQuery = <
      TData = GetPolicyActivityTimelineQuery,
      TError = unknown
    >(
      variables: GetPolicyActivityTimelineQueryVariables,
      options?: Omit<UseQueryOptions<GetPolicyActivityTimelineQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPolicyActivityTimelineQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPolicyActivityTimelineQuery, TError, TData>(
      {
    queryKey: ['getPolicyActivityTimeline', variables],
    queryFn: useMyQuery<GetPolicyActivityTimelineQuery, GetPolicyActivityTimelineQueryVariables>(GetPolicyActivityTimelineDocument).bind(null, variables),
    ...options
  }
    )};

useGetPolicyActivityTimelineQuery.getKey = (variables: GetPolicyActivityTimelineQueryVariables) => ['getPolicyActivityTimeline', variables];

export const useInfiniteGetPolicyActivityTimelineQuery = <
      TData = InfiniteData<GetPolicyActivityTimelineQuery>,
      TError = unknown
    >(
      variables: GetPolicyActivityTimelineQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetPolicyActivityTimelineQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetPolicyActivityTimelineQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetPolicyActivityTimelineQuery, GetPolicyActivityTimelineQueryVariables>(GetPolicyActivityTimelineDocument)
    return useInfiniteQuery<GetPolicyActivityTimelineQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getPolicyActivityTimeline.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetPolicyActivityTimelineQuery.getKey = (variables: GetPolicyActivityTimelineQueryVariables) => ['getPolicyActivityTimeline.infinite', variables];

export const GetPolicyHistoryDocument = `
    query getPolicyHistory($policyId: ID!, $limit: Int, $offset: Int) {
  getPolicyHistory(policyId: $policyId, limit: $limit, offset: $offset) {
    hasNextPage
    nodes {
      id
      description
      action
      previousState
      newState
      createdAt
      userName
      userEmail
    }
  }
}
    `;

export const useGetPolicyHistoryQuery = <
      TData = GetPolicyHistoryQuery,
      TError = unknown
    >(
      variables: GetPolicyHistoryQueryVariables,
      options?: Omit<UseQueryOptions<GetPolicyHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPolicyHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPolicyHistoryQuery, TError, TData>(
      {
    queryKey: ['getPolicyHistory', variables],
    queryFn: useMyQuery<GetPolicyHistoryQuery, GetPolicyHistoryQueryVariables>(GetPolicyHistoryDocument).bind(null, variables),
    ...options
  }
    )};

useGetPolicyHistoryQuery.getKey = (variables: GetPolicyHistoryQueryVariables) => ['getPolicyHistory', variables];

export const useInfiniteGetPolicyHistoryQuery = <
      TData = InfiniteData<GetPolicyHistoryQuery>,
      TError = unknown
    >(
      variables: GetPolicyHistoryQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetPolicyHistoryQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetPolicyHistoryQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetPolicyHistoryQuery, GetPolicyHistoryQueryVariables>(GetPolicyHistoryDocument)
    return useInfiniteQuery<GetPolicyHistoryQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getPolicyHistory.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetPolicyHistoryQuery.getKey = (variables: GetPolicyHistoryQueryVariables) => ['getPolicyHistory.infinite', variables];

export const GetResourceActivityTimelineDocument = `
    query getResourceActivityTimeline($resourceType: String!, $resourceId: ID!, $limit: Int, $offset: Int) {
  getResourceActivityTimeline(
    resourceType: $resourceType
    resourceId: $resourceId
    limit: $limit
    offset: $offset
  ) {
    hasNextPage
    nodes {
      id
      activityType
      description
      action
      previousState
      newState
      createdAt
      userName
      userEmail
      automationType
      status
      parameters
      result
      completedAt
      sourcePolicyName
    }
  }
}
    `;

export const useGetResourceActivityTimelineQuery = <
      TData = GetResourceActivityTimelineQuery,
      TError = unknown
    >(
      variables: GetResourceActivityTimelineQueryVariables,
      options?: Omit<UseQueryOptions<GetResourceActivityTimelineQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetResourceActivityTimelineQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetResourceActivityTimelineQuery, TError, TData>(
      {
    queryKey: ['getResourceActivityTimeline', variables],
    queryFn: useMyQuery<GetResourceActivityTimelineQuery, GetResourceActivityTimelineQueryVariables>(GetResourceActivityTimelineDocument).bind(null, variables),
    ...options
  }
    )};

useGetResourceActivityTimelineQuery.getKey = (variables: GetResourceActivityTimelineQueryVariables) => ['getResourceActivityTimeline', variables];

export const useInfiniteGetResourceActivityTimelineQuery = <
      TData = InfiniteData<GetResourceActivityTimelineQuery>,
      TError = unknown
    >(
      variables: GetResourceActivityTimelineQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetResourceActivityTimelineQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetResourceActivityTimelineQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetResourceActivityTimelineQuery, GetResourceActivityTimelineQueryVariables>(GetResourceActivityTimelineDocument)
    return useInfiniteQuery<GetResourceActivityTimelineQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getResourceActivityTimeline.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetResourceActivityTimelineQuery.getKey = (variables: GetResourceActivityTimelineQueryVariables) => ['getResourceActivityTimeline.infinite', variables];

export const GetScanResourceStatusDocument = `
    query getScanResourceStatus {
  getScanResourceStatus {
    files
    sites
    groups
    apps
    users
  }
}
    `;

export const useGetScanResourceStatusQuery = <
      TData = GetScanResourceStatusQuery,
      TError = unknown
    >(
      variables?: GetScanResourceStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetScanResourceStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetScanResourceStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetScanResourceStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getScanResourceStatus'] : ['getScanResourceStatus', variables],
    queryFn: useMyQuery<GetScanResourceStatusQuery, GetScanResourceStatusQueryVariables>(GetScanResourceStatusDocument).bind(null, variables),
    ...options
  }
    )};

useGetScanResourceStatusQuery.getKey = (variables?: GetScanResourceStatusQueryVariables) => variables === undefined ? ['getScanResourceStatus'] : ['getScanResourceStatus', variables];

export const useInfiniteGetScanResourceStatusQuery = <
      TData = InfiniteData<GetScanResourceStatusQuery>,
      TError = unknown
    >(
      variables: GetScanResourceStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetScanResourceStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetScanResourceStatusQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetScanResourceStatusQuery, GetScanResourceStatusQueryVariables>(GetScanResourceStatusDocument)
    return useInfiniteQuery<GetScanResourceStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getScanResourceStatus.infinite'] : ['getScanResourceStatus.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetScanResourceStatusQuery.getKey = (variables?: GetScanResourceStatusQueryVariables) => variables === undefined ? ['getScanResourceStatus.infinite'] : ['getScanResourceStatus.infinite', variables];

export const GetSecurityTaskDocument = `
    query GetSecurityTask($drawerDataId: ID!) {
  getSecurityTask(drawerDataId: $drawerDataId) {
    id
    findingId
    name
    severity
    affectedItemName
    affectedItemId
    resourceType
    taskStatus
    assignedToId
    assignedById
    assignedTo
    assignedBy
    createdAt
    tags
    description
    hidden
    graph {
      nodes {
        id
        name
        type
        users
        icon
      }
      edges {
        from
        to
      }
      description {
        text
        color
        link
      }
    }
  }
}
    `;

export const useGetSecurityTaskQuery = <
      TData = GetSecurityTaskQuery,
      TError = unknown
    >(
      variables: GetSecurityTaskQueryVariables,
      options?: Omit<UseQueryOptions<GetSecurityTaskQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSecurityTaskQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSecurityTaskQuery, TError, TData>(
      {
    queryKey: ['GetSecurityTask', variables],
    queryFn: useMyQuery<GetSecurityTaskQuery, GetSecurityTaskQueryVariables>(GetSecurityTaskDocument).bind(null, variables),
    ...options
  }
    )};

useGetSecurityTaskQuery.getKey = (variables: GetSecurityTaskQueryVariables) => ['GetSecurityTask', variables];

export const useInfiniteGetSecurityTaskQuery = <
      TData = InfiniteData<GetSecurityTaskQuery>,
      TError = unknown
    >(
      variables: GetSecurityTaskQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSecurityTaskQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSecurityTaskQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSecurityTaskQuery, GetSecurityTaskQueryVariables>(GetSecurityTaskDocument)
    return useInfiniteQuery<GetSecurityTaskQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetSecurityTask.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSecurityTaskQuery.getKey = (variables: GetSecurityTaskQueryVariables) => ['GetSecurityTask.infinite', variables];

export const GetSecurityTasksDocument = `
    query GetSecurityTasks($search: String, $limit: Int, $offset: Int, $type: [String], $status: [String], $severity: [String], $time: DateTimeFilterInput, $dateRange: DateRangeFilterInput, $assignment: [String], $task: TaskAssignmentFilterInput, $showHidden: [String], $sort: String, $hasAutoFix: String) {
  getSecurityTasks(
    limit: $limit
    offset: $offset
    text: $search
    type: $type
    status: $status
    severity: $severity
    time: $time
    dateRange: $dateRange
    assignment: $assignment
    task: $task
    showHidden: $showHidden
    sort: $sort
    hasAutoFix: $hasAutoFix
  ) {
    hasNextPage
    itemsFound
    nodes {
      id
      findingId
      name
      severity
      affectedItemName
      affectedItemId
      resourceType
      resourceTypeEn
      taskStatus
      assignedToId
      assignedById
      assignedTo
      assignedBy
      hidden
    }
  }
}
    `;

export const useGetSecurityTasksQuery = <
      TData = GetSecurityTasksQuery,
      TError = unknown
    >(
      variables?: GetSecurityTasksQueryVariables,
      options?: Omit<UseQueryOptions<GetSecurityTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSecurityTasksQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSecurityTasksQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetSecurityTasks'] : ['GetSecurityTasks', variables],
    queryFn: useMyQuery<GetSecurityTasksQuery, GetSecurityTasksQueryVariables>(GetSecurityTasksDocument).bind(null, variables),
    ...options
  }
    )};

useGetSecurityTasksQuery.getKey = (variables?: GetSecurityTasksQueryVariables) => variables === undefined ? ['GetSecurityTasks'] : ['GetSecurityTasks', variables];

export const useInfiniteGetSecurityTasksQuery = <
      TData = InfiniteData<GetSecurityTasksQuery>,
      TError = unknown
    >(
      variables: GetSecurityTasksQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSecurityTasksQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSecurityTasksQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSecurityTasksQuery, GetSecurityTasksQueryVariables>(GetSecurityTasksDocument)
    return useInfiniteQuery<GetSecurityTasksQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetSecurityTasks.infinite'] : ['GetSecurityTasks.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSecurityTasksQuery.getKey = (variables?: GetSecurityTasksQueryVariables) => variables === undefined ? ['GetSecurityTasks.infinite'] : ['GetSecurityTasks.infinite', variables];

export const GetSecurityTasksFilterCountDocument = `
    query getSecurityTasksFilterCount {
  getSecurityTasksFilterCount {
    all
    appResource
    userResource
    groupResource
    fileResource
    siteResource
    driveResource
    open
    waitingForReview
    inReview
    resolved
    closed
    falsePositive
    lowSeverity
    mediumSeverity
    highSeverity
    criticalSeverity
    informationSeverity
    createdLast1Day
    createdLast7Days
    createdLast30Days
    createdLast90Days
    createdLast1Year
    modifiedLast1Day
    modifiedLast7Days
    modifiedLast30Days
    modifiedLast90Days
    modifiedLast1Year
    autoAssigned
    userAssigned
    listHidden
    skipHidden
  }
}
    `;

export const useGetSecurityTasksFilterCountQuery = <
      TData = GetSecurityTasksFilterCountQuery,
      TError = unknown
    >(
      variables?: GetSecurityTasksFilterCountQueryVariables,
      options?: Omit<UseQueryOptions<GetSecurityTasksFilterCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSecurityTasksFilterCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSecurityTasksFilterCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSecurityTasksFilterCount'] : ['getSecurityTasksFilterCount', variables],
    queryFn: useMyQuery<GetSecurityTasksFilterCountQuery, GetSecurityTasksFilterCountQueryVariables>(GetSecurityTasksFilterCountDocument).bind(null, variables),
    ...options
  }
    )};

useGetSecurityTasksFilterCountQuery.getKey = (variables?: GetSecurityTasksFilterCountQueryVariables) => variables === undefined ? ['getSecurityTasksFilterCount'] : ['getSecurityTasksFilterCount', variables];

export const useInfiniteGetSecurityTasksFilterCountQuery = <
      TData = InfiniteData<GetSecurityTasksFilterCountQuery>,
      TError = unknown
    >(
      variables: GetSecurityTasksFilterCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSecurityTasksFilterCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSecurityTasksFilterCountQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSecurityTasksFilterCountQuery, GetSecurityTasksFilterCountQueryVariables>(GetSecurityTasksFilterCountDocument)
    return useInfiniteQuery<GetSecurityTasksFilterCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getSecurityTasksFilterCount.infinite'] : ['getSecurityTasksFilterCount.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSecurityTasksFilterCountQuery.getKey = (variables?: GetSecurityTasksFilterCountQueryVariables) => variables === undefined ? ['getSecurityTasksFilterCount.infinite'] : ['getSecurityTasksFilterCount.infinite', variables];

export const GetSensitiveDataDocument = `
    query getSensitiveData($limit: Int, $offset: Int, $search: String, $sort: GetSensitiveInfoSortEnum, $drawerDataId: ID) {
  getSensitiveData(
    limit: $limit
    offset: $offset
    text: $search
    sort: $sort
    policyId: $drawerDataId
  ) {
    hasNextPage
    nodes {
      id
      name
      sites
      groups
      files
      users
      apps
      isActive
      confidenceLevel
      detectionMechanism
      publisher
      filesDetectedBy1SecurityPercent
      filesDetectedByPurviewPercent
    }
    itemsFound
  }
}
    `;

export const useGetSensitiveDataQuery = <
      TData = GetSensitiveDataQuery,
      TError = unknown
    >(
      variables?: GetSensitiveDataQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitiveDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitiveDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitiveDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSensitiveData'] : ['getSensitiveData', variables],
    queryFn: useMyQuery<GetSensitiveDataQuery, GetSensitiveDataQueryVariables>(GetSensitiveDataDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitiveDataQuery.getKey = (variables?: GetSensitiveDataQueryVariables) => variables === undefined ? ['getSensitiveData'] : ['getSensitiveData', variables];

export const useInfiniteGetSensitiveDataQuery = <
      TData = InfiniteData<GetSensitiveDataQuery>,
      TError = unknown
    >(
      variables: GetSensitiveDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitiveDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitiveDataQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitiveDataQuery, GetSensitiveDataQueryVariables>(GetSensitiveDataDocument)
    return useInfiniteQuery<GetSensitiveDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getSensitiveData.infinite'] : ['getSensitiveData.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitiveDataQuery.getKey = (variables?: GetSensitiveDataQueryVariables) => variables === undefined ? ['getSensitiveData.infinite'] : ['getSensitiveData.infinite', variables];

export const GetSensitiveInfoDocument = `
    query getSensitiveInfo($drawerDataId: ID!) {
  getSensitiveInfo(drawerDataId: $drawerDataId) {
    id
    name
    sites
    groups
    files
    users
    apps
  }
}
    `;

export const useGetSensitiveInfoQuery = <
      TData = GetSensitiveInfoQuery,
      TError = unknown
    >(
      variables: GetSensitiveInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitiveInfoQuery, TError, TData>(
      {
    queryKey: ['getSensitiveInfo', variables],
    queryFn: useMyQuery<GetSensitiveInfoQuery, GetSensitiveInfoQueryVariables>(GetSensitiveInfoDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitiveInfoQuery.getKey = (variables: GetSensitiveInfoQueryVariables) => ['getSensitiveInfo', variables];

export const useInfiniteGetSensitiveInfoQuery = <
      TData = InfiniteData<GetSensitiveInfoQuery>,
      TError = unknown
    >(
      variables: GetSensitiveInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitiveInfoQuery, GetSensitiveInfoQueryVariables>(GetSensitiveInfoDocument)
    return useInfiniteQuery<GetSensitiveInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSensitiveInfo.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitiveInfoQuery.getKey = (variables: GetSensitiveInfoQueryVariables) => ['getSensitiveInfo.infinite', variables];

export const GetSensitiveInfoAlertsDocument = `
    query GetSensitiveInfoAlerts($drawerDataId: ID!, $limit: Int, $offset: Int, $sensitiveInfoAppListSearch: String, $drawerSort: GetResourceAlertsSortEnum) {
  getSensitiveInfoAlerts(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $sensitiveInfoAppListSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      status
      severity
      detectedAt
      resolvedAt
    }
  }
}
    `;

export const useGetSensitiveInfoAlertsQuery = <
      TData = GetSensitiveInfoAlertsQuery,
      TError = unknown
    >(
      variables: GetSensitiveInfoAlertsQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitiveInfoAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitiveInfoAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitiveInfoAlertsQuery, TError, TData>(
      {
    queryKey: ['GetSensitiveInfoAlerts', variables],
    queryFn: useMyQuery<GetSensitiveInfoAlertsQuery, GetSensitiveInfoAlertsQueryVariables>(GetSensitiveInfoAlertsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitiveInfoAlertsQuery.getKey = (variables: GetSensitiveInfoAlertsQueryVariables) => ['GetSensitiveInfoAlerts', variables];

export const useInfiniteGetSensitiveInfoAlertsQuery = <
      TData = InfiniteData<GetSensitiveInfoAlertsQuery>,
      TError = unknown
    >(
      variables: GetSensitiveInfoAlertsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitiveInfoAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitiveInfoAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitiveInfoAlertsQuery, GetSensitiveInfoAlertsQueryVariables>(GetSensitiveInfoAlertsDocument)
    return useInfiniteQuery<GetSensitiveInfoAlertsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetSensitiveInfoAlerts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitiveInfoAlertsQuery.getKey = (variables: GetSensitiveInfoAlertsQueryVariables) => ['GetSensitiveInfoAlerts.infinite', variables];

export const GetSensitiveInfoAppsDocument = `
    query GetSensitiveInfoApps($drawerDataId: ID!, $limit: Int, $offset: Int, $sensitiveInfoAppListSearch: String, $drawerSort: GetAppsSortEnum) {
  getSensitiveInfoApps(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $sensitiveInfoAppListSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      connected
      users
      externalUsers
      firstAdminUser
      filesAccess
      usersAccess
      emailsAccess
      logoUrl
      sensitivity
      files
    }
  }
}
    `;

export const useGetSensitiveInfoAppsQuery = <
      TData = GetSensitiveInfoAppsQuery,
      TError = unknown
    >(
      variables: GetSensitiveInfoAppsQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitiveInfoAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitiveInfoAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitiveInfoAppsQuery, TError, TData>(
      {
    queryKey: ['GetSensitiveInfoApps', variables],
    queryFn: useMyQuery<GetSensitiveInfoAppsQuery, GetSensitiveInfoAppsQueryVariables>(GetSensitiveInfoAppsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitiveInfoAppsQuery.getKey = (variables: GetSensitiveInfoAppsQueryVariables) => ['GetSensitiveInfoApps', variables];

export const useInfiniteGetSensitiveInfoAppsQuery = <
      TData = InfiniteData<GetSensitiveInfoAppsQuery>,
      TError = unknown
    >(
      variables: GetSensitiveInfoAppsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitiveInfoAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitiveInfoAppsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitiveInfoAppsQuery, GetSensitiveInfoAppsQueryVariables>(GetSensitiveInfoAppsDocument)
    return useInfiniteQuery<GetSensitiveInfoAppsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetSensitiveInfoApps.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitiveInfoAppsQuery.getKey = (variables: GetSensitiveInfoAppsQueryVariables) => ['GetSensitiveInfoApps.infinite', variables];

export const GetSensitiveInfoFilesDocument = `
    query getSensitiveInfoFiles($drawerDataId: ID!, $limit: Int, $offset: Int, $usersSearch: String, $drawerSort: GetSensitiveInfoDrawerSortEnum) {
  getSensitiveInfoFiles(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $usersSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      usersWithAccess
      sharedExternally
      sharedWithAnyone
      sharedWithOrganization
      path
      detectedByPurview
      detectedBy1Security
      webUrl
    }
  }
}
    `;

export const useGetSensitiveInfoFilesQuery = <
      TData = GetSensitiveInfoFilesQuery,
      TError = unknown
    >(
      variables: GetSensitiveInfoFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitiveInfoFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitiveInfoFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitiveInfoFilesQuery, TError, TData>(
      {
    queryKey: ['getSensitiveInfoFiles', variables],
    queryFn: useMyQuery<GetSensitiveInfoFilesQuery, GetSensitiveInfoFilesQueryVariables>(GetSensitiveInfoFilesDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitiveInfoFilesQuery.getKey = (variables: GetSensitiveInfoFilesQueryVariables) => ['getSensitiveInfoFiles', variables];

export const useInfiniteGetSensitiveInfoFilesQuery = <
      TData = InfiniteData<GetSensitiveInfoFilesQuery>,
      TError = unknown
    >(
      variables: GetSensitiveInfoFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitiveInfoFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitiveInfoFilesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitiveInfoFilesQuery, GetSensitiveInfoFilesQueryVariables>(GetSensitiveInfoFilesDocument)
    return useInfiniteQuery<GetSensitiveInfoFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSensitiveInfoFiles.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitiveInfoFilesQuery.getKey = (variables: GetSensitiveInfoFilesQueryVariables) => ['getSensitiveInfoFiles.infinite', variables];

export const GetSensitiveInfoGroupsDocument = `
    query getSensitiveInfoGroups($drawerDataId: ID!, $limit: Int, $offset: Int, $sensitiveInfoGroupListSearch: String, $drawerSort: GetGroupsSortType) {
  getSensitiveInfoGroups(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $sensitiveInfoGroupListSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      createdAt
      type
      members
      nestedMembers
      nestedExternalUsers
      containedGroups
      totalUsers
      totalExternalUsers
      isMemberOfGroups
      accessibleFiles
      accessibleSites
      filesWithSensitivityLabels
      sensitivityLabels
    }
  }
}
    `;

export const useGetSensitiveInfoGroupsQuery = <
      TData = GetSensitiveInfoGroupsQuery,
      TError = unknown
    >(
      variables: GetSensitiveInfoGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitiveInfoGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitiveInfoGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitiveInfoGroupsQuery, TError, TData>(
      {
    queryKey: ['getSensitiveInfoGroups', variables],
    queryFn: useMyQuery<GetSensitiveInfoGroupsQuery, GetSensitiveInfoGroupsQueryVariables>(GetSensitiveInfoGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitiveInfoGroupsQuery.getKey = (variables: GetSensitiveInfoGroupsQueryVariables) => ['getSensitiveInfoGroups', variables];

export const useInfiniteGetSensitiveInfoGroupsQuery = <
      TData = InfiniteData<GetSensitiveInfoGroupsQuery>,
      TError = unknown
    >(
      variables: GetSensitiveInfoGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitiveInfoGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitiveInfoGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitiveInfoGroupsQuery, GetSensitiveInfoGroupsQueryVariables>(GetSensitiveInfoGroupsDocument)
    return useInfiniteQuery<GetSensitiveInfoGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSensitiveInfoGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitiveInfoGroupsQuery.getKey = (variables: GetSensitiveInfoGroupsQueryVariables) => ['getSensitiveInfoGroups.infinite', variables];

export const GetSensitiveInfoSitesDocument = `
    query GetSensitiveInfoSites($drawerDataId: ID!, $limit: Int, $offset: Int, $sensitiveInfoSiteListSearch: String, $drawerSort: GetSitesSortEnum) {
  getSensitiveInfoSites(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $sensitiveInfoSiteListSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      lastActivity
      isHubSite
      subsites
      files
      privacy
      activity
      groupsWithAccess
      usersWithAccess
      externalUsersWithAccess
      pages
      drives
      lists
      notebooks
      modifiedAt
      createdAt
      type
      filesSize
      owners
      directUsersWithAccess
      indirectUsersWithAccess
      filesWithSensitivityLabels
      sensitivityLabels
      sensitiveInfo
    }
  }
}
    `;

export const useGetSensitiveInfoSitesQuery = <
      TData = GetSensitiveInfoSitesQuery,
      TError = unknown
    >(
      variables: GetSensitiveInfoSitesQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitiveInfoSitesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitiveInfoSitesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitiveInfoSitesQuery, TError, TData>(
      {
    queryKey: ['GetSensitiveInfoSites', variables],
    queryFn: useMyQuery<GetSensitiveInfoSitesQuery, GetSensitiveInfoSitesQueryVariables>(GetSensitiveInfoSitesDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitiveInfoSitesQuery.getKey = (variables: GetSensitiveInfoSitesQueryVariables) => ['GetSensitiveInfoSites', variables];

export const useInfiniteGetSensitiveInfoSitesQuery = <
      TData = InfiniteData<GetSensitiveInfoSitesQuery>,
      TError = unknown
    >(
      variables: GetSensitiveInfoSitesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitiveInfoSitesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitiveInfoSitesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitiveInfoSitesQuery, GetSensitiveInfoSitesQueryVariables>(GetSensitiveInfoSitesDocument)
    return useInfiniteQuery<GetSensitiveInfoSitesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetSensitiveInfoSites.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitiveInfoSitesQuery.getKey = (variables: GetSensitiveInfoSitesQueryVariables) => ['GetSensitiveInfoSites.infinite', variables];

export const GetSensitiveInfoUsersDocument = `
    query GetSensitiveInfoUsers($drawerDataId: ID!, $limit: Int, $offset: Int, $sensitiveInfoUserListSearch: String, $drawerSort: GetAppUsersSortEnum) {
  getSensitiveInfoUsers(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $sensitiveInfoUserListSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      userName
      avatar
      emailDomain
      isExternal
      signInDisabledAt
      azureRegisteredAt
      canAdminConsent
      connectedApps
      accessibleFiles
      totalGroupMemberships
      licenses
      lastSignIn
      hasMfa
    }
  }
}
    `;

export const useGetSensitiveInfoUsersQuery = <
      TData = GetSensitiveInfoUsersQuery,
      TError = unknown
    >(
      variables: GetSensitiveInfoUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitiveInfoUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitiveInfoUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitiveInfoUsersQuery, TError, TData>(
      {
    queryKey: ['GetSensitiveInfoUsers', variables],
    queryFn: useMyQuery<GetSensitiveInfoUsersQuery, GetSensitiveInfoUsersQueryVariables>(GetSensitiveInfoUsersDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitiveInfoUsersQuery.getKey = (variables: GetSensitiveInfoUsersQueryVariables) => ['GetSensitiveInfoUsers', variables];

export const useInfiniteGetSensitiveInfoUsersQuery = <
      TData = InfiniteData<GetSensitiveInfoUsersQuery>,
      TError = unknown
    >(
      variables: GetSensitiveInfoUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitiveInfoUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitiveInfoUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitiveInfoUsersQuery, GetSensitiveInfoUsersQueryVariables>(GetSensitiveInfoUsersDocument)
    return useInfiniteQuery<GetSensitiveInfoUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetSensitiveInfoUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitiveInfoUsersQuery.getKey = (variables: GetSensitiveInfoUsersQueryVariables) => ['GetSensitiveInfoUsers.infinite', variables];

export const GetSensitivityLabelDocument = `
    query getSensitivityLabel($drawerDataId: ID!) {
  getSensitivityLabel(drawerDataId: $drawerDataId) {
    id
    name
    color
    contentFormats
    description
    hasProtection
    isActive
    isAppliable
    priority
    tooltip
    sites
    groups
    files
    users
    apps
  }
}
    `;

export const useGetSensitivityLabelQuery = <
      TData = GetSensitivityLabelQuery,
      TError = unknown
    >(
      variables: GetSensitivityLabelQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitivityLabelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitivityLabelQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitivityLabelQuery, TError, TData>(
      {
    queryKey: ['getSensitivityLabel', variables],
    queryFn: useMyQuery<GetSensitivityLabelQuery, GetSensitivityLabelQueryVariables>(GetSensitivityLabelDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitivityLabelQuery.getKey = (variables: GetSensitivityLabelQueryVariables) => ['getSensitivityLabel', variables];

export const useInfiniteGetSensitivityLabelQuery = <
      TData = InfiniteData<GetSensitivityLabelQuery>,
      TError = unknown
    >(
      variables: GetSensitivityLabelQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitivityLabelQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitivityLabelQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitivityLabelQuery, GetSensitivityLabelQueryVariables>(GetSensitivityLabelDocument)
    return useInfiniteQuery<GetSensitivityLabelQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSensitivityLabel.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitivityLabelQuery.getKey = (variables: GetSensitivityLabelQueryVariables) => ['getSensitivityLabel.infinite', variables];

export const GetSensitivityLabelAlertsDocument = `
    query getSensitivityLabelAlerts($drawerDataId: ID!, $limit: Int, $offset: Int, $sensitiveLabelGroupListSearch: String, $sensitivityLabelName: String, $drawerSort: GetResourceAlertsSortEnum) {
  getSensitivityLabelAlerts(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $sensitiveLabelGroupListSearch
    sensitivityLabelName: $sensitivityLabelName
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      status
      severity
      detectedAt
      resolvedAt
    }
  }
}
    `;

export const useGetSensitivityLabelAlertsQuery = <
      TData = GetSensitivityLabelAlertsQuery,
      TError = unknown
    >(
      variables: GetSensitivityLabelAlertsQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitivityLabelAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitivityLabelAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitivityLabelAlertsQuery, TError, TData>(
      {
    queryKey: ['getSensitivityLabelAlerts', variables],
    queryFn: useMyQuery<GetSensitivityLabelAlertsQuery, GetSensitivityLabelAlertsQueryVariables>(GetSensitivityLabelAlertsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitivityLabelAlertsQuery.getKey = (variables: GetSensitivityLabelAlertsQueryVariables) => ['getSensitivityLabelAlerts', variables];

export const useInfiniteGetSensitivityLabelAlertsQuery = <
      TData = InfiniteData<GetSensitivityLabelAlertsQuery>,
      TError = unknown
    >(
      variables: GetSensitivityLabelAlertsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitivityLabelAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitivityLabelAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitivityLabelAlertsQuery, GetSensitivityLabelAlertsQueryVariables>(GetSensitivityLabelAlertsDocument)
    return useInfiniteQuery<GetSensitivityLabelAlertsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSensitivityLabelAlerts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitivityLabelAlertsQuery.getKey = (variables: GetSensitivityLabelAlertsQueryVariables) => ['getSensitivityLabelAlerts.infinite', variables];

export const GetSensitivityLabelFilesDocument = `
    query getSensitivityLabelFiles($drawerDataId: ID!, $limit: Int, $offset: Int, $usersSearch: String, $sensitivityLabelName: String, $drawerSort: GetSensitivityLabelFilesSortEnum) {
  getSensitivityLabelFiles(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $usersSearch
    sensitivityLabelName: $sensitivityLabelName
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      sensitivity
      size
      files
      lastModified
      createdDate
      webUrl
      createdBy
      modifiedBy
      type
      usersWithAccess
      sharedExternally
      sharedWithAnyone
      sharedWithOrganization
      path
    }
  }
}
    `;

export const useGetSensitivityLabelFilesQuery = <
      TData = GetSensitivityLabelFilesQuery,
      TError = unknown
    >(
      variables: GetSensitivityLabelFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitivityLabelFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitivityLabelFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitivityLabelFilesQuery, TError, TData>(
      {
    queryKey: ['getSensitivityLabelFiles', variables],
    queryFn: useMyQuery<GetSensitivityLabelFilesQuery, GetSensitivityLabelFilesQueryVariables>(GetSensitivityLabelFilesDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitivityLabelFilesQuery.getKey = (variables: GetSensitivityLabelFilesQueryVariables) => ['getSensitivityLabelFiles', variables];

export const useInfiniteGetSensitivityLabelFilesQuery = <
      TData = InfiniteData<GetSensitivityLabelFilesQuery>,
      TError = unknown
    >(
      variables: GetSensitivityLabelFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitivityLabelFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitivityLabelFilesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitivityLabelFilesQuery, GetSensitivityLabelFilesQueryVariables>(GetSensitivityLabelFilesDocument)
    return useInfiniteQuery<GetSensitivityLabelFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSensitivityLabelFiles.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitivityLabelFilesQuery.getKey = (variables: GetSensitivityLabelFilesQueryVariables) => ['getSensitivityLabelFiles.infinite', variables];

export const GetSensitivityLabelGroupsDocument = `
    query getSensitivityLabelGroups($drawerDataId: ID!, $limit: Int, $offset: Int, $sensitiveLabelGroupListSearch: String, $sensitivityLabelName: String, $drawerSort: GetGroupsSortType) {
  getSensitivityLabelGroups(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $sensitiveLabelGroupListSearch
    sensitivityLabelName: $sensitivityLabelName
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      createdAt
      type
      members
      nestedMembers
      nestedExternalUsers
      containedGroups
      totalUsers
      totalExternalUsers
      isMemberOfGroups
      accessibleFiles
      accessibleSites
      filesWithSensitivityLabels
      sensitivityLabels
    }
  }
}
    `;

export const useGetSensitivityLabelGroupsQuery = <
      TData = GetSensitivityLabelGroupsQuery,
      TError = unknown
    >(
      variables: GetSensitivityLabelGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitivityLabelGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitivityLabelGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitivityLabelGroupsQuery, TError, TData>(
      {
    queryKey: ['getSensitivityLabelGroups', variables],
    queryFn: useMyQuery<GetSensitivityLabelGroupsQuery, GetSensitivityLabelGroupsQueryVariables>(GetSensitivityLabelGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitivityLabelGroupsQuery.getKey = (variables: GetSensitivityLabelGroupsQueryVariables) => ['getSensitivityLabelGroups', variables];

export const useInfiniteGetSensitivityLabelGroupsQuery = <
      TData = InfiniteData<GetSensitivityLabelGroupsQuery>,
      TError = unknown
    >(
      variables: GetSensitivityLabelGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitivityLabelGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitivityLabelGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitivityLabelGroupsQuery, GetSensitivityLabelGroupsQueryVariables>(GetSensitivityLabelGroupsDocument)
    return useInfiniteQuery<GetSensitivityLabelGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSensitivityLabelGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitivityLabelGroupsQuery.getKey = (variables: GetSensitivityLabelGroupsQueryVariables) => ['getSensitivityLabelGroups.infinite', variables];

export const GetSensitivityLabelsDocument = `
    query getSensitivityLabels($limit: Int, $offset: Int, $search: String, $sort: GetSensitivityLabelsSortEnum, $drawerDataId: ID) {
  getSensitivityLabels(
    limit: $limit
    offset: $offset
    text: $search
    sort: $sort
    policyId: $drawerDataId
  ) {
    hasNextPage
    nodes {
      id
      name
      color
      contentFormats
      description
      hasProtection
      isActive
      isAppliable
      priority
      tooltip
      sites
      groups
      files
      users
      apps
    }
    itemsFound
  }
}
    `;

export const useGetSensitivityLabelsQuery = <
      TData = GetSensitivityLabelsQuery,
      TError = unknown
    >(
      variables?: GetSensitivityLabelsQueryVariables,
      options?: Omit<UseQueryOptions<GetSensitivityLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSensitivityLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSensitivityLabelsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSensitivityLabels'] : ['getSensitivityLabels', variables],
    queryFn: useMyQuery<GetSensitivityLabelsQuery, GetSensitivityLabelsQueryVariables>(GetSensitivityLabelsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSensitivityLabelsQuery.getKey = (variables?: GetSensitivityLabelsQueryVariables) => variables === undefined ? ['getSensitivityLabels'] : ['getSensitivityLabels', variables];

export const useInfiniteGetSensitivityLabelsQuery = <
      TData = InfiniteData<GetSensitivityLabelsQuery>,
      TError = unknown
    >(
      variables: GetSensitivityLabelsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSensitivityLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSensitivityLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSensitivityLabelsQuery, GetSensitivityLabelsQueryVariables>(GetSensitivityLabelsDocument)
    return useInfiniteQuery<GetSensitivityLabelsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getSensitivityLabels.infinite'] : ['getSensitivityLabels.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSensitivityLabelsQuery.getKey = (variables?: GetSensitivityLabelsQueryVariables) => variables === undefined ? ['getSensitivityLabels.infinite'] : ['getSensitivityLabels.infinite', variables];

export const GetSiteDocument = `
    query getSite($drawerDataId: ID) {
  getSite(drawerDataId: $drawerDataId) {
    id
    name
    type
    usersWithAccess
    groupsWithAccess
    files
    sensitiveInfo
    webUrl
    teamsChannelsStandard
    teamsChannelsPrivate
    teamsChannelsShared
    isTeamsSite
    isChannelSite
    channelType
    help
  }
}
    `;

export const useGetSiteQuery = <
      TData = GetSiteQuery,
      TError = unknown
    >(
      variables?: GetSiteQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSite'] : ['getSite', variables],
    queryFn: useMyQuery<GetSiteQuery, GetSiteQueryVariables>(GetSiteDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteQuery.getKey = (variables?: GetSiteQueryVariables) => variables === undefined ? ['getSite'] : ['getSite', variables];

export const useInfiniteGetSiteQuery = <
      TData = InfiniteData<GetSiteQuery>,
      TError = unknown
    >(
      variables: GetSiteQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteQuery, GetSiteQueryVariables>(GetSiteDocument)
    return useInfiniteQuery<GetSiteQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getSite.infinite'] : ['getSite.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteQuery.getKey = (variables?: GetSiteQueryVariables) => variables === undefined ? ['getSite.infinite'] : ['getSite.infinite', variables];

export const GetSiteAlertsDocument = `
    query getSiteAlerts($drawerDataId: ID!, $limit: Int, $offset: Int, $siteGroupsCompactSearch: String, $drawerSort: GetResourceAlertsSortEnum) {
  getSiteAlerts(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $siteGroupsCompactSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      status
      severity
      detectedAt
      resolvedAt
    }
  }
}
    `;

export const useGetSiteAlertsQuery = <
      TData = GetSiteAlertsQuery,
      TError = unknown
    >(
      variables: GetSiteAlertsQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteAlertsQuery, TError, TData>(
      {
    queryKey: ['getSiteAlerts', variables],
    queryFn: useMyQuery<GetSiteAlertsQuery, GetSiteAlertsQueryVariables>(GetSiteAlertsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteAlertsQuery.getKey = (variables: GetSiteAlertsQueryVariables) => ['getSiteAlerts', variables];

export const useInfiniteGetSiteAlertsQuery = <
      TData = InfiniteData<GetSiteAlertsQuery>,
      TError = unknown
    >(
      variables: GetSiteAlertsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteAlertsQuery, GetSiteAlertsQueryVariables>(GetSiteAlertsDocument)
    return useInfiniteQuery<GetSiteAlertsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSiteAlerts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteAlertsQuery.getKey = (variables: GetSiteAlertsQueryVariables) => ['getSiteAlerts.infinite', variables];

export const GetSiteFilesDocument = `
    query GetSiteFiles($drawerDataId: ID!, $limit: Int, $offset: Int, $siteFilesCompactSearch: String, $drawerSort: GetSiteFilesSortEnum) {
  getSiteFiles(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $siteFilesCompactSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      size
      files
      webUrl
      sourceType
      sharedExternally
      sharedWithAnyone
      usersWithAccess
      usersWithEditAccess
      groupsWithAccess
      createdBy
      createdAt
      modifiedBy
      modifiedAt
      fileSensitivityLabels
      sensitiveInfo
    }
  }
}
    `;

export const useGetSiteFilesQuery = <
      TData = GetSiteFilesQuery,
      TError = unknown
    >(
      variables: GetSiteFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteFilesQuery, TError, TData>(
      {
    queryKey: ['GetSiteFiles', variables],
    queryFn: useMyQuery<GetSiteFilesQuery, GetSiteFilesQueryVariables>(GetSiteFilesDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteFilesQuery.getKey = (variables: GetSiteFilesQueryVariables) => ['GetSiteFiles', variables];

export const useInfiniteGetSiteFilesQuery = <
      TData = InfiniteData<GetSiteFilesQuery>,
      TError = unknown
    >(
      variables: GetSiteFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteFilesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteFilesQuery, GetSiteFilesQueryVariables>(GetSiteFilesDocument)
    return useInfiniteQuery<GetSiteFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['GetSiteFiles.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteFilesQuery.getKey = (variables: GetSiteFilesQueryVariables) => ['GetSiteFiles.infinite', variables];

export const GetSiteFilterCountsDocument = `
    query getSiteFilterCounts {
  getSiteFilterCounts {
    all
    site
    subsite
    hubsite
    accessAll
    internalUsers
    externalUsers
    createdLast1Day
    createdLast7Days
    createdLast30Days
    createdLast90Days
    createdLast1Year
    modifiedLast1Day
    modifiedLast7Days
    modifiedLast30Days
    modifiedLast90Days
    modifiedLast1Year
    noActivityLastYear
    noDirectUsers
    noUsers
    noOwners
    blockedSites
    noBlockedSites
    fullyScannedSites
    noFullyScannedSites
    showPersonalSites
  }
}
    `;

export const useGetSiteFilterCountsQuery = <
      TData = GetSiteFilterCountsQuery,
      TError = unknown
    >(
      variables?: GetSiteFilterCountsQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteFilterCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSiteFilterCounts'] : ['getSiteFilterCounts', variables],
    queryFn: useMyQuery<GetSiteFilterCountsQuery, GetSiteFilterCountsQueryVariables>(GetSiteFilterCountsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteFilterCountsQuery.getKey = (variables?: GetSiteFilterCountsQueryVariables) => variables === undefined ? ['getSiteFilterCounts'] : ['getSiteFilterCounts', variables];

export const useInfiniteGetSiteFilterCountsQuery = <
      TData = InfiniteData<GetSiteFilterCountsQuery>,
      TError = unknown
    >(
      variables: GetSiteFilterCountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteFilterCountsQuery, GetSiteFilterCountsQueryVariables>(GetSiteFilterCountsDocument)
    return useInfiniteQuery<GetSiteFilterCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getSiteFilterCounts.infinite'] : ['getSiteFilterCounts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteFilterCountsQuery.getKey = (variables?: GetSiteFilterCountsQueryVariables) => variables === undefined ? ['getSiteFilterCounts.infinite'] : ['getSiteFilterCounts.infinite', variables];

export const GetSiteGroupsDocument = `
    query getSiteGroups($drawerDataId: ID!, $limit: Int, $offset: Int, $siteGroupsCompactSearch: String, $drawerSort: GetSiteGroupsSortEnum, $drawerFilterTypes: [GroupType!]) {
  getSiteGroups(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $siteGroupsCompactSearch
    sort: $drawerSort
    type: $drawerFilterTypes
  ) {
    hasNextPage
    nodes {
      id
      name
      type
      highestSitePermission
      indirectInternalUsers
      indirectExternalUsers
      totalIndirectUsers
      directInternalUsers
      directExternalUsers
      totalDirectUsers
      totalUsers
      accessThrough
      groupSensitivityLabels
    }
  }
}
    `;

export const useGetSiteGroupsQuery = <
      TData = GetSiteGroupsQuery,
      TError = unknown
    >(
      variables: GetSiteGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteGroupsQuery, TError, TData>(
      {
    queryKey: ['getSiteGroups', variables],
    queryFn: useMyQuery<GetSiteGroupsQuery, GetSiteGroupsQueryVariables>(GetSiteGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteGroupsQuery.getKey = (variables: GetSiteGroupsQueryVariables) => ['getSiteGroups', variables];

export const useInfiniteGetSiteGroupsQuery = <
      TData = InfiniteData<GetSiteGroupsQuery>,
      TError = unknown
    >(
      variables: GetSiteGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteGroupsQuery, GetSiteGroupsQueryVariables>(GetSiteGroupsDocument)
    return useInfiniteQuery<GetSiteGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSiteGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteGroupsQuery.getKey = (variables: GetSiteGroupsQueryVariables) => ['getSiteGroups.infinite', variables];

export const GetSiteGroupsGraphDocument = `
    query getSiteGroupsGraph($drawerDataId: ID!) {
  getSiteGroupsGraph(drawerDataId: $drawerDataId) {
    nodes {
      id
      name
      type
      page
      resource
      drawerDataId
      icon
      color
      users
      files
      groups
      filters {
        permissions
        type
      }
    }
    edges {
      from
      to
    }
    legend {
      name
      color
      icon
      type
    }
  }
}
    `;

export const useGetSiteGroupsGraphQuery = <
      TData = GetSiteGroupsGraphQuery,
      TError = unknown
    >(
      variables: GetSiteGroupsGraphQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteGroupsGraphQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteGroupsGraphQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteGroupsGraphQuery, TError, TData>(
      {
    queryKey: ['getSiteGroupsGraph', variables],
    queryFn: useMyQuery<GetSiteGroupsGraphQuery, GetSiteGroupsGraphQueryVariables>(GetSiteGroupsGraphDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteGroupsGraphQuery.getKey = (variables: GetSiteGroupsGraphQueryVariables) => ['getSiteGroupsGraph', variables];

export const useInfiniteGetSiteGroupsGraphQuery = <
      TData = InfiniteData<GetSiteGroupsGraphQuery>,
      TError = unknown
    >(
      variables: GetSiteGroupsGraphQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteGroupsGraphQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteGroupsGraphQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteGroupsGraphQuery, GetSiteGroupsGraphQueryVariables>(GetSiteGroupsGraphDocument)
    return useInfiniteQuery<GetSiteGroupsGraphQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSiteGroupsGraph.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteGroupsGraphQuery.getKey = (variables: GetSiteGroupsGraphQueryVariables) => ['getSiteGroupsGraph.infinite', variables];

export const GetSiteLabelsDocument = `
    query getSiteLabels($drawerDataId: ID!, $groupLabelsListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerLabelsSortEnum) {
  getSiteLabels(
    drawerDataId: $drawerDataId
    text: $groupLabelsListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      description
      color
      contentFormats
      hasProtection
      isActive
      isAppliable
      sensitivity
      tooltip
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetSiteLabelsQuery = <
      TData = GetSiteLabelsQuery,
      TError = unknown
    >(
      variables: GetSiteLabelsQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteLabelsQuery, TError, TData>(
      {
    queryKey: ['getSiteLabels', variables],
    queryFn: useMyQuery<GetSiteLabelsQuery, GetSiteLabelsQueryVariables>(GetSiteLabelsDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteLabelsQuery.getKey = (variables: GetSiteLabelsQueryVariables) => ['getSiteLabels', variables];

export const useInfiniteGetSiteLabelsQuery = <
      TData = InfiniteData<GetSiteLabelsQuery>,
      TError = unknown
    >(
      variables: GetSiteLabelsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteLabelsQuery, GetSiteLabelsQueryVariables>(GetSiteLabelsDocument)
    return useInfiniteQuery<GetSiteLabelsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSiteLabels.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteLabelsQuery.getKey = (variables: GetSiteLabelsQueryVariables) => ['getSiteLabels.infinite', variables];

export const GetSiteSensitiveInfoDocument = `
    query getSiteSensitiveInfo($drawerDataId: ID!, $siteSensitiveInfoListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerSensitiveInfoSortEnum) {
  getSiteSensitiveInfo(
    drawerDataId: $drawerDataId
    text: $siteSensitiveInfoListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetSiteSensitiveInfoQuery = <
      TData = GetSiteSensitiveInfoQuery,
      TError = unknown
    >(
      variables: GetSiteSensitiveInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteSensitiveInfoQuery, TError, TData>(
      {
    queryKey: ['getSiteSensitiveInfo', variables],
    queryFn: useMyQuery<GetSiteSensitiveInfoQuery, GetSiteSensitiveInfoQueryVariables>(GetSiteSensitiveInfoDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteSensitiveInfoQuery.getKey = (variables: GetSiteSensitiveInfoQueryVariables) => ['getSiteSensitiveInfo', variables];

export const useInfiniteGetSiteSensitiveInfoQuery = <
      TData = InfiniteData<GetSiteSensitiveInfoQuery>,
      TError = unknown
    >(
      variables: GetSiteSensitiveInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteSensitiveInfoQuery, GetSiteSensitiveInfoQueryVariables>(GetSiteSensitiveInfoDocument)
    return useInfiniteQuery<GetSiteSensitiveInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSiteSensitiveInfo.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteSensitiveInfoQuery.getKey = (variables: GetSiteSensitiveInfoQueryVariables) => ['getSiteSensitiveInfo.infinite', variables];

export const GetSiteUsersDocument = `
    query getSiteUsers($drawerDataId: ID!, $limit: Int, $offset: Int, $siteAccessSearch: String, $drawerSort: GetSiteUsersSortEnum, $drawerFilterTypes: [String]) {
  getSiteUsers(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $siteAccessSearch
    sort: $drawerSort
    permissions: $drawerFilterTypes
  ) {
    hasNextPage
    nodes {
      id
      name
      emailDomain
      permissions {
        level
        levelName
        score
        accessThrough {
          type
          name
          id
        }
      }
    }
  }
}
    `;

export const useGetSiteUsersQuery = <
      TData = GetSiteUsersQuery,
      TError = unknown
    >(
      variables: GetSiteUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetSiteUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSiteUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSiteUsersQuery, TError, TData>(
      {
    queryKey: ['getSiteUsers', variables],
    queryFn: useMyQuery<GetSiteUsersQuery, GetSiteUsersQueryVariables>(GetSiteUsersDocument).bind(null, variables),
    ...options
  }
    )};

useGetSiteUsersQuery.getKey = (variables: GetSiteUsersQueryVariables) => ['getSiteUsers', variables];

export const useInfiniteGetSiteUsersQuery = <
      TData = InfiniteData<GetSiteUsersQuery>,
      TError = unknown
    >(
      variables: GetSiteUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSiteUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSiteUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSiteUsersQuery, GetSiteUsersQueryVariables>(GetSiteUsersDocument)
    return useInfiniteQuery<GetSiteUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getSiteUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSiteUsersQuery.getKey = (variables: GetSiteUsersQueryVariables) => ['getSiteUsers.infinite', variables];

export const GetSitesDocument = `
    query getSites($limit: Int, $offset: Int, $sort: GetSitesSortEnum, $type: [GetSitesTypeEnum], $search: String, $user: UserType, $orphanedIndicators: [OrphanedIndicatorsEnum], $personalSites: [PersonalSitesEnum], $fullyScannedSites: [FullyScannedSitesEnum], $blockedSites: [BlockedSitesEnum], $time: DateTimeFilterInput, $createdAt: DateRange, $modifiedAt: DateRange, $lastActivityAt: DateRange, $privacy: [GetSitesPrivacyEnum], $activity: [GetSitesActivityEnum], $access: [GetSitesAccessEnum], $drawerDataId: ID) {
  getSites(
    limit: $limit
    offset: $offset
    sort: $sort
    type: $type
    text: $search
    user: $user
    orphanedIndicators: $orphanedIndicators
    personalSites: $personalSites
    fullyScannedSites: $fullyScannedSites
    blockedSites: $blockedSites
    time: $time
    createdAt: $createdAt
    modifiedAt: $modifiedAt
    lastActivityAt: $lastActivityAt
    privacy: $privacy
    activity: $activity
    access: $access
    policyId: $drawerDataId
  ) {
    itemsFound
    hasNextPage
    nodes {
      id
      name
      lastActivity
      isHubSite
      subsites
      files
      privacy
      activity
      groupsWithAccess
      usersWithAccess
      externalUsersWithAccess
      pages
      drives
      lists
      notebooks
      modifiedAt
      createdAt
      type
      filesSize
      owners
      directUsersWithAccess
      indirectUsersWithAccess
      filesWithSensitivityLabels
      sensitivityLabels
      sensitiveInfo
      isFullyScanned
      isBlocked
      webUrl
      teamsChannels
      webUrl
    }
  }
}
    `;

export const useGetSitesQuery = <
      TData = GetSitesQuery,
      TError = unknown
    >(
      variables?: GetSitesQueryVariables,
      options?: Omit<UseQueryOptions<GetSitesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetSitesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetSitesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getSites'] : ['getSites', variables],
    queryFn: useMyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument).bind(null, variables),
    ...options
  }
    )};

useGetSitesQuery.getKey = (variables?: GetSitesQueryVariables) => variables === undefined ? ['getSites'] : ['getSites', variables];

export const useInfiniteGetSitesQuery = <
      TData = InfiniteData<GetSitesQuery>,
      TError = unknown
    >(
      variables: GetSitesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetSitesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetSitesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetSitesQuery, GetSitesQueryVariables>(GetSitesDocument)
    return useInfiniteQuery<GetSitesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getSites.infinite'] : ['getSites.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetSitesQuery.getKey = (variables?: GetSitesQueryVariables) => variables === undefined ? ['getSites.infinite'] : ['getSites.infinite', variables];

export const GetTenantListDocument = `
    query getTenantList($limit: Int, $offset: Int, $text: String, $sort: TenantSortEnum) {
  getTenantList(limit: $limit, offset: $offset, text: $text, sort: $sort) {
    itemsFound
    hasNextPage
    nodes {
      id
      name
      domain
      emailDomain
      scanStatus
      lastScannedAt
      filesStatus
      groupsStatus
      sitesStatus
      usersStatus
      fileCount
      siteCount
      groupCount
      appCount
      userCount
      accessToTenantGranted
      hasValidLicense
      isDemo
    }
  }
}
    `;

export const useGetTenantListQuery = <
      TData = GetTenantListQuery,
      TError = unknown
    >(
      variables?: GetTenantListQueryVariables,
      options?: Omit<UseQueryOptions<GetTenantListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTenantListQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTenantListQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getTenantList'] : ['getTenantList', variables],
    queryFn: useMyQuery<GetTenantListQuery, GetTenantListQueryVariables>(GetTenantListDocument).bind(null, variables),
    ...options
  }
    )};

useGetTenantListQuery.getKey = (variables?: GetTenantListQueryVariables) => variables === undefined ? ['getTenantList'] : ['getTenantList', variables];

export const useInfiniteGetTenantListQuery = <
      TData = InfiniteData<GetTenantListQuery>,
      TError = unknown
    >(
      variables: GetTenantListQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetTenantListQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetTenantListQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetTenantListQuery, GetTenantListQueryVariables>(GetTenantListDocument)
    return useInfiniteQuery<GetTenantListQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getTenantList.infinite'] : ['getTenantList.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetTenantListQuery.getKey = (variables?: GetTenantListQueryVariables) => variables === undefined ? ['getTenantList.infinite'] : ['getTenantList.infinite', variables];

export const GetTenantSensitiveInfoRefreshStatusDocument = `
    query GetTenantSensitiveInfoRefreshStatus {
  getTenantSensitiveInfoRefreshStatus
}
    `;

export const useGetTenantSensitiveInfoRefreshStatusQuery = <
      TData = GetTenantSensitiveInfoRefreshStatusQuery,
      TError = unknown
    >(
      variables?: GetTenantSensitiveInfoRefreshStatusQueryVariables,
      options?: Omit<UseQueryOptions<GetTenantSensitiveInfoRefreshStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetTenantSensitiveInfoRefreshStatusQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetTenantSensitiveInfoRefreshStatusQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetTenantSensitiveInfoRefreshStatus'] : ['GetTenantSensitiveInfoRefreshStatus', variables],
    queryFn: useMyQuery<GetTenantSensitiveInfoRefreshStatusQuery, GetTenantSensitiveInfoRefreshStatusQueryVariables>(GetTenantSensitiveInfoRefreshStatusDocument).bind(null, variables),
    ...options
  }
    )};

useGetTenantSensitiveInfoRefreshStatusQuery.getKey = (variables?: GetTenantSensitiveInfoRefreshStatusQueryVariables) => variables === undefined ? ['GetTenantSensitiveInfoRefreshStatus'] : ['GetTenantSensitiveInfoRefreshStatus', variables];

export const useInfiniteGetTenantSensitiveInfoRefreshStatusQuery = <
      TData = InfiniteData<GetTenantSensitiveInfoRefreshStatusQuery>,
      TError = unknown
    >(
      variables: GetTenantSensitiveInfoRefreshStatusQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetTenantSensitiveInfoRefreshStatusQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetTenantSensitiveInfoRefreshStatusQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetTenantSensitiveInfoRefreshStatusQuery, GetTenantSensitiveInfoRefreshStatusQueryVariables>(GetTenantSensitiveInfoRefreshStatusDocument)
    return useInfiniteQuery<GetTenantSensitiveInfoRefreshStatusQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['GetTenantSensitiveInfoRefreshStatus.infinite'] : ['GetTenantSensitiveInfoRefreshStatus.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetTenantSensitiveInfoRefreshStatusQuery.getKey = (variables?: GetTenantSensitiveInfoRefreshStatusQueryVariables) => variables === undefined ? ['GetTenantSensitiveInfoRefreshStatus.infinite'] : ['GetTenantSensitiveInfoRefreshStatus.infinite', variables];

export const GetUserDocument = `
    query getUser($drawerDataId: ID!) {
  getUser(drawerDataId: $drawerDataId) {
    id
    userName
    email
    isExternal
    avatar
    emailDomain
    licenses
    hasMfa
    lastSignIn
    signInDisabledAt
    accessibleFiles
    totalGroupMemberships
    connectedApps
    sites
    sensitiveInfo
  }
}
    `;

export const useGetUserQuery = <
      TData = GetUserQuery,
      TError = unknown
    >(
      variables: GetUserQueryVariables,
      options?: Omit<UseQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserQuery, TError, TData>(
      {
    queryKey: ['getUser', variables],
    queryFn: useMyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserQuery.getKey = (variables: GetUserQueryVariables) => ['getUser', variables];

export const useInfiniteGetUserQuery = <
      TData = InfiniteData<GetUserQuery>,
      TError = unknown
    >(
      variables: GetUserQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument)
    return useInfiniteQuery<GetUserQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUser.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserQuery.getKey = (variables: GetUserQueryVariables) => ['getUser.infinite', variables];

export const GetUserAlertsDocument = `
    query getUserAlerts($drawerDataId: ID!, $limit: Int, $offset: Int, $userAppsSearch: String, $drawerSort: GetResourceAlertsSortEnum) {
  getUserAlerts(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $userAppsSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      status
      severity
      detectedAt
      resolvedAt
    }
  }
}
    `;

export const useGetUserAlertsQuery = <
      TData = GetUserAlertsQuery,
      TError = unknown
    >(
      variables: GetUserAlertsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserAlertsQuery, TError, TData>(
      {
    queryKey: ['getUserAlerts', variables],
    queryFn: useMyQuery<GetUserAlertsQuery, GetUserAlertsQueryVariables>(GetUserAlertsDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserAlertsQuery.getKey = (variables: GetUserAlertsQueryVariables) => ['getUserAlerts', variables];

export const useInfiniteGetUserAlertsQuery = <
      TData = InfiniteData<GetUserAlertsQuery>,
      TError = unknown
    >(
      variables: GetUserAlertsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserAlertsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserAlertsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserAlertsQuery, GetUserAlertsQueryVariables>(GetUserAlertsDocument)
    return useInfiniteQuery<GetUserAlertsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserAlerts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserAlertsQuery.getKey = (variables: GetUserAlertsQueryVariables) => ['getUserAlerts.infinite', variables];

export const GetUserAppsDocument = `
    query getUserApps($drawerDataId: ID!, $limit: Int, $offset: Int, $userAppsSearch: String, $drawerSort: UserAppsSortEnum) {
  getUserApps(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $userAppsSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      connected
      users
      externalUsers
      firstAdminUser
      filesAccess
      usersAccess
      emailsAccess
      logoUrl
      sensitivity
      accessFrom
      files
    }
  }
}
    `;

export const useGetUserAppsQuery = <
      TData = GetUserAppsQuery,
      TError = unknown
    >(
      variables: GetUserAppsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserAppsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserAppsQuery, TError, TData>(
      {
    queryKey: ['getUserApps', variables],
    queryFn: useMyQuery<GetUserAppsQuery, GetUserAppsQueryVariables>(GetUserAppsDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserAppsQuery.getKey = (variables: GetUserAppsQueryVariables) => ['getUserApps', variables];

export const useInfiniteGetUserAppsQuery = <
      TData = InfiniteData<GetUserAppsQuery>,
      TError = unknown
    >(
      variables: GetUserAppsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserAppsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserAppsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserAppsQuery, GetUserAppsQueryVariables>(GetUserAppsDocument)
    return useInfiniteQuery<GetUserAppsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserApps.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserAppsQuery.getKey = (variables: GetUserAppsQueryVariables) => ['getUserApps.infinite', variables];

export const GetUserFilesDocument = `
    query getUserFiles($drawerDataId: ID!, $limit: Int, $offset: Int, $userFilesCompactSearch: String, $drawerSort: GetUserFilesSortEnum) {
  getUserFiles(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $userFilesCompactSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      permissions {
        permission
        accessThrough {
          type
        }
      }
      fileSensitivityLabels
    }
  }
}
    `;

export const useGetUserFilesQuery = <
      TData = GetUserFilesQuery,
      TError = unknown
    >(
      variables: GetUserFilesQueryVariables,
      options?: Omit<UseQueryOptions<GetUserFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserFilesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserFilesQuery, TError, TData>(
      {
    queryKey: ['getUserFiles', variables],
    queryFn: useMyQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserFilesQuery.getKey = (variables: GetUserFilesQueryVariables) => ['getUserFiles', variables];

export const useInfiniteGetUserFilesQuery = <
      TData = InfiniteData<GetUserFilesQuery>,
      TError = unknown
    >(
      variables: GetUserFilesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserFilesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserFilesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument)
    return useInfiniteQuery<GetUserFilesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserFiles.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserFilesQuery.getKey = (variables: GetUserFilesQueryVariables) => ['getUserFiles.infinite', variables];

export const GetUserFilterCountsDocument = `
    query getUserFilterCounts {
  getUserFilterCounts {
    all
    externalUsers
    internalUsers
    noLicense
    withLicense
    createdLast1Day
    createdLast7Days
    createdLast30Days
    createdLast90Days
    createdLast1Year
    lastSignIn1Day
    lastSignIn7Days
    lastSignIn30Days
    lastSignIn90Days
    lastSignIn1Year
  }
}
    `;

export const useGetUserFilterCountsQuery = <
      TData = GetUserFilterCountsQuery,
      TError = unknown
    >(
      variables?: GetUserFilterCountsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserFilterCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getUserFilterCounts'] : ['getUserFilterCounts', variables],
    queryFn: useMyQuery<GetUserFilterCountsQuery, GetUserFilterCountsQueryVariables>(GetUserFilterCountsDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserFilterCountsQuery.getKey = (variables?: GetUserFilterCountsQueryVariables) => variables === undefined ? ['getUserFilterCounts'] : ['getUserFilterCounts', variables];

export const useInfiniteGetUserFilterCountsQuery = <
      TData = InfiniteData<GetUserFilterCountsQuery>,
      TError = unknown
    >(
      variables: GetUserFilterCountsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserFilterCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserFilterCountsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserFilterCountsQuery, GetUserFilterCountsQueryVariables>(GetUserFilterCountsDocument)
    return useInfiniteQuery<GetUserFilterCountsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getUserFilterCounts.infinite'] : ['getUserFilterCounts.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserFilterCountsQuery.getKey = (variables?: GetUserFilterCountsQueryVariables) => variables === undefined ? ['getUserFilterCounts.infinite'] : ['getUserFilterCounts.infinite', variables];

export const GetUserGroupsDocument = `
    query getUserGroups($drawerDataId: ID!, $limit: Int, $offset: Int, $userGroupsCompactSearch: String, $drawerSort: GetUserGroupsSortEnum, $drawerFilterTypes: [GroupType!]) {
  getUserGroups(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $userGroupsCompactSearch
    sort: $drawerSort
    type: $drawerFilterTypes
  ) {
    hasNextPage
    nodes {
      type
      id
      name
      indirectInternalUsers
      indirectExternalUsers
      totalIndirectUsers
      directExternalUsers
      directExternalUsers
      totalDirectUsers
      totalUsers
      accessThrough
      directInternalUsers
      groupSensitivityLabels
    }
  }
}
    `;

export const useGetUserGroupsQuery = <
      TData = GetUserGroupsQuery,
      TError = unknown
    >(
      variables: GetUserGroupsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserGroupsQuery, TError, TData>(
      {
    queryKey: ['getUserGroups', variables],
    queryFn: useMyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserGroupsQuery.getKey = (variables: GetUserGroupsQueryVariables) => ['getUserGroups', variables];

export const useInfiniteGetUserGroupsQuery = <
      TData = InfiniteData<GetUserGroupsQuery>,
      TError = unknown
    >(
      variables: GetUserGroupsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserGroupsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserGroupsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserGroupsQuery, GetUserGroupsQueryVariables>(GetUserGroupsDocument)
    return useInfiniteQuery<GetUserGroupsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserGroups.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserGroupsQuery.getKey = (variables: GetUserGroupsQueryVariables) => ['getUserGroups.infinite', variables];

export const GetUserGroupsGraphDocument = `
    query getUserGroupsGraph($drawerDataId: ID!) {
  getUserGroupsGraph(drawerDataId: $drawerDataId) {
    nodes {
      id
      name
      type
      page
      resource
      drawerDataId
      icon
      color
      users
      files
      groups
      filters {
        permissions
        type
      }
    }
    edges {
      from
      to
    }
    legend {
      name
      color
      icon
      type
    }
  }
}
    `;

export const useGetUserGroupsGraphQuery = <
      TData = GetUserGroupsGraphQuery,
      TError = unknown
    >(
      variables: GetUserGroupsGraphQueryVariables,
      options?: Omit<UseQueryOptions<GetUserGroupsGraphQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserGroupsGraphQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserGroupsGraphQuery, TError, TData>(
      {
    queryKey: ['getUserGroupsGraph', variables],
    queryFn: useMyQuery<GetUserGroupsGraphQuery, GetUserGroupsGraphQueryVariables>(GetUserGroupsGraphDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserGroupsGraphQuery.getKey = (variables: GetUserGroupsGraphQueryVariables) => ['getUserGroupsGraph', variables];

export const useInfiniteGetUserGroupsGraphQuery = <
      TData = InfiniteData<GetUserGroupsGraphQuery>,
      TError = unknown
    >(
      variables: GetUserGroupsGraphQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserGroupsGraphQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserGroupsGraphQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserGroupsGraphQuery, GetUserGroupsGraphQueryVariables>(GetUserGroupsGraphDocument)
    return useInfiniteQuery<GetUserGroupsGraphQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserGroupsGraph.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserGroupsGraphQuery.getKey = (variables: GetUserGroupsGraphQueryVariables) => ['getUserGroupsGraph.infinite', variables];

export const GetUserLabelsDocument = `
    query getUserLabels($drawerDataId: ID!, $userLabelsListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerLabelsSortEnum) {
  getUserLabels(
    drawerDataId: $drawerDataId
    text: $userLabelsListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      description
      color
      contentFormats
      hasProtection
      isActive
      isAppliable
      sensitivity
      tooltip
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetUserLabelsQuery = <
      TData = GetUserLabelsQuery,
      TError = unknown
    >(
      variables: GetUserLabelsQueryVariables,
      options?: Omit<UseQueryOptions<GetUserLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserLabelsQuery, TError, TData>(
      {
    queryKey: ['getUserLabels', variables],
    queryFn: useMyQuery<GetUserLabelsQuery, GetUserLabelsQueryVariables>(GetUserLabelsDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserLabelsQuery.getKey = (variables: GetUserLabelsQueryVariables) => ['getUserLabels', variables];

export const useInfiniteGetUserLabelsQuery = <
      TData = InfiniteData<GetUserLabelsQuery>,
      TError = unknown
    >(
      variables: GetUserLabelsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserLabelsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserLabelsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserLabelsQuery, GetUserLabelsQueryVariables>(GetUserLabelsDocument)
    return useInfiniteQuery<GetUserLabelsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserLabels.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserLabelsQuery.getKey = (variables: GetUserLabelsQueryVariables) => ['getUserLabels.infinite', variables];

export const GetUserSensitiveInfoDocument = `
    query getUserSensitiveInfo($drawerDataId: ID!, $userSensitiveInfoListSearch: String, $limit: Int, $offset: Int, $drawerSort: GetDrawerSensitiveInfoSortEnum) {
  getUserSensitiveInfo(
    drawerDataId: $drawerDataId
    text: $userSensitiveInfoListSearch
    limit: $limit
    offset: $offset
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      sites
      groups
      files
      users
      apps
    }
  }
}
    `;

export const useGetUserSensitiveInfoQuery = <
      TData = GetUserSensitiveInfoQuery,
      TError = unknown
    >(
      variables: GetUserSensitiveInfoQueryVariables,
      options?: Omit<UseQueryOptions<GetUserSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserSensitiveInfoQuery, TError, TData>(
      {
    queryKey: ['getUserSensitiveInfo', variables],
    queryFn: useMyQuery<GetUserSensitiveInfoQuery, GetUserSensitiveInfoQueryVariables>(GetUserSensitiveInfoDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserSensitiveInfoQuery.getKey = (variables: GetUserSensitiveInfoQueryVariables) => ['getUserSensitiveInfo', variables];

export const useInfiniteGetUserSensitiveInfoQuery = <
      TData = InfiniteData<GetUserSensitiveInfoQuery>,
      TError = unknown
    >(
      variables: GetUserSensitiveInfoQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserSensitiveInfoQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserSensitiveInfoQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserSensitiveInfoQuery, GetUserSensitiveInfoQueryVariables>(GetUserSensitiveInfoDocument)
    return useInfiniteQuery<GetUserSensitiveInfoQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserSensitiveInfo.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserSensitiveInfoQuery.getKey = (variables: GetUserSensitiveInfoQueryVariables) => ['getUserSensitiveInfo.infinite', variables];

export const GetUserSitesDocument = `
    query getUserSites($drawerDataId: ID!, $limit: Int, $offset: Int, $groupSitesCompactSearch: String, $drawerSort: GetUserSitesSortEnum) {
  getUserSites(
    drawerDataId: $drawerDataId
    limit: $limit
    offset: $offset
    text: $groupSitesCompactSearch
    sort: $drawerSort
  ) {
    hasNextPage
    nodes {
      id
      name
      permissions {
        levelName
        accessThrough {
          type
        }
      }
    }
  }
}
    `;

export const useGetUserSitesQuery = <
      TData = GetUserSitesQuery,
      TError = unknown
    >(
      variables: GetUserSitesQueryVariables,
      options?: Omit<UseQueryOptions<GetUserSitesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUserSitesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUserSitesQuery, TError, TData>(
      {
    queryKey: ['getUserSites', variables],
    queryFn: useMyQuery<GetUserSitesQuery, GetUserSitesQueryVariables>(GetUserSitesDocument).bind(null, variables),
    ...options
  }
    )};

useGetUserSitesQuery.getKey = (variables: GetUserSitesQueryVariables) => ['getUserSites', variables];

export const useInfiniteGetUserSitesQuery = <
      TData = InfiniteData<GetUserSitesQuery>,
      TError = unknown
    >(
      variables: GetUserSitesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUserSitesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUserSitesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUserSitesQuery, GetUserSitesQueryVariables>(GetUserSitesDocument)
    return useInfiniteQuery<GetUserSitesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['getUserSites.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUserSitesQuery.getKey = (variables: GetUserSitesQueryVariables) => ['getUserSites.infinite', variables];

export const GetUsersDocument = `
    query getUsers($limit: Int, $offset: Int, $search: String, $sort: GetUsersSortEnum, $type: [GetUsersTypeEnum], $isAppUser: Boolean, $licenses: [GetUsersLicensesEnum], $drawerDataId: ID) {
  getUsers(
    limit: $limit
    offset: $offset
    sort: $sort
    text: $search
    type: $type
    isAppUser: $isAppUser
    licenses: $licenses
    policyId: $drawerDataId
  ) {
    itemsFound
    hasNextPage
    nodes {
      id
      userName
      avatar
      emailDomain
      isExternal
      signInDisabledAt
      azureRegisteredAt
      canAdminConsent
      connectedApps
      accessibleFiles
      totalGroupMemberships
      licenses
      lastSignIn
      hasMfa
      hasSignedIn
      email
      isAdmin
      totalSensitivityScore
      filesWithSensitivityLabels
      sensitivityLabels
      sensitiveInfo
      filesWithSensitiveData
    }
  }
}
    `;

export const useGetUsersQuery = <
      TData = GetUsersQuery,
      TError = unknown
    >(
      variables?: GetUsersQueryVariables,
      options?: Omit<UseQueryOptions<GetUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetUsersQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetUsersQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['getUsers'] : ['getUsers', variables],
    queryFn: useMyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument).bind(null, variables),
    ...options
  }
    )};

useGetUsersQuery.getKey = (variables?: GetUsersQueryVariables) => variables === undefined ? ['getUsers'] : ['getUsers', variables];

export const useInfiniteGetUsersQuery = <
      TData = InfiniteData<GetUsersQuery>,
      TError = unknown
    >(
      variables: GetUsersQueryVariables,
      options: Omit<UseInfiniteQueryOptions<GetUsersQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<GetUsersQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument)
    return useInfiniteQuery<GetUsersQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['getUsers.infinite'] : ['getUsers.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteGetUsersQuery.getKey = (variables?: GetUsersQueryVariables) => variables === undefined ? ['getUsers.infinite'] : ['getUsers.infinite', variables];

export const InviteTo1SecurityDocument = `
    mutation inviteTo1Security($email: String!, $role: String) {
  inviteTo1Security(email: $email, role: $role) {
    success
    inviteCode
    message
  }
}
    `;

export const useInviteTo1SecurityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InviteTo1SecurityMutation, TError, InviteTo1SecurityMutationVariables, TContext>) => {
    
    return useMutation<InviteTo1SecurityMutation, TError, InviteTo1SecurityMutationVariables, TContext>(
      {
    mutationKey: ['inviteTo1Security'],
    mutationFn: useMyQuery<InviteTo1SecurityMutation, InviteTo1SecurityMutationVariables>(InviteTo1SecurityDocument),
    ...options
  }
    )};

export const LogoutDocument = `
    mutation logout($allDevices: Boolean!) {
  logout(allDevices: $allDevices)
}
    `;

export const useLogoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogoutMutation, TError, LogoutMutationVariables, TContext>) => {
    
    return useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
      {
    mutationKey: ['logout'],
    mutationFn: useMyQuery<LogoutMutation, LogoutMutationVariables>(LogoutDocument),
    ...options
  }
    )};

export const LogoutTenantDocument = `
    mutation logoutTenant($tenantId: String!) {
  logoutTenant(tenantId: $tenantId)
}
    `;

export const useLogoutTenantMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogoutTenantMutation, TError, LogoutTenantMutationVariables, TContext>) => {
    
    return useMutation<LogoutTenantMutation, TError, LogoutTenantMutationVariables, TContext>(
      {
    mutationKey: ['logoutTenant'],
    mutationFn: useMyQuery<LogoutTenantMutation, LogoutTenantMutationVariables>(LogoutTenantDocument),
    ...options
  }
    )};

export const RemoveAccountOrInvitationFromOrganizationDocument = `
    mutation RemoveAccountOrInvitationFromOrganization($accountId: String, $invitationId: String) {
  removeAccountOrInvitationFromOrganization(
    accountId: $accountId
    invitationId: $invitationId
  )
}
    `;

export const useRemoveAccountOrInvitationFromOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAccountOrInvitationFromOrganizationMutation, TError, RemoveAccountOrInvitationFromOrganizationMutationVariables, TContext>) => {
    
    return useMutation<RemoveAccountOrInvitationFromOrganizationMutation, TError, RemoveAccountOrInvitationFromOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['RemoveAccountOrInvitationFromOrganization'],
    mutationFn: useMyQuery<RemoveAccountOrInvitationFromOrganizationMutation, RemoveAccountOrInvitationFromOrganizationMutationVariables>(RemoveAccountOrInvitationFromOrganizationDocument),
    ...options
  }
    )};

export const RemoveTenantFrom1SecurityDocument = `
    mutation removeTenantFrom1Security($tenantId: String!) {
  removeTenantFrom1Security(tenantId: $tenantId)
}
    `;

export const useRemoveTenantFrom1SecurityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTenantFrom1SecurityMutation, TError, RemoveTenantFrom1SecurityMutationVariables, TContext>) => {
    
    return useMutation<RemoveTenantFrom1SecurityMutation, TError, RemoveTenantFrom1SecurityMutationVariables, TContext>(
      {
    mutationKey: ['removeTenantFrom1Security'],
    mutationFn: useMyQuery<RemoveTenantFrom1SecurityMutation, RemoveTenantFrom1SecurityMutationVariables>(RemoveTenantFrom1SecurityDocument),
    ...options
  }
    )};

export const RemoveTenantFromOrganizationDocument = `
    mutation RemoveTenantFromOrganization($tenantId: String!) {
  removeTenantFromOrganization(tenantId: $tenantId)
}
    `;

export const useRemoveTenantFromOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveTenantFromOrganizationMutation, TError, RemoveTenantFromOrganizationMutationVariables, TContext>) => {
    
    return useMutation<RemoveTenantFromOrganizationMutation, TError, RemoveTenantFromOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['RemoveTenantFromOrganization'],
    mutationFn: useMyQuery<RemoveTenantFromOrganizationMutation, RemoveTenantFromOrganizationMutationVariables>(RemoveTenantFromOrganizationDocument),
    ...options
  }
    )};

export const RemoveUserFromGroupDocument = `
    mutation removeUserFromGroup($userId: String!, $groupId: String!) {
  removeUserFromGroup(userId: $userId, groupId: $groupId)
}
    `;

export const useRemoveUserFromGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveUserFromGroupMutation, TError, RemoveUserFromGroupMutationVariables, TContext>) => {
    
    return useMutation<RemoveUserFromGroupMutation, TError, RemoveUserFromGroupMutationVariables, TContext>(
      {
    mutationKey: ['removeUserFromGroup'],
    mutationFn: useMyQuery<RemoveUserFromGroupMutation, RemoveUserFromGroupMutationVariables>(RemoveUserFromGroupDocument),
    ...options
  }
    )};

export const RequestRefreshTenantDocument = `
    mutation RequestRefreshTenant($tenantId: String!) {
  requestRefreshTenant(tenantId: $tenantId)
}
    `;

export const useRequestRefreshTenantMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequestRefreshTenantMutation, TError, RequestRefreshTenantMutationVariables, TContext>) => {
    
    return useMutation<RequestRefreshTenantMutation, TError, RequestRefreshTenantMutationVariables, TContext>(
      {
    mutationKey: ['RequestRefreshTenant'],
    mutationFn: useMyQuery<RequestRefreshTenantMutation, RequestRefreshTenantMutationVariables>(RequestRefreshTenantDocument),
    ...options
  }
    )};

export const SearchOrganizationsDocument = `
    query searchOrganizations($searchQuery: String) {
  searchOrganizations(searchQuery: $searchQuery) {
    id
    label
  }
}
    `;

export const useSearchOrganizationsQuery = <
      TData = SearchOrganizationsQuery,
      TError = unknown
    >(
      variables?: SearchOrganizationsQueryVariables,
      options?: Omit<UseQueryOptions<SearchOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchOrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchOrganizationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['searchOrganizations'] : ['searchOrganizations', variables],
    queryFn: useMyQuery<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>(SearchOrganizationsDocument).bind(null, variables),
    ...options
  }
    )};

useSearchOrganizationsQuery.getKey = (variables?: SearchOrganizationsQueryVariables) => variables === undefined ? ['searchOrganizations'] : ['searchOrganizations', variables];

export const useInfiniteSearchOrganizationsQuery = <
      TData = InfiniteData<SearchOrganizationsQuery>,
      TError = unknown
    >(
      variables: SearchOrganizationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchOrganizationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchOrganizationsQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<SearchOrganizationsQuery, SearchOrganizationsQueryVariables>(SearchOrganizationsDocument)
    return useInfiniteQuery<SearchOrganizationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['searchOrganizations.infinite'] : ['searchOrganizations.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchOrganizationsQuery.getKey = (variables?: SearchOrganizationsQueryVariables) => variables === undefined ? ['searchOrganizations.infinite'] : ['searchOrganizations.infinite', variables];

export const SearchResourcesDocument = `
    query SearchResources($resourceType: String!, $query: String!, $limit: Int) {
  searchResources(resourceType: $resourceType, query: $query, limit: $limit) {
    hasNextPage
    nodes {
      id
      name
      type
      displayName
    }
  }
}
    `;

export const useSearchResourcesQuery = <
      TData = SearchResourcesQuery,
      TError = unknown
    >(
      variables: SearchResourcesQueryVariables,
      options?: Omit<UseQueryOptions<SearchResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SearchResourcesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<SearchResourcesQuery, TError, TData>(
      {
    queryKey: ['SearchResources', variables],
    queryFn: useMyQuery<SearchResourcesQuery, SearchResourcesQueryVariables>(SearchResourcesDocument).bind(null, variables),
    ...options
  }
    )};

useSearchResourcesQuery.getKey = (variables: SearchResourcesQueryVariables) => ['SearchResources', variables];

export const useInfiniteSearchResourcesQuery = <
      TData = InfiniteData<SearchResourcesQuery>,
      TError = unknown
    >(
      variables: SearchResourcesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SearchResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SearchResourcesQuery, TError, TData>['queryKey'] }
    ) => {
    const query = useMyQuery<SearchResourcesQuery, SearchResourcesQueryVariables>(SearchResourcesDocument)
    return useInfiniteQuery<SearchResourcesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['SearchResources.infinite', variables],
      queryFn: (metaData) => query({...variables, ...(metaData.pageParam ?? {})}),
      ...restOptions
    }
  })()
    )};

useInfiniteSearchResourcesQuery.getKey = (variables: SearchResourcesQueryVariables) => ['SearchResources.infinite', variables];

export const SendEmailMessageTo1SecurityDocument = `
    mutation sendEmailMessageTo1Security($email: String, $message: String, $recaptchaToken: String!) {
  sendEmailMessageTo1Security(
    email: $email
    message: $message
    recaptchaToken: $recaptchaToken
  )
}
    `;

export const useSendEmailMessageTo1SecurityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendEmailMessageTo1SecurityMutation, TError, SendEmailMessageTo1SecurityMutationVariables, TContext>) => {
    
    return useMutation<SendEmailMessageTo1SecurityMutation, TError, SendEmailMessageTo1SecurityMutationVariables, TContext>(
      {
    mutationKey: ['sendEmailMessageTo1Security'],
    mutationFn: useMyQuery<SendEmailMessageTo1SecurityMutation, SendEmailMessageTo1SecurityMutationVariables>(SendEmailMessageTo1SecurityDocument),
    ...options
  }
    )};

export const SendWaitlistEmailDocument = `
    mutation sendWaitlistEmail($email: String!, $recaptchaToken: String!) {
  sendWaitlistEmail(email: $email, recaptchaToken: $recaptchaToken)
}
    `;

export const useSendWaitlistEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendWaitlistEmailMutation, TError, SendWaitlistEmailMutationVariables, TContext>) => {
    
    return useMutation<SendWaitlistEmailMutation, TError, SendWaitlistEmailMutationVariables, TContext>(
      {
    mutationKey: ['sendWaitlistEmail'],
    mutationFn: useMyQuery<SendWaitlistEmailMutation, SendWaitlistEmailMutationVariables>(SendWaitlistEmailDocument),
    ...options
  }
    )};

export const SendUpgradeRequestEmailDocument = `
    mutation sendUpgradeRequestEmail($email: String!) {
  sendUpgradeRequestEmail(email: $email)
}
    `;

export const useSendUpgradeRequestEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendUpgradeRequestEmailMutation, TError, SendUpgradeRequestEmailMutationVariables, TContext>) => {
    
    return useMutation<SendUpgradeRequestEmailMutation, TError, SendUpgradeRequestEmailMutationVariables, TContext>(
      {
    mutationKey: ['sendUpgradeRequestEmail'],
    mutationFn: useMyQuery<SendUpgradeRequestEmailMutation, SendUpgradeRequestEmailMutationVariables>(SendUpgradeRequestEmailDocument),
    ...options
  }
    )};

export const SetCurrentTenantDocument = `
    mutation setCurrentTenant($tenantId: String!) {
  setCurrentTenant(tenantId: $tenantId)
}
    `;

export const useSetCurrentTenantMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetCurrentTenantMutation, TError, SetCurrentTenantMutationVariables, TContext>) => {
    
    return useMutation<SetCurrentTenantMutation, TError, SetCurrentTenantMutationVariables, TContext>(
      {
    mutationKey: ['setCurrentTenant'],
    mutationFn: useMyQuery<SetCurrentTenantMutation, SetCurrentTenantMutationVariables>(SetCurrentTenantDocument),
    ...options
  }
    )};

export const SetDisplayFindingDocument = `
    mutation SetDisplayFinding($findingId: ID, $hide: Boolean!, $taskId: ID) {
  setDisplayFinding(findingId: $findingId, hide: $hide, taskId: $taskId)
}
    `;

export const useSetDisplayFindingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetDisplayFindingMutation, TError, SetDisplayFindingMutationVariables, TContext>) => {
    
    return useMutation<SetDisplayFindingMutation, TError, SetDisplayFindingMutationVariables, TContext>(
      {
    mutationKey: ['SetDisplayFinding'],
    mutationFn: useMyQuery<SetDisplayFindingMutation, SetDisplayFindingMutationVariables>(SetDisplayFindingDocument),
    ...options
  }
    )};

export const SetViewAsDocument = `
    mutation SetViewAs($viewingAs: String, $isAdminMode: Boolean) {
  setViewAs(viewingAs: $viewingAs, isAdminMode: $isAdminMode)
}
    `;

export const useSetViewAsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetViewAsMutation, TError, SetViewAsMutationVariables, TContext>) => {
    
    return useMutation<SetViewAsMutation, TError, SetViewAsMutationVariables, TContext>(
      {
    mutationKey: ['SetViewAs'],
    mutationFn: useMyQuery<SetViewAsMutation, SetViewAsMutationVariables>(SetViewAsDocument),
    ...options
  }
    )};

export const SignInDocument = `
    mutation signIn($token: String, $provider: String, $email: String, $referralCode: String, $inviteCode: String) {
  signIn(
    email: $email
    token: $token
    provider: $provider
    referralCode: $referralCode
    inviteCode: $inviteCode
  ) {
    access_token
    refresh_token
  }
}
    `;

export const useSignInMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SignInMutation, TError, SignInMutationVariables, TContext>) => {
    
    return useMutation<SignInMutation, TError, SignInMutationVariables, TContext>(
      {
    mutationKey: ['signIn'],
    mutationFn: useMyQuery<SignInMutation, SignInMutationVariables>(SignInDocument),
    ...options
  }
    )};

export const SwitchOrganizationDocument = `
    mutation SwitchOrganization($organizationId: String!) {
  switchOrganization(organizationId: $organizationId)
}
    `;

export const useSwitchOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SwitchOrganizationMutation, TError, SwitchOrganizationMutationVariables, TContext>) => {
    
    return useMutation<SwitchOrganizationMutation, TError, SwitchOrganizationMutationVariables, TContext>(
      {
    mutationKey: ['SwitchOrganization'],
    mutationFn: useMyQuery<SwitchOrganizationMutation, SwitchOrganizationMutationVariables>(SwitchOrganizationDocument),
    ...options
  }
    )};

export const UnassignLicensesDocument = `
    mutation unassignLicenses {
  unassignLicenses
}
    `;

export const useUnassignLicensesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnassignLicensesMutation, TError, UnassignLicensesMutationVariables, TContext>) => {
    
    return useMutation<UnassignLicensesMutation, TError, UnassignLicensesMutationVariables, TContext>(
      {
    mutationKey: ['unassignLicenses'],
    mutationFn: useMyQuery<UnassignLicensesMutation, UnassignLicensesMutationVariables>(UnassignLicensesDocument),
    ...options
  }
    )};

export const UpdateTaskDocument = `
    mutation UpdateTask($taskId: ID!, $taskStatus: String, $assignedTo: String) {
  updateTask(taskId: $taskId, taskStatus: $taskStatus, assignedTo: $assignedTo) {
    id
    findingId
    name
    severity
    affectedItemName
    affectedItemId
    resourceType
    taskStatus
    assignedToId
    assignedById
    assignedTo
    assignedBy
    createdAt
    tags
    description
  }
}
    `;

export const useUpdateTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTaskMutation, TError, UpdateTaskMutationVariables, TContext>) => {
    
    return useMutation<UpdateTaskMutation, TError, UpdateTaskMutationVariables, TContext>(
      {
    mutationKey: ['UpdateTask'],
    mutationFn: useMyQuery<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument),
    ...options
  }
    )};

export const VerifyEmailDocument = `
    mutation verifyEmail($token: String, $provider: String, $email: String, $emailVerificationCode: String) {
  verifyEmail(
    email: $email
    token: $token
    provider: $provider
    emailVerificationCode: $emailVerificationCode
  ) {
    access_token
    refresh_token
  }
}
    `;

export const useVerifyEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<VerifyEmailMutation, TError, VerifyEmailMutationVariables, TContext>) => {
    
    return useMutation<VerifyEmailMutation, TError, VerifyEmailMutationVariables, TContext>(
      {
    mutationKey: ['verifyEmail'],
    mutationFn: useMyQuery<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument),
    ...options
  }
    )};
